
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global = globalThis;
    var parcelRequire = $parcel$global["parcelRequired477"];
var parcelRegister = parcelRequire.register;
parcelRegister("6g38M", function(module, exports) {
/**
 * @generated SignedSource<<192c1135385a2bed1a8cfb9cda08da32>>
 * @relayHash c8147ea7d06264c113941f070cc9c557
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7bb20320983fb57f96674e457880159113245958ae698e240254febfcb07a08a
const $c2366b7346451a87$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageAri"
        }
    ], v1 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "pageAri"
                }
            ],
            "concreteType": "Page",
            "kind": "LinkedField",
            "name": "page",
            "plural": false,
            "selections": [
                {
                    "args": [
                        {
                            "kind": "Literal",
                            "name": "keys",
                            "value": [
                                "isAutomatedMeetingNotes",
                                "meetingRecurrenceAri"
                            ]
                        }
                    ],
                    "concreteType": "PaginatedJsonContentPropertyList",
                    "kind": "LinkedField",
                    "name": "properties",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "JsonContentProperty",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "value"
                                }
                            ]
                        }
                    ],
                    "storageKey": "properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"])"
                },
                {
                    "kind": "ScalarField",
                    "name": "subType"
                },
                {
                    "kind": "ScalarField",
                    "name": "id"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "getAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "getAutomatedMeetingNotesPagePropertiesQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "c8147ea7d06264c113941f070cc9c557",
            "id": "7bb20320983fb57f96674e457880159113245958ae698e240254febfcb07a08a",
            "metadata": {},
            "name": "getAutomatedMeetingNotesPagePropertiesQuery",
            "operationKind": "query",
            "text": "query getAutomatedMeetingNotesPagePropertiesQuery($pageAri:ID!){page(id:$pageAri){properties(keys:[\"isAutomatedMeetingNotes\",\"meetingRecurrenceAri\"]){nodes{key,value}},subType,id}}"
        }
    };
}();
$c2366b7346451a87$var$node.hash = "4187f33183c6b803fad92aa55dc76eee";
var $c2366b7346451a87$export$2e2bcd8739ae039 = $c2366b7346451a87$var$node;



var $6B1vK = parcelRequire("6B1vK");


var $ge2sX = parcelRequire("ge2sX");


var $iSXh4 = parcelRequire("iSXh4");


var $c0rhi = parcelRequire("c0rhi");

const $c7fe11d803ab2486$var$getAutomatedMeetingNotesPagePropertiesQuery = (0, $c2366b7346451a87$export$2e2bcd8739ae039);
const $c7fe11d803ab2486$export$803a631454411196 = async (pageId)=>{
    const { cloudId: cloudId } = await (0, $ge2sX.getSessionData)();
    const pageAri = (0, $6B1vK.ConfluencePageAri).create({
        siteId: cloudId,
        pageId: pageId
    }).toString();
    // There is no non-hook alternative for getApolloClient AFAIK
    const { data: data } = await (0, $c0rhi.queryInterop)({
        query: $c7fe11d803ab2486$var$getAutomatedMeetingNotesPagePropertiesQuery,
        variables: {
            pageAri: pageAri
        },
        errorPolicy: 'none',
        __callerPackage__: "automated-meeting-notes"
    });
    return (0, $iSXh4.extractAmnPageProperties)(data);
};
module.exports["getAutomatedMeetingNotesPageProperties"] = $c7fe11d803ab2486$export$803a631454411196;

});

parcelRegister("55DRn", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");

/**
 * @generated SignedSource<<dd3292c560b6f631db3781a58aef80a3>>
 * @relayHash 12bf64819ab2d36ef483ee5ce9a88bcd
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 4e36b48f3ac80d1bdaf2651dfef6e79d93108bbf1591800d929192d29cad0fe9
const $abcb93b73f298879$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "spaceKey"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "targetSpaceKey",
                            "variableName": "spaceKey"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageTopLevel",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "Map_LinkType_String",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMovePageHandlerMovePageTopLevelMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMovePageHandlerMovePageTopLevelMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "12bf64819ab2d36ef483ee5ce9a88bcd",
            "id": "4e36b48f3ac80d1bdaf2651dfef6e79d93108bbf1591800d929192d29cad0fe9",
            "metadata": {},
            "name": "useMovePageHandlerMovePageTopLevelMutation",
            "operationKind": "mutation",
            "text": "mutation useMovePageHandlerMovePageTopLevelMutation($pageId:ID!,$spaceKey:String!){movePageTopLevel(input:{pageId:$pageId,targetSpaceKey:$spaceKey}){page{id,links{webui,editui}}}}"
        }
    };
}();
$abcb93b73f298879$var$node.hash = "0bbc6a612473c98695dd3973cd86fb2e";
var $abcb93b73f298879$export$2e2bcd8739ae039 = $abcb93b73f298879$var$node;


/**
 * @generated SignedSource<<1f2791f179cf7e30cf9e5a0945a0aadb>>
 * @relayHash 73d70478feb019b3126a56695522224e
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID fcb8f2b74d1f3407e9d560434e38dd34ba07c7239fa51e37b8fc40e8b08a8400
const $ce5feb6c0fc292c7$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "parentId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "parentId",
                            "variableName": "parentId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageAppend",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "Map_LinkType_String",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMovePageHandlerMovePageAppendMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMovePageHandlerMovePageAppendMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "73d70478feb019b3126a56695522224e",
            "id": "fcb8f2b74d1f3407e9d560434e38dd34ba07c7239fa51e37b8fc40e8b08a8400",
            "metadata": {},
            "name": "useMovePageHandlerMovePageAppendMutation",
            "operationKind": "mutation",
            "text": "mutation useMovePageHandlerMovePageAppendMutation($pageId:ID!,$parentId:ID!){movePageAppend(input:{pageId:$pageId,parentId:$parentId}){page{id,links{webui,editui}}}}"
        }
    };
}();
$ce5feb6c0fc292c7$var$node.hash = "438afe9b7f5abfdc270fb984ae9947ec";
var $ce5feb6c0fc292c7$export$2e2bcd8739ae039 = $ce5feb6c0fc292c7$var$node;


/**
 * @generated SignedSource<<9f85c08398d11135b9c5906da2fa1231>>
 * @relayHash e4fc157144ff80433929db438252274a
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID e6d8a439313151ac4be2392b04a56ad04abc753676cb8a365d2172b825c4f835
const $89aad801432cf2f9$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "siblingId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "siblingId",
                            "variableName": "siblingId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageBefore",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "Map_LinkType_String",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMovePageHandlerMovePageBeforeMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMovePageHandlerMovePageBeforeMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "e4fc157144ff80433929db438252274a",
            "id": "e6d8a439313151ac4be2392b04a56ad04abc753676cb8a365d2172b825c4f835",
            "metadata": {},
            "name": "useMovePageHandlerMovePageBeforeMutation",
            "operationKind": "mutation",
            "text": "mutation useMovePageHandlerMovePageBeforeMutation($pageId:ID!,$siblingId:ID!){movePageBefore(input:{pageId:$pageId,siblingId:$siblingId}){page{id,links{webui,editui}}}}"
        }
    };
}();
$89aad801432cf2f9$var$node.hash = "4c865d6cf9059b124024ddd239f00b20";
var $89aad801432cf2f9$export$2e2bcd8739ae039 = $89aad801432cf2f9$var$node;


/**
 * @generated SignedSource<<2fedbd79fd5a056f5cdc08dbdfe8717a>>
 * @relayHash f007e6a1a06e284145a6e359d559abc7
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 2285585fad428a22ba24da19e8d732ed06f7f166ce87970eb39db8bac4964e0e
const $96207dc70cedc05c$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "pageId"
        },
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "siblingId"
        }
    ], v1 = [
        {
            "args": [
                {
                    "fields": [
                        {
                            "kind": "Variable",
                            "name": "pageId",
                            "variableName": "pageId"
                        },
                        {
                            "kind": "Variable",
                            "name": "siblingId",
                            "variableName": "siblingId"
                        }
                    ],
                    "kind": "ObjectValue",
                    "name": "input"
                }
            ],
            "concreteType": "MovePagePayload",
            "kind": "LinkedField",
            "name": "movePageAfter",
            "plural": false,
            "selections": [
                {
                    "concreteType": "Page",
                    "kind": "LinkedField",
                    "name": "page",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "id"
                        },
                        {
                            "concreteType": "Map_LinkType_String",
                            "kind": "LinkedField",
                            "name": "links",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "webui"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "editui"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useMovePageHandlerMovePageAfterMutation",
            "selections": v1 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useMovePageHandlerMovePageAfterMutation",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "f007e6a1a06e284145a6e359d559abc7",
            "id": "2285585fad428a22ba24da19e8d732ed06f7f166ce87970eb39db8bac4964e0e",
            "metadata": {},
            "name": "useMovePageHandlerMovePageAfterMutation",
            "operationKind": "mutation",
            "text": "mutation useMovePageHandlerMovePageAfterMutation($pageId:ID!,$siblingId:ID!){movePageAfter(input:{pageId:$pageId,siblingId:$siblingId}){page{id,links{webui,editui}}}}"
        }
    };
}();
$96207dc70cedc05c$var$node.hash = "9d4a33e40b8e98aa3f260ac26bd6fa66";
var $96207dc70cedc05c$export$2e2bcd8739ae039 = $96207dc70cedc05c$var$node;



var $308Wd = parcelRequire("308Wd");

const $49c0c7f1efa9aabd$export$6dd12ebb9a442472 = ()=>{
    const $ = (0, $bDgLe.c)(7);
    const [movePageAfter] = (0, $308Wd.useMutationInterop)((0, $96207dc70cedc05c$export$2e2bcd8739ae039), {
        __callerPackage__: "page-tree"
    });
    const [movePageBefore] = (0, $308Wd.useMutationInterop)((0, $89aad801432cf2f9$export$2e2bcd8739ae039), {
        __callerPackage__: "page-tree"
    });
    const [movePageAppend] = (0, $308Wd.useMutationInterop)((0, $ce5feb6c0fc292c7$export$2e2bcd8739ae039), {
        __callerPackage__: "page-tree"
    });
    const [movePageTopLevel] = (0, $308Wd.useMutationInterop)((0, $abcb93b73f298879$export$2e2bcd8739ae039), {
        __callerPackage__: "page-tree"
    });
    let t0;
    if ($[0] !== movePageAfter || $[1] !== movePageAppend || $[2] !== movePageBefore || $[3] !== movePageTopLevel) {
        t0 = async (params)=>{
            const thenFn = $49c0c7f1efa9aabd$var$_temp;
            if ("parentId" in params) return movePageAppend({
                variables: {
                    pageId: params.pageId,
                    parentId: params.parentId
                }
            }).then(thenFn($49c0c7f1efa9aabd$var$_temp2));
            else {
                if ("spaceKey" in params) return movePageTopLevel({
                    variables: {
                        pageId: params.pageId,
                        spaceKey: params.spaceKey
                    }
                }).then(thenFn($49c0c7f1efa9aabd$var$_temp3));
                else {
                    if (params.positionToSibling === "after") return movePageAfter({
                        variables: {
                            pageId: params.pageId,
                            siblingId: params.siblingId
                        }
                    }).then(thenFn($49c0c7f1efa9aabd$var$_temp4));
                    else return movePageBefore({
                        variables: {
                            pageId: params.pageId,
                            siblingId: params.siblingId
                        }
                    }).then(thenFn($49c0c7f1efa9aabd$var$_temp5));
                }
            }
        };
        $[0] = movePageAfter;
        $[1] = movePageAppend;
        $[2] = movePageBefore;
        $[3] = movePageTopLevel;
        $[4] = t0;
    } else t0 = $[4];
    const movePage = t0;
    let t1;
    if ($[5] !== movePage) {
        t1 = {
            movePage: movePage
        };
        $[5] = movePage;
        $[6] = t1;
    } else t1 = $[6];
    return t1;
};
function $49c0c7f1efa9aabd$var$_temp(resultFormatter) {
    return (t0)=>{
        const { data: data, ...rest } = t0;
        return {
            ...rest,
            data: typeof data === "undefined" ? undefined : {
                mutationResult: resultFormatter(data)
            }
        };
    };
}
function $49c0c7f1efa9aabd$var$_temp2(data_0) {
    return data_0.movePageAppend;
}
function $49c0c7f1efa9aabd$var$_temp3(data_1) {
    return data_1.movePageTopLevel;
}
function $49c0c7f1efa9aabd$var$_temp4(data_2) {
    return data_2.movePageAfter;
}
function $49c0c7f1efa9aabd$var$_temp5(data_3) {
    return data_3.movePageBefore;
}
module.exports["useMovePageHandler"] = $49c0c7f1efa9aabd$export$6dd12ebb9a442472;

});

parcelRegister("88DkZ", function(module, exports) {
const $641409054108cb84$export$65f8db878a2225f1 = ({ source: source, contentStatus: contentStatus, pageId: pageId, previousParentPageId: previousParentPageId, newParentPageId: newParentPageId, previousSpaceId: previousSpaceId, newSpaceId: newSpaceId, referrer: referrer, isLivePage: isLivePage, isOnEditRoute: isOnEditRoute, instructionType: instructionType, isAmnPage: isAmnPage = false })=>({
        type: 'sendTrackEvent',
        data: {
            action: 'updated',
            source: source,
            containerType: 'space',
            containerId: previousSpaceId,
            objectType: 'page',
            objectId: pageId,
            actionSubject: 'page',
            attributes: {
                contentStatus: contentStatus ?? null,
                previousSpaceId: previousSpaceId,
                previousParentPageId: previousParentPageId,
                newSpaceId: newSpaceId,
                newParentPageId: newParentPageId,
                ...referrer ? {
                    referrer: referrer
                } : undefined,
                isLivePage: isLivePage,
                isOnEditRoute: isOnEditRoute,
                instructionType: instructionType,
                isAmnPage: isAmnPage
            }
        }
    });
const $641409054108cb84$export$2077471dee1c6ca0 = ()=>({
        type: 'sendUIEvent',
        data: {
            action: 'dragged',
            actionSubject: 'pageTree',
            source: 'viewPageScreen'
        }
    });
const $641409054108cb84$export$231aa440646a5d8b = (isValidTarget)=>({
        type: 'sendUIEvent',
        data: {
            action: 'dropped',
            actionSubject: 'pageTree',
            source: 'viewPageScreen',
            attributes: {
                isValidTarget: isValidTarget
            }
        }
    });
const $641409054108cb84$export$ab5b8960d8c25b71 = ()=>({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            actionSubject: 'button',
            actionSubjectId: 'pageTreeDragDropUndo',
            source: 'viewPageScreen'
        }
    });
const $641409054108cb84$export$c10d8b9fe448cd40 = ()=>({
        type: 'sendUIEvent',
        data: {
            action: 'pressed',
            actionSubject: 'keyboardShortcut',
            actionSubjectId: 'pageTreeDragDropUndo',
            source: 'viewPageScreen'
        }
    });
const $641409054108cb84$export$aa83874b4391f46b = (action, spaceId, isInDrawer, status, contentId, contentType, navdexPointType, isOnEditRoute, contentTreeSize, spaceKey, interactionSource)=>{
    const event = {
        type: 'sendUIEvent',
        data: {
            containerType: 'space',
            containerId: spaceId,
            objectType: contentType ?? 'page',
            objectId: contentId ?? '',
            action: action,
            actionSubject: 'pageTree',
            source: isInDrawer ? 'pageTreeDrawer' : 'containerNavigation',
            attributes: {
                navigationLayer: 'container',
                navigationContainer: 'sidebar',
                spaceView: 'TREE',
                contentStatus: status ?? null,
                isOnEditRoute: // status/contentStatus is used to distinguish published page vs draft when clicking on a page tree item
                isOnEditRoute,
                contentTreeSize: contentTreeSize,
                navVersion: '4',
                spaceKey: spaceKey,
                ...interactionSource && {
                    interactionSource: interactionSource
                }
            }
        }
    };
    if (navdexPointType) event.data.attributes['navdexPointType'] = navdexPointType;
    return event;
};
const $641409054108cb84$export$6606cf45794cc2de = (spaceId, pageCount, source, direction)=>({
        type: 'sendUIEvent',
        data: {
            action: 'clicked',
            containerId: spaceId,
            actionSubject: 'button',
            actionSubjectId: 'showAllButton',
            source: source || 'containerNavigation',
            attributes: {
                pageCount: pageCount,
                direction: direction
            }
        }
    });
const $641409054108cb84$export$dd155dee114de315 = (oneOnOnePagesCount, totalPagesCount, spaceId)=>({
        type: 'sendTrackEvent',
        data: {
            action: 'OneOnOneTitlesShown',
            actionSubject: 'pageTree',
            actionSubjectId: 'OneOnOneTitles',
            source: 'containerNavigation',
            containerType: 'space',
            containerId: spaceId,
            attributes: {
                oneOnOnePagesCount: oneOnOnePagesCount,
                totalPagesCount: totalPagesCount
            }
        }
    });
module.exports["dragDropEndTrackEvent"] = $641409054108cb84$export$65f8db878a2225f1;
module.exports["dragStartUIEvent"] = $641409054108cb84$export$2077471dee1c6ca0;
module.exports["dragEndUIEvent"] = $641409054108cb84$export$231aa440646a5d8b;
module.exports["undoClickUIEvent"] = $641409054108cb84$export$ab5b8960d8c25b71;
module.exports["undoShortcutUIEvent"] = $641409054108cb84$export$c10d8b9fe448cd40;
module.exports["pageTreeUIAnalytics"] = $641409054108cb84$export$aa83874b4391f46b;
module.exports["pageTreePaginationEvent"] = $641409054108cb84$export$6606cf45794cc2de;
module.exports["oneOnOnePagesDetectedEvent"] = $641409054108cb84$export$dd155dee114de315;

});

parcelRegister("6FfmH", function(module, exports) {

var $cozmU = parcelRequire("cozmU");


var $4aRua = parcelRequire("4aRua");


var $aMcHK = parcelRequire("aMcHK");


var $9wGTI = parcelRequire("9wGTI");


var $dquGP = parcelRequire("dquGP");

const $0deb5c3dbfed5cc8$var$isConflictingPageNameError = (errorMessage)=>{
    return (errorMessage.includes('A page with the name(s)') || errorMessage.includes('A content with the name(s)')) && errorMessage.includes('already exist(s) in the space');
};
const $0deb5c3dbfed5cc8$export$7112efaf1b52aaeb = (title)=>{
    const trailingCounterPattern = /\s\((\d+)\)$/;
    const match = title.match(trailingCounterPattern);
    if (match) {
        const nextCount = parseInt(match[1], 10) + 1;
        return title.replace(trailingCounterPattern, ` (${nextCount})`);
    }
    return `${title} (1)`;
};
const $0deb5c3dbfed5cc8$var$convertToCommaSeparatedString = (listOfPageNames)=>{
    if (listOfPageNames.length === 2) return listOfPageNames.join(' and ');
    else if (listOfPageNames.length > 2) return `${listOfPageNames.slice(0, listOfPageNames.length - 1).join(', ')}, and ${listOfPageNames[listOfPageNames.length - 1]}`;
    return listOfPageNames.join(', ');
};
const $0deb5c3dbfed5cc8$var$getErrorMessageForConflictingPageNamesError = (errorMessage, IsInEditor, onActionClick, isLivePage)=>{
    let firstPartOfMessage = 'A page with the name(s) ';
    const middlePartOfMessage = ' already exist(s) in the space ';
    let lastPartOfMessage = '. You must rename the page title before moving it.';
    if (errorMessage.indexOf(firstPartOfMessage) === -1) {
        firstPartOfMessage = 'A content with the name(s) ';
        lastPartOfMessage = '. You must rename the content title before moving it.';
    }
    const listOfConflictingNames = errorMessage.substring(errorMessage.indexOf(firstPartOfMessage) + firstPartOfMessage.length, errorMessage.indexOf(middlePartOfMessage)).split(',');
    const destinationSpace = errorMessage.substring(errorMessage.indexOf(middlePartOfMessage) + middlePartOfMessage.length, errorMessage.indexOf(lastPartOfMessage));
    if (listOfConflictingNames.length === 1) {
        const conflictingPageName = listOfConflictingNames[0];
        if (!IsInEditor) return {
            title: (0, $dquGP.i18n).singleConflictingTitleRenameErrorTitle,
            description: firstPartOfMessage === 'A page with the name(s) ' ? (0, $dquGP.i18n).singleConflictingTitleRenamePageErrorDescription : (0, $dquGP.i18n).singleConflictingTitleRenameContentErrorDescription,
            props: {
                values: {
                    conflictingPageName: conflictingPageName,
                    destinationSpace: destinationSpace,
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                            as: "strong"
                        }, chunks)
                }
            },
            isConflictingTitleError: true,
            renameTitleValue: $0deb5c3dbfed5cc8$export$7112efaf1b52aaeb(conflictingPageName)
        };
        const title = isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? (0, $dquGP.i18n).singleConflictingLivePageNameWithinEditorErrorTitle : (0, $dquGP.i18n).singleConflictingPageNameWithinEditorErrorTitle;
        let description;
        if (isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in')) description = (0, $dquGP.i18n).singleConflictingLiveDocNameWithinEditorErrorDescription;
        else if (isLivePage) description = (0, $dquGP.i18n).singleConflictingLivePageNameWithinEditorErrorDescription;
        else description = (0, $dquGP.i18n).singleConflictingPageNameWithinEditorErrorDescription;
        return {
            title: title,
            description: description,
            props: {
                values: {
                    conflictingPageName: conflictingPageName,
                    destinationSpace: destinationSpace,
                    strong: (chunks)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aRua.Text), {
                            as: "strong"
                        }, chunks)
                }
            },
            actions: [
                {
                    key: 'move-page-error-error-cta',
                    text: isLivePage && (0, $9wGTI.fg)('confluence_live_pages_open_beta_trait_opted_in') ? (0, $dquGP.i18n).singleConflictingLivePageNameWithinEditorErrorCallToAction : (0, $dquGP.i18n).singleConflictingPageNameWithinEditorErrorCallToAction,
                    onClick: onActionClick
                }
            ]
        };
    } else return {
        title: (0, $dquGP.i18n).multipleConflictingContentNamesErrorTitle,
        description: (0, $dquGP.i18n).multipleConflictingContentNamesErrorDescription,
        props: {
            values: {
                listOfConflictingNames: $0deb5c3dbfed5cc8$var$convertToCommaSeparatedString(listOfConflictingNames),
                destinationSpace: destinationSpace
            }
        }
    };
};
const $0deb5c3dbfed5cc8$var$isRestrictionsPermissionError = (errorMessage)=>{
    return errorMessage.includes('You can not restrict pages in the destination space.') || errorMessage.includes('You can not restrict contents in the destination space.');
};
const $0deb5c3dbfed5cc8$var$cannotMoveDraftError = (errorMessage)=>{
    return errorMessage.includes('You do not have permission to move this draft to another space.');
};
const $0deb5c3dbfed5cc8$var$cannotMoveDraftWithChildrenError = (errorMessage)=>{
    return errorMessage.includes('You cannot move a draft with children to another space without space admin permission.');
};
const $0deb5c3dbfed5cc8$var$isNotSpaceAdminForCrossSpaceMoveError = (errorMessage)=>{
    return errorMessage.includes('Only space admins can move content to another space.');
};
const $0deb5c3dbfed5cc8$var$lacksManageContentOperationError = (errorMessage)=>{
    return errorMessage.includes('Only users who can manage content can move content to another space.');
};
// isTargetSameasSource and isParentChildLoop are the same error, but the api either returns 400/500.
const $0deb5c3dbfed5cc8$var$isParentChildLoopError = (errorMessage)=>{
    return errorMessage.includes('creates a parent-child loop');
};
const $0deb5c3dbfed5cc8$var$isTargetSameAsSourceError = (errorMessage)=>{
    return errorMessage.includes('Can not set page as its own parent.');
};
const $0deb5c3dbfed5cc8$var$isDestinationNonexistantError = (errorMessage)=>{
    return errorMessage.includes('The target page provided does not exist.') || errorMessage.includes('The target content provided does not exist.') || (errorMessage.includes('The target page with ID = ') || errorMessage.includes('The target content with ID = ')) && errorMessage.includes('is archived');
};
const $0deb5c3dbfed5cc8$var$isSourceNonexistantError = (errorMessage)=>{
    return errorMessage.includes('The source page provided does not exist.') || errorMessage.includes('The source content provided does not exist.') || (errorMessage.includes('The source page with ID = ') || errorMessage.includes('The source content with ID =')) && errorMessage.includes('is archived');
};
const $0deb5c3dbfed5cc8$var$isCurrentlyUpdatedError = (errorMessage)=>errorMessage.includes('UnexpectedRollbackException');
const $0deb5c3dbfed5cc8$var$isMovingTooManyPagesError = (errorMessage)=>errorMessage.includes("We can't support moving this many pages at this time");
const $0deb5c3dbfed5cc8$var$isMovingMoreThan100PagesError = (errorMessage)=>errorMessage.includes("We can't support moving more than 100 pages at this time");
const $0deb5c3dbfed5cc8$var$isAttemptingToMoveContentToSelf = (errorMessage)=>errorMessage.includes('Invalid to perform any move operation where source is same as target');
const $0deb5c3dbfed5cc8$var$isPartiallyMovedError = (errorMessage)=>errorMessage.includes("Can't add a parent from another space");
const $0deb5c3dbfed5cc8$var$getI18nMessageForKnown400Error = (errorMessage, IsInEditor, onActionClick, isLivePage)=>{
    if ($0deb5c3dbfed5cc8$var$isConflictingPageNameError(errorMessage)) return $0deb5c3dbfed5cc8$var$getErrorMessageForConflictingPageNamesError(errorMessage, IsInEditor, onActionClick, isLivePage);
    else if ($0deb5c3dbfed5cc8$var$isAttemptingToMoveContentToSelf(errorMessage)) return {
        title: (0, $dquGP.i18n).movingContentToSelfErrorTitle,
        description: (0, $dquGP.i18n).movingContentToSelfErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$isParentChildLoopError(errorMessage)) return {
        title: (0, $dquGP.i18n).parentChildLoopErrorTitle,
        description: (0, $dquGP.i18n).parentChildLoopErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$isRestrictionsPermissionError(errorMessage)) return {
        title: (0, $dquGP.i18n).restrictionsPermissionErrorTitle,
        description: (0, $dquGP.i18n).restrictionsPermissionErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$isMovingMoreThan100PagesError(errorMessage)) return {
        title: (0, $dquGP.i18n).moreThan100PagesErrorTitle,
        description: (0, $dquGP.i18n).moreThan100PagesErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$isMovingTooManyPagesError(errorMessage)) // This was previously a configurable limit, but the blanket 100-page limit (isMovingMoreThan100PagesError)
    // has been added behind a feature gate on the backend. Thus, this branch is still needed
    return {
        title: (0, $dquGP.i18n).tooManyPagesErrorTitle,
        description: (0, $dquGP.i18n).tooManyPagesErrorDescription
    };
    return undefined;
};
const $0deb5c3dbfed5cc8$var$getI18nMessageForKnown500Error = (errorMessage, IsInEditor, onActionClick, isLivePage)=>{
    if ($0deb5c3dbfed5cc8$var$isConflictingPageNameError(errorMessage)) return $0deb5c3dbfed5cc8$var$getErrorMessageForConflictingPageNamesError(errorMessage, IsInEditor, onActionClick, isLivePage);
    else if ($0deb5c3dbfed5cc8$var$isTargetSameAsSourceError(errorMessage)) return {
        title: (0, $dquGP.i18n).parentChildLoopErrorTitle,
        description: (0, $dquGP.i18n).parentChildLoopErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$isCurrentlyUpdatedError(errorMessage)) return {
        title: (0, $dquGP.i18n).currentlyUpdatedErrorTitle,
        description: (0, $dquGP.i18n).currentlyUpdatedErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$isPartiallyMovedError(errorMessage)) return {
        title: (0, $dquGP.i18n).partiallyMovedErrorTitle,
        description: (0, $dquGP.i18n).partiallyMovedErrorDescription
    };
    return undefined;
};
const $0deb5c3dbfed5cc8$var$getI18nMessageForKnown404Error = (errorMessage)=>{
    if ($0deb5c3dbfed5cc8$var$isDestinationNonexistantError(errorMessage)) return {
        title: (0, $dquGP.i18n).destinationDoesNotExistErrorTitle,
        description: (0, $dquGP.i18n).destinationDoesNotExistErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$isSourceNonexistantError(errorMessage)) return {
        title: (0, $dquGP.i18n).sourceDoesNotExistErrorTitle,
        description: (0, $dquGP.i18n).sourceDoesNotExistErrorDescription
    };
    return undefined;
};
const $0deb5c3dbfed5cc8$var$getI18nMessageForKnown403Error = (errorMessage)=>{
    if ($0deb5c3dbfed5cc8$var$cannotMoveDraftError(errorMessage)) return {
        title: (0, $dquGP.i18n).draftPermissionsErrorTitle,
        description: (0, $dquGP.i18n).draftPermissionsErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$cannotMoveDraftWithChildrenError(errorMessage)) return {
        title: (0, $dquGP.i18n).draftWithChildrenErrorTitle,
        description: (0, $dquGP.i18n).draftWithChildrenErrorDescription
    };
    else if ($0deb5c3dbfed5cc8$var$isNotSpaceAdminForCrossSpaceMoveError(errorMessage) || $0deb5c3dbfed5cc8$var$lacksManageContentOperationError(errorMessage)) return {
        title: (0, $dquGP.i18n).notSpaceAdminForCrossSpaceMoveTitle,
        description: (0, $dquGP.i18n).notSpaceAdminForCrossSpaceMoveDescription
    };
    else return {
        title: (0, $dquGP.i18n).permissionsErrorTitle,
        description: (0, $dquGP.i18n).permissionsErrorDescription
    };
};
const $0deb5c3dbfed5cc8$export$b39266804fdbfd96 = (error, { IsInEditor: IsInEditor = false, onActionClick: onActionClick = ()=>{}, isLivePage: isLivePage = false } = {})=>{
    const graphQLError = error?.graphQLErrors?.[0];
    const errorStatus = (0, $aMcHK.getStatusCode)(graphQLError);
    const errorMessage = graphQLError?.message;
    if (errorStatus === '400') return $0deb5c3dbfed5cc8$var$getI18nMessageForKnown400Error(errorMessage, IsInEditor, onActionClick, isLivePage);
    else if (errorStatus === '403') return $0deb5c3dbfed5cc8$var$getI18nMessageForKnown403Error(errorMessage);
    else if (errorStatus === '404') return $0deb5c3dbfed5cc8$var$getI18nMessageForKnown404Error(errorMessage);
    else if (errorStatus === '500') return $0deb5c3dbfed5cc8$var$getI18nMessageForKnown500Error(errorMessage, IsInEditor, onActionClick, isLivePage);
    return undefined;
};
const $0deb5c3dbfed5cc8$export$d09796ea79b340a2 = (error, childPagesCount)=>{
    if ((0, $aMcHK.isStatusCodeError)(error, '503') && childPagesCount >= 500) return {
        title: (0, $dquGP.i18n).tooManyPagesErrorTitle,
        description: (0, $dquGP.i18n).tooManyPagesErrorDescription
    };
    return {
        title: (0, $dquGP.i18n).defaultErrorTitle,
        description: (0, $dquGP.i18n).defaultErrorDescription
    };
};
const $0deb5c3dbfed5cc8$export$baffa2cd9ca4747d = ()=>({
        title: (0, $dquGP.i18n).noCreatePermissionsErrorTitle,
        description: (0, $dquGP.i18n).noCreatePermissionsErrorDescription
    });
module.exports["getI18nMessageForKnownError"] = $0deb5c3dbfed5cc8$export$b39266804fdbfd96;
module.exports["getI18nMessageForUnknownError"] = $0deb5c3dbfed5cc8$export$d09796ea79b340a2;
module.exports["getI18nMessageForNoCreatePermissions"] = $0deb5c3dbfed5cc8$export$baffa2cd9ca4747d;

});

parcelRegister("dquGP", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $66e892a19b0f4c22$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    noCreatePermissionsErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.no-create-permissions-error.title",
        defaultMessage: "You can\u2019t move this content"
    },
    noCreatePermissionsErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.no-create-permissions-error.description",
        defaultMessage: "To move content to another space, you need permission to create in that space."
    },
    permissionsErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.permissions-error.title",
        defaultMessage: "You don\u2019t have permission to move this content"
    },
    permissionsErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.permissions-error.description",
        defaultMessage: "Contact a space admin to get the content moved or to give you the permissions you need."
    },
    parentChildLoopErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.parent-child-loop.title",
        defaultMessage: "Select a different destination"
    },
    parentChildLoopErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.parent-child-loop.description",
        defaultMessage: "The destination cannot be nested below the content being moved."
    },
    singleConflictingTitleRenameErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.single-conflicting-title-rename.title",
        defaultMessage: "Rename this content to move it"
    },
    singleConflictingTitleRenamePageErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.single-conflicting-title-rename.page-description",
        defaultMessage: "A page with this title already exists in <strong>{destinationSpace}</strong>. We\u2019ll rename it for you so you can move it."
    },
    singleConflictingTitleRenameContentErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.single-conflicting-title-rename.content-description",
        defaultMessage: "Content with this title already exists in <strong>{destinationSpace}</strong>. We\u2019ll rename it for you so you can move it."
    },
    renameFailedErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.rename-failed.title",
        defaultMessage: "We couldn\u2019t rename this content"
    },
    renameFailedErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.rename-failed.description",
        defaultMessage: "Try a different title, then move it again."
    },
    newTitleLabel: {
        id: "page-tree.move-page-dialog.published-page.move-error.single-conflicting-title-rename.new-title-label",
        defaultMessage: "New title"
    },
    singleConflictingPageNameWithinEditorErrorCallToAction: {
        id: "page-tree.move-page-dialog.published-page.move-error.single-conflicting-page-name-within-editor.call-to-action",
        defaultMessage: "Rename this page"
    },
    singleConflictingLivePageNameWithinEditorErrorCallToAction: {
        id: "page-tree.move-page-dialog.published-page.move-error.single-conflicting-live-page-name-within-editor.call-to-action",
        defaultMessage: "Rename this doc"
    },
    singleConflictingPageNameWithinEditorErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.single-conflicting-page-name-within-editor.title",
        defaultMessage: "Rename this page to make it unique"
    },
    singleConflictingLivePageNameWithinEditorErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.single-conflicting-live-page-name-within-editor.title",
        defaultMessage: "Rename this doc to make it unique"
    },
    singleConflictingPageNameWithinEditorErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.single-conflicting-page-name-within-editor.description",
        defaultMessage: "A page titled <strong>{conflictingPageName}</strong> already exists in the {destinationSpace} space. To move this page, you\u2019ll first need to give it a unique title and publish it."
    },
    singleConflictingLivePageNameWithinEditorErrorDescription: {
        id: "page-tree.move-page-dialog.live-page.move-error.single-conflicting-page-name-within-editor.description",
        defaultMessage: "There\u2019s already a page named <strong>{conflictingPageName}</strong> in {destinationSpace}. Give this page a unique title to move it."
    },
    singleConflictingLiveDocNameWithinEditorErrorDescription: {
        id: "page-tree.move-page-dialog.live-doc.move-error.single-conflicting-page-name-within-editor.description",
        defaultMessage: "There\u2019s already a live doc named <strong>{conflictingPageName}</strong> in {destinationSpace}. Give this doc a unique title to move it."
    },
    multipleConflictingContentNamesErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.multiple-conflicting-page-name.title",
        defaultMessage: "Content with these names already exist"
    },
    multipleConflictingContentNamesErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.multiple-conflicting-page-name.description",
        defaultMessage: "The following content already exists in the {destinationSpace} space: {listOfConflictingNames}. Rename your content before moving."
    },
    restrictionsPermissionErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.no-restrictions-permissions.title",
        defaultMessage: "You can\u2019t move restricted content to this space"
    },
    restrictionsPermissionErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.no-restrictions-permissions.description",
        defaultMessage: "This content is restricted, and you don\u2019t have permission to create restricted content in the new space. Remove restrictions before moving it."
    },
    destinationDoesNotExistErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.destination-does-not-exist.title",
        defaultMessage: "Select a different destination"
    },
    destinationDoesNotExistErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.destination-does-not-exist.description",
        defaultMessage: "This destination has recently been deleted or archived. Please select a different destination."
    },
    sourceDoesNotExistErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.source-does-not-exist.title",
        defaultMessage: "This content can\u2019t be moved"
    },
    sourceDoesNotExistErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.source-does-not-exist.description",
        defaultMessage: "This content has recently been deleted or archived and therefore cannot be moved."
    },
    draftPermissionsErrorTitle: {
        id: "page-tree.move-page-dialog.draft-page.move-error.default.title",
        defaultMessage: "You can\u2019t move this content"
    },
    draftPermissionsErrorDescription: {
        id: "page-tree.move-page-dialog.draft-page.move-error.default.description",
        defaultMessage: "Only the owner can move a draft to another space. Contact them or a space admin for help."
    },
    draftWithChildrenErrorTitle: {
        id: "page-tree.move-page-dialog.draft-page.children.move-error.default.title",
        defaultMessage: "You can\u2019t move this content"
    },
    draftWithChildrenErrorDescription: {
        id: "page-tree.move-page-dialog.draft-page.children.move-error.default.description",
        defaultMessage: "This draft has children and cannot be moved to another space. Move them first to relocate this draft or contact a space admin for help."
    },
    defaultErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.default.title",
        defaultMessage: "We\u2019re having issues moving this content"
    },
    defaultErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.default.description",
        defaultMessage: "We\u2019re having issues moving this content. Refresh and try again; if that doesn\u2019t solve the issue, please contact support."
    },
    tooManyPagesErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.too-many-pages.title",
        defaultMessage: "We couldn\u2019t move this many items at once."
    },
    tooManyPagesErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.too-many-pages.description",
        defaultMessage: "Try again by selecting an item with fewer child items."
    },
    moreThan100PagesErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.more-than-hundred-pages.title",
        defaultMessage: "We couldn\u2019t move this many items at once."
    },
    moreThan100PagesErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.more-than-hundred-pages.description",
        defaultMessage: "Try again by selecting an item with fewer than 100 child items."
    },
    movingContentToSelfErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.source-same-as-target.title",
        defaultMessage: "You can\u2019t move any content to a position relative to itself"
    },
    movingContentToSelfErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.source-same-as-target.description",
        defaultMessage: "Uh, oh! You are attempting to move content to itself. Please choose other content you wish to move to."
    },
    currentlyUpdatedErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.currently-updated.title",
        defaultMessage: "We can\u2019t move this content right now"
    },
    currentlyUpdatedErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.currently-updated.description",
        defaultMessage: "Someone just updated this content. Refresh and try moving it again."
    },
    partiallyMovedErrorTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.partially-moved.title",
        defaultMessage: "The move could not be fully completed"
    },
    partiallyMovedErrorDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.partially-moved.description",
        defaultMessage: "Some of the content was not able to be moved to the target space. If you have trouble finding any content, please reach out to Support for help."
    },
    notSpaceAdminForCrossSpaceMoveTitle: {
        id: "page-tree.move-page-dialog.published-page.move-error.not-space-admin-cross-space.title",
        defaultMessage: "You can\u2019t move this content"
    },
    notSpaceAdminForCrossSpaceMoveDescription: {
        id: "page-tree.move-page-dialog.published-page.move-error.not-space-admin-cross-space.description",
        defaultMessage: "Only space admins can move content to another space. Contact your admin for help."
    }
});
module.exports["i18n"] = $66e892a19b0f4c22$export$a7357cdd1f0b0168;

});

parcelRegister("cdzEA", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $aDSIl = parcelRequire("aDSIl");


var $8LYsc = parcelRequire("8LYsc");


var $ds2zu = parcelRequire("ds2zu");


var $dovdS = parcelRequire("dovdS");


var $3aAh8 = parcelRequire("3aAh8");

const $2d6a24440faf3c46$var$i18n = (0, $kSwu1.defineMessages)({
    childrenCountText: {
        id: "page-tree.children-count-plural",
        defaultMessage: "{count, plural,\n      one { includes # child }\n      other { includes # children }\n    }"
    },
    untitledDraftText: {
        id: "page-tree.move-dialog.untitled-draft",
        defaultMessage: "Untitled"
    }
});
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $2d6a24440faf3c46$var$DragPreviewContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        const { isMovePageDialog: isMovePageDialog, ...__cmpldp } = __cmplp;
        T0 = C;
        t1 = __cmpldp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4FKVYEBW4Y _0bjKvDzXzM _2uo31fqi9L _45tiVxJg58 _3iDTPbQ4SZ _0hPCNLDIqT _24h04i2Njc _37wbyuI7V3",
            __cmplp.isMovePageDialog ? "_39xV02aVF6" : "_39xV02Gtpf",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2d6a24440faf3c46$var$BeforeIcon = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_3iDTPbQ4SZ _39xV02oWWg _0jFU0VoWWg _37wbyuDIqT _0hPCNLDIqT _0adFHsPgdg",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2d6a24440faf3c46$var$TitleWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNO7dHp _1bHrqEIZbP _4bt5LAnQyn _2WAcuGnQyn",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2d6a24440faf3c46$var$ChildrenCountContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2O5VijdnbC _3YEZNOdnbC _1bHrqEIZbP _2XsHFMuFDC",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $2d6a24440faf3c46$export$905ab40ac2179daa = (t0)=>{
    const $ = (0, $bDgLe.c)(23);
    const { item: item, type: type, childPagesCount: childPagesCount } = t0;
    const intl = (0, $kSwu1.useIntl)();
    let t1;
    if ($[0] !== intl) {
        t1 = intl.formatMessage($2d6a24440faf3c46$var$i18n.untitledDraftText);
        $[0] = intl;
        $[1] = t1;
    } else t1 = $[1];
    const draftText = t1;
    const isMovePageDialog = type === "move-page-tree";
    const isLive = !!(item?.data?.subType === "live");
    let t2;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dovdS))), {
            label: ""
        });
        $[2] = t2;
    } else t2 = $[2];
    let beforeIcon = t2;
    if (isMovePageDialog) {
        let t3;
        if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($8LYsc))), {
                label: "",
                color: "var(--ds-icon, #292A2E)"
            });
            $[3] = t3;
        } else t3 = $[3];
        beforeIcon = t3;
    } else if (item.hasChildren || item.data.type === "folder") {
        let t3;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                label: "",
                size: "small"
            });
            $[4] = t3;
        } else t3 = $[4];
        beforeIcon = t3;
    }
    let t3;
    if ($[5] !== beforeIcon) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d6a24440faf3c46$var$BeforeIcon, null, beforeIcon);
        $[5] = beforeIcon;
        $[6] = t3;
    } else t3 = $[6];
    let t4;
    if ($[7] !== item.id) {
        t4 = item.id.toString();
        $[7] = item.id;
        $[8] = t4;
    } else t4 = $[8];
    const t5 = item.data.title || draftText;
    const t6 = item.data.status === "DRAFT";
    const t7 = !item.data.emoji ? item.data.type : undefined;
    let t8;
    if ($[9] !== isLive || $[10] !== item.data.emoji || $[11] !== t4 || $[12] !== t5 || $[13] !== t6 || $[14] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d6a24440faf3c46$var$TitleWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3aAh8.PageTreeItemContent), {
            id: t4,
            displayHomePageIcon: false,
            displayEmoji: item.data.emoji,
            displayTitle: t5,
            isDraft: t6,
            contentType: t7,
            draggableState: "idle",
            isSelected: false,
            isLive: isLive
        }));
        $[9] = isLive;
        $[10] = item.data.emoji;
        $[11] = t4;
        $[12] = t5;
        $[13] = t6;
        $[14] = t7;
        $[15] = t8;
    } else t8 = $[15];
    let t9;
    if ($[16] !== childPagesCount) {
        t9 = !!childPagesCount && childPagesCount > 0 && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d6a24440faf3c46$var$ChildrenCountContainer, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($ds2zu))), {
            label: "",
            color: "var(--ds-icon, #292A2E)"
        }), " ", /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
            ...$2d6a24440faf3c46$var$i18n.childrenCountText,
            values: {
                count: childPagesCount
            }
        }));
        $[16] = childPagesCount;
        $[17] = t9;
    } else t9 = $[17];
    let t10;
    if ($[18] !== isMovePageDialog || $[19] !== t3 || $[20] !== t8 || $[21] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($2d6a24440faf3c46$var$DragPreviewContainer, {
            isMovePageDialog: isMovePageDialog
        }, t3, t8, t9);
        $[18] = isMovePageDialog;
        $[19] = t3;
        $[20] = t8;
        $[21] = t9;
        $[22] = t10;
    } else t10 = $[22];
    return t10;
};
module.exports["DragPreview"] = $2d6a24440faf3c46$export$905ab40ac2179daa;

});

parcelRegister("3aAh8", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $kSwu1 = parcelRequire("kSwu1");


var $3izAL = parcelRequire("3izAL");


var $6Pqow = parcelRequire("6Pqow");


var $buxP3 = parcelRequire("buxP3");


var $1l0kj = parcelRequire("1l0kj");


var $w6R6I = parcelRequire("w6R6I");


var $2uDbg = parcelRequire("2uDbg");


var $57p4j = parcelRequire("57p4j");


var $9KSWX = parcelRequire("9KSWX");


var $lpNn5 = parcelRequire("lpNn5");


var $di8q4 = parcelRequire("di8q4");


var $jlIaF = parcelRequire("jlIaF");


var $4K4h4 = parcelRequire("4K4h4");


var $5tsXU = parcelRequire("5tsXU");


var $a6VRS = parcelRequire("a6VRS");


var $6bZDi = parcelRequire("6bZDi");


var $huWyw = parcelRequire("huWyw");


var $bI0Bv = parcelRequire("bI0Bv");


var $1C3B1 = parcelRequire("1C3B1");


var $lXYVJ = parcelRequire("lXYVJ");


var $9wGTI = parcelRequire("9wGTI");


var $6mKj3 = parcelRequire("6mKj3");


var $bQm3c = parcelRequire("bQm3c");


var $kSPGK = parcelRequire("kSPGK");


var $9eE57 = parcelRequire("9eE57");


var $dYA5q = parcelRequire("dYA5q");


var $hXDOc = parcelRequire("hXDOc");


var $2vuKf = parcelRequire("2vuKf");


var $LSims = parcelRequire("LSims");


var $bwL2u = parcelRequire("bwL2u");


var $7aRa9 = parcelRequire("7aRa9");


var $3qtLb = parcelRequire("3qtLb");


var $g0MxG = parcelRequire("g0MxG");








var $6p02T = parcelRequire("6p02T");










const $17e4300d7b59a3d4$export$6c94635022fac1d1 = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { children: children, title: title, isQuickActionsOpen: isQuickActionsOpen } = t0;
    const t1 = !isQuickActionsOpen && title ? title : null;
    let t2;
    if ($[0] !== children || $[1] !== t1) {
        t2 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
            content: t1,
            position: "top",
            delay: 750,
            hideTooltipOnMouseDown: true
        }, children);
        $[0] = children;
        $[1] = t1;
        $[2] = t2;
    } else t2 = $[2];
    return t2;
};


const $2703b103d1a678c3$export$cba03ec732da70ea = (t0)=>{
    const $ = (0, $bDgLe.c)(5);
    const { isHoverPageCardOptedIn: isHoverPageCardOptedIn, children: children, title: title, isQuickActionsOpen: isQuickActionsOpen } = t0;
    let t1;
    if ($[0] !== children || $[1] !== isHoverPageCardOptedIn || $[2] !== isQuickActionsOpen || $[3] !== title) {
        t1 = isHoverPageCardOptedIn ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $17e4300d7b59a3d4$export$6c94635022fac1d1), {
            title: (0, $6p02T.cleanExcerpt)(title),
            isQuickActionsOpen: isQuickActionsOpen
        }, children);
        $[0] = children;
        $[1] = isHoverPageCardOptedIn;
        $[2] = isQuickActionsOpen;
        $[3] = title;
        $[4] = t1;
    } else t1 = $[4];
    return t1;
};



var $l0o5N = parcelRequire("l0o5N");


var $jmjWc = parcelRequire("jmjWc");


const $283076e3bd0fbc90$export$eb28ea972995380e = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "eczdW",
    name: "HomepageIcon",
    loader: async ()=>(await (parcelRequire("dcWqf"))).HomepageIcon
});






const $d246470bc74a0a93$export$86b665ce7b1d6912 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "gunMb",
    name: "DraftLozenge",
    loader: async ()=>(await (parcelRequire("fHWLA"))).DraftLozenge
});



var $lkcsM = parcelRequire("lkcsM");


var $kmQhR = parcelRequire("kmQhR");





var $9DHhW = parcelRequire("9DHhW");





var $1xpoY = parcelRequire("1xpoY");


var $7W8i8 = parcelRequire("7W8i8");




const $20fcf3acba16c07e$export$2920b0197981d122 = 500;


const $f78f73101da794dc$var$logger = (0, $7W8i8.getLogger)('predictLeaveProbability');
// NOTE: while model should (and will) be fetched from Statsig, we need to have a default model
// to avoid errors when the model is not available or buggy. The default model is based on the
// data collected from mouse tracing on Hello over about 4 hours.
const $f78f73101da794dc$var$defaultModel = {
    version: 'default',
    distanceWeight: 0.106,
    speedWeight: 0.072,
    xRangeWeight: 0.095,
    yRangeWeight: 0.048,
    threshold: 0.5,
    stats: {
        distance: {
            mean: 21.22,
            stdDev: 30.59
        },
        speed: {
            mean: 0.14,
            stdDev: 0.21
        },
        xRange: {
            mean: 15.13,
            stdDev: 30.61
        },
        yRange: {
            mean: 8.52,
            stdDev: 5.62
        }
    }
};
const $f78f73101da794dc$var$calculateDistance = (p1, p2)=>{
    return Math.sqrt(Math.pow(p2.x - p1.x, 2) + Math.pow(p2.y - p1.y, 2));
};
function $f78f73101da794dc$var$normalizeFeatures(features, stats) {
    return {
        distance: (features.distance - stats.distance.mean) / stats.distance.stdDev,
        speed: (features.speed - stats.speed.mean) / stats.speed.stdDev,
        xRange: (features.xRange - stats.xRange.mean) / stats.xRange.stdDev,
        yRange: (features.yRange - stats.yRange.mean) / stats.yRange.stdDev
    };
}
const $f78f73101da794dc$var$extractEarlyTraceFeatures = (trace, threshold = (0, $20fcf3acba16c07e$export$2920b0197981d122))=>{
    const earlyPoints = trace.filter((p)=>p.t <= threshold);
    if (earlyPoints.length < 2) return null;
    let totalDistance = 0;
    for(let i = 1; i < earlyPoints.length; i++)totalDistance += $f78f73101da794dc$var$calculateDistance(earlyPoints[i - 1], earlyPoints[i]);
    const timeSpan = earlyPoints[earlyPoints.length - 1].t - earlyPoints[0].t;
    const avgSpeed = timeSpan !== 0 ? totalDistance / timeSpan : 0;
    const xValues = earlyPoints.map((p)=>p.x);
    const yValues = earlyPoints.map((p)=>p.y);
    const xRange = Math.max(...xValues) - Math.min(...xValues);
    const yRange = Math.max(...yValues) - Math.min(...yValues);
    const result = {
        distance: totalDistance,
        speed: avgSpeed,
        xRange: xRange,
        yRange: yRange
    };
    return result;
};
const $f78f73101da794dc$export$9d678332e6ba0864 = (trace)=>{
    const modelStr = (0, $1xpoY.default).getString('confluence-delayed-preload-model', '');
    let model = $f78f73101da794dc$var$defaultModel;
    try {
        model = JSON.parse(modelStr);
    } catch (error) {
        $f78f73101da794dc$var$logger.debug`Error parsing model - ${error}`;
    }
    const result = {
        version: model.version,
        leaveProbability: 0.5
    };
    try {
        const features = $f78f73101da794dc$var$extractEarlyTraceFeatures(trace);
        if (!features) return result;
        const normalizedFeatures = $f78f73101da794dc$var$normalizeFeatures(features, model.stats);
        const score = normalizedFeatures.distance * model.distanceWeight + normalizedFeatures.speed * model.speedWeight + normalizedFeatures.xRange * model.xRangeWeight + normalizedFeatures.yRange * model.yRangeWeight;
        // Convert to probability using sigmoid function
        result.leaveProbability = 1 / (1 + Math.exp(-score));
    } catch (error) {
        $f78f73101da794dc$var$logger.debug`Error predicting leave probability - ${error}`;
    }
    return result;
};


const $80f3b2a1ed983d07$var$sendAnalyticsEvent = (createAnalyticsEvent, action, itemId, attributes)=>{
    createAnalyticsEvent({
        type: 'sendTrackEvent',
        data: {
            action: action,
            actionSubject: 'pageTree',
            actionSubjectId: itemId,
            source: 'pageTree',
            attributes: attributes
        }
    }).fire();
};
const $80f3b2a1ed983d07$var$toMouseTraceString = (mouseTrace)=>{
    return mouseTrace.entries.map(({ x: x, y: y, t: t })=>`(${Math.round(x)}|${Math.round(y)}|${Math.round(t)})`).join('-');
};
// For now this will only collect user's mouse movements compared to the initial target element
// and log them in the following format: (x|y|t)-(x|y|t)-... so later we can TRY using this data
// to determine if the user is intended to click on the page tree item.
const $80f3b2a1ed983d07$var$isUserIntendedToClick = (0, (/*@__PURE__*/$parcel$interopDefault($kmQhR)))((event, targetRect, mouseTrace, preloadTimeout)=>{
    if (!targetRect) return true;
    const x = event.clientX - targetRect.left;
    const y = event.clientY - targetRect.top;
    const t = performance.now() - mouseTrace.timestamp;
    mouseTrace.entries.push({
        x: x,
        y: y,
        t: t
    });
    // We don't want to store too much data in the mouse trace, so we limit it to 200 entries,
    // the number of entries is arbitrary, but hopefully should be enough to determine if the
    // user is intended to click on the page tree item.
    if (mouseTrace.entries.length > 200) mouseTrace.entries.shift();
    // Evaluate the probability of the user leaving the element after the preload timeout
    if (mouseTrace.leaveProbability === undefined && t > preloadTimeout) {
        const result = (0, $f78f73101da794dc$export$9d678332e6ba0864)(mouseTrace.entries);
        mouseTrace.leaveProbability = result.leaveProbability;
        mouseTrace.modelVersion = result.version;
    }
    return true;
}, 17);
const $80f3b2a1ed983d07$export$e30b04a35ab95455 = ({ itemId: itemId, isLive: isLive, contentType: contentType, isSelected: isSelected })=>{
    const preloadTimeout = (0, $1xpoY.default).getNumber('confluence-delayed-preload-timeout', 500);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const preloadAndLeaveRef = (0, $cozmU.useRef)(false);
    const interactionTimeRef = (0, $cozmU.useRef)(0);
    const hoverTimeoutRef = (0, $cozmU.useRef)(undefined);
    const mouseTraceRef = (0, $cozmU.useRef)({
        entries: [],
        timestamp: performance.now()
    });
    const targetRectRef = (0, $cozmU.useRef)(undefined);
    const onPreloadMouseEnter = (0, $cozmU.useCallback)((event)=>{
        if (isSelected || !(0, $9wGTI.fg)('confluence-delayed-preload-hover')) return;
        targetRectRef.current = event.target.getBoundingClientRect();
        mouseTraceRef.current = {
            entries: [],
            timestamp: performance.now()
        };
        preloadAndLeaveRef.current = false;
        interactionTimeRef.current = performance.now();
        hoverTimeoutRef.current = setTimeout(()=>{
            preloadAndLeaveRef.current = true;
        // NO-OP: with this we just measure user behavior, not actually preload the page yet
        }, preloadTimeout);
    }, // NOTE: dependency list is intentional, as future preloading function will depend on these values
    // eslint-disable-next-line react-hooks/exhaustive-deps
    [
        itemId,
        isLive,
        contentType,
        isSelected
    ]);
    const onPreloadMouseLeave = (0, $cozmU.useCallback)(()=>{
        if (isSelected || !(0, $9wGTI.fg)('confluence-delayed-preload-hover')) return;
        const mouseTrace = $80f3b2a1ed983d07$var$toMouseTraceString(mouseTraceRef.current);
        const modelVersion = mouseTraceRef.current.modelVersion;
        const leaveProbability = mouseTraceRef.current.leaveProbability;
        mouseTraceRef.current = {
            entries: [],
            timestamp: performance.now()
        };
        targetRectRef.current = undefined;
        if (hoverTimeoutRef.current) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = undefined;
            if (preloadAndLeaveRef.current) {
                preloadAndLeaveRef.current = false;
                // Here we want to know how many times the user has hovered over the page tree item
                // enough to start the preload, but then left without the navigation.
                $80f3b2a1ed983d07$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndLeave', itemId, {
                    isLive: isLive,
                    contentType: contentType,
                    isNav4Enabled: true,
                    preloadTimeout: preloadTimeout,
                    leaveAfter: performance.now() - interactionTimeRef.current,
                    mouseTrace: mouseTrace,
                    leaveProbability: leaveProbability,
                    modelVersion: modelVersion
                });
            }
        }
    }, [
        itemId,
        createAnalyticsEvent,
        isLive,
        contentType,
        preloadTimeout,
        isSelected
    ]);
    const onPreloadMouseDown = (0, $cozmU.useCallback)(()=>{
        if (isSelected || !(0, $9wGTI.fg)('confluence-delayed-preload-hover')) return;
        const mouseTrace = $80f3b2a1ed983d07$var$toMouseTraceString(mouseTraceRef.current);
        const { leaveProbability: leaveProbability, version: version } = (0, $f78f73101da794dc$export$9d678332e6ba0864)(mouseTraceRef.current.entries);
        clearTimeout(hoverTimeoutRef.current);
        mouseTraceRef.current = {
            entries: [],
            timestamp: performance.now()
        };
        hoverTimeoutRef.current = undefined;
        preloadAndLeaveRef.current = false;
        $80f3b2a1ed983d07$var$sendAnalyticsEvent(createAnalyticsEvent, 'preloadAndClick', itemId, {
            isLive: isLive,
            contentType: contentType,
            isNav4Enabled: true,
            preloadTimeout: preloadTimeout,
            clickAfter: performance.now() - interactionTimeRef.current,
            mouseTrace: mouseTrace,
            leaveProbability: leaveProbability,
            modelVersion: version
        });
    }, [
        createAnalyticsEvent,
        itemId,
        isLive,
        contentType,
        preloadTimeout,
        isSelected
    ]);
    const onPreloadMouseMove = (0, $cozmU.useCallback)((event)=>{
        if (isSelected || !(0, $9wGTI.fg)('confluence-delayed-preload-hover')) return;
        // If we determine that the user is not intended to click, we don't want to preload the page
        // so cancel the preloading timeout and reset the rest of the state.
        if (!$80f3b2a1ed983d07$var$isUserIntendedToClick(event, targetRectRef.current, mouseTraceRef.current, preloadTimeout)) {
            clearTimeout(hoverTimeoutRef.current);
            hoverTimeoutRef.current = undefined;
            preloadAndLeaveRef.current = false;
        }
    }, [
        isSelected,
        preloadTimeout
    ]);
    return {
        isPreloadOnDelayedHoverEnabled: (0, $9wGTI.fg)('confluence-delayed-preload-hover'),
        onPreloadMouseEnter: onPreloadMouseEnter,
        onPreloadMouseLeave: onPreloadMouseLeave,
        onPreloadMouseDown: onPreloadMouseDown,
        onPreloadMouseMove: onPreloadMouseMove
    };
};















var $ep3mz = parcelRequire("ep3mz");


var $dYU3e = parcelRequire("dYU3e");


var $fqIt3 = parcelRequire("fqIt3");


var $nIvaQ = parcelRequire("nIvaQ");

/**
 * Prefetch collabDraft content into the Apollo cache for a given content ID.
 * This is a lightweight version of preloadCollabDraftContent from load-edit-page,
 * without the edit-page-specific side effects (e.g. __SMART_CARDS_IN_DRAFT__).
 */ function $0889ed5704e98880$var$prefetchCollabDraft(contentId, useCache) {
    return (0, $dYU3e.query)({
        query: (0, $nIvaQ.getCollabDraftQuery)(),
        variables: {
            id: contentId,
            hydrateAdf: true
        },
        fetchPolicy: useCache ? 'cache-first' : 'network-only',
        __callerPackage__: "page-tree"
    });
}
// Tracking for prefetch timing — lets us measure if/when the cache was used
// on subsequent navigation. Keyed by contentId.
const $0889ed5704e98880$var$prefetchTimestamps = {};
function $0889ed5704e98880$export$3948cdcdec3474eb(contentId) {
    const timing = $0889ed5704e98880$var$prefetchTimestamps[contentId];
    const cacheStale = (0, $fqIt3.isCollabDraftCacheStale)(contentId);
    const now = performance.now();
    if (!timing) return {
        status: 'not_prefetched',
        cacheStale: cacheStale
    };
    if (!timing.completedAt) {
        const headStartMs = now - timing.startedAt;
        return {
            status: 'in_flight',
            headStartMs: headStartMs,
            cacheStale: cacheStale
        };
    }
    const timeSincePrefetchMs = now - timing.completedAt;
    const prefetchDurationMs = timing.completedAt - timing.startedAt;
    if (cacheStale) return {
        status: 'cache_expired',
        prefetchDurationMs: prefetchDurationMs,
        timeSincePrefetchMs: timeSincePrefetchMs,
        cacheStale: cacheStale
    };
    return {
        status: 'ready',
        prefetchDurationMs: prefetchDurationMs,
        timeSincePrefetchMs: timeSincePrefetchMs,
        cacheStale: cacheStale
    };
}
function $0889ed5704e98880$export$d35410d056b9fa08(contentId) {
    const useCache = !(0, $fqIt3.isCollabDraftCacheStale)(contentId);
    $0889ed5704e98880$var$prefetchTimestamps[contentId] = {
        startedAt: performance.now()
    };
    $0889ed5704e98880$var$prefetchCollabDraft(contentId, useCache).then(()=>{
        (0, $fqIt3.markCollabDraftFetched)(contentId);
        $0889ed5704e98880$var$prefetchTimestamps[contentId].completedAt = performance.now();
    }).catch(()=>{
    // Swallow errors — this is a best-effort prefetch.
    // The real fetch on navigation will handle errors properly.
    });
}


const $7b4f28511d8385e8$export$8b4729b796915618 = (t0)=>{
    const $ = (0, $bDgLe.c)(48);
    const { itemId: itemId, isLive: isLive, isDraft: isDraft, contentType: contentType } = t0;
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const [currentContentId] = (0, $ep3mz.usePageContentId)();
    let t1;
    if ($[0] !== createAnalyticsEvent) {
        t1 = (action, contentId, attributes)=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    action: action,
                    actionSubject: "pageTreeCollabDraftPrefetch",
                    actionSubjectId: contentId,
                    source: "pageTree",
                    attributes: attributes
                }
            }).fire();
        };
        $[0] = createAnalyticsEvent;
        $[1] = t1;
    } else t1 = $[1];
    const sendPrefetchAnalyticsEvent = t1;
    const isCurrentPage = itemId === currentContentId;
    const couldPrefetch = (isLive || isDraft) && !isCurrentPage;
    let t2;
    if ($[2] !== couldPrefetch) {
        t2 = couldPrefetch && (0, $6mKj3.expValEquals)("platform_editor_collabdraft_query_improvements", "isEnabled", true);
        $[2] = couldPrefetch;
        $[3] = t2;
    } else t2 = $[3];
    const isPrefetchEnabled = t2;
    const prefetchTriggeredRef = (0, $cozmU.useRef)(false);
    const prefetchTimeoutRef = (0, $cozmU.useRef)(undefined);
    const interactionTimeRef = (0, $cozmU.useRef)(0);
    const prefetchIdRef = (0, $cozmU.useRef)(null);
    let t3;
    if ($[4] !== itemId) {
        t3 = ()=>`${itemId}-${Date.now()}-${Math.random().toString(36).slice(2, 8)}`;
        $[4] = itemId;
        $[5] = t3;
    } else t3 = $[5];
    const generatePrefetchId = t3;
    let t4;
    if ($[6] !== contentType || $[7] !== generatePrefetchId || $[8] !== isDraft || $[9] !== isLive || $[10] !== isPrefetchEnabled || $[11] !== itemId || $[12] !== sendPrefetchAnalyticsEvent) {
        t4 = ()=>{
            if (!isPrefetchEnabled) return;
            const existingPrefetch = (0, $0889ed5704e98880$export$3948cdcdec3474eb)(itemId);
            if (existingPrefetch.status === "ready" && !existingPrefetch.cacheStale) return;
            prefetchTriggeredRef.current = false;
            interactionTimeRef.current = performance.now();
            prefetchTimeoutRef.current = setTimeout(()=>{
                prefetchTriggeredRef.current = true;
                prefetchIdRef.current = generatePrefetchId();
                (0, $0889ed5704e98880$export$d35410d056b9fa08)(itemId);
                sendPrefetchAnalyticsEvent("prefetchTriggered", itemId, {
                    prefetchId: prefetchIdRef.current,
                    isLive: isLive,
                    isDraft: isDraft,
                    contentType: contentType,
                    prefetchDelayMs: 125,
                    dwellTimeMs: performance.now() - interactionTimeRef.current
                });
            }, 125);
        };
        $[6] = contentType;
        $[7] = generatePrefetchId;
        $[8] = isDraft;
        $[9] = isLive;
        $[10] = isPrefetchEnabled;
        $[11] = itemId;
        $[12] = sendPrefetchAnalyticsEvent;
        $[13] = t4;
    } else t4 = $[13];
    const onPrefetchMouseEnter = t4;
    let t5;
    if ($[14] !== contentType || $[15] !== isDraft || $[16] !== isLive || $[17] !== itemId || $[18] !== sendPrefetchAnalyticsEvent) {
        t5 = ()=>{
            if (prefetchTimeoutRef.current) {
                clearTimeout(prefetchTimeoutRef.current);
                prefetchTimeoutRef.current = undefined;
            }
            if (prefetchTriggeredRef.current) {
                const prefetchInfo = (0, $0889ed5704e98880$export$3948cdcdec3474eb)(itemId);
                sendPrefetchAnalyticsEvent("prefetchUnused", itemId, {
                    prefetchId: prefetchIdRef.current,
                    isLive: isLive,
                    isDraft: isDraft,
                    contentType: contentType,
                    prefetchDelayMs: 125,
                    dwellTimeMs: performance.now() - interactionTimeRef.current,
                    prefetchStatus: prefetchInfo.status,
                    prefetchDurationMs: prefetchInfo.prefetchDurationMs
                });
                prefetchTriggeredRef.current = false;
                prefetchIdRef.current = null;
            }
        };
        $[14] = contentType;
        $[15] = isDraft;
        $[16] = isLive;
        $[17] = itemId;
        $[18] = sendPrefetchAnalyticsEvent;
        $[19] = t5;
    } else t5 = $[19];
    const onPrefetchMouseLeave = t5;
    let t6;
    if ($[20] !== contentType || $[21] !== isDraft || $[22] !== isLive || $[23] !== isPrefetchEnabled || $[24] !== itemId || $[25] !== sendPrefetchAnalyticsEvent) {
        t6 = ()=>{
            prefetchTriggeredRef.current = false;
            if (prefetchTimeoutRef.current) {
                clearTimeout(prefetchTimeoutRef.current);
                prefetchTimeoutRef.current = undefined;
            }
            if (!isPrefetchEnabled) return;
            const prefetchInfo_0 = (0, $0889ed5704e98880$export$3948cdcdec3474eb)(itemId);
            sendPrefetchAnalyticsEvent("prefetchAndClick", itemId, {
                prefetchId: prefetchIdRef.current,
                isLive: isLive,
                isDraft: isDraft,
                contentType: contentType,
                prefetchDelayMs: 125,
                clickAfter: performance.now() - interactionTimeRef.current,
                prefetchStatus: prefetchInfo_0.status,
                prefetchDurationMs: prefetchInfo_0.prefetchDurationMs,
                prefetchTimeSinceMs: prefetchInfo_0.timeSincePrefetchMs,
                prefetchHeadStartMs: prefetchInfo_0.headStartMs,
                prefetchCacheStale: prefetchInfo_0.cacheStale
            });
            prefetchIdRef.current = null;
        };
        $[20] = contentType;
        $[21] = isDraft;
        $[22] = isLive;
        $[23] = isPrefetchEnabled;
        $[24] = itemId;
        $[25] = sendPrefetchAnalyticsEvent;
        $[26] = t6;
    } else t6 = $[26];
    const onPrefetchMouseDown = t6;
    let t7;
    if ($[27] !== contentType || $[28] !== generatePrefetchId || $[29] !== isDraft || $[30] !== isLive || $[31] !== isPrefetchEnabled || $[32] !== itemId || $[33] !== sendPrefetchAnalyticsEvent) {
        t7 = ()=>{
            if (!isPrefetchEnabled) return;
            const existingPrefetch_0 = (0, $0889ed5704e98880$export$3948cdcdec3474eb)(itemId);
            if (existingPrefetch_0.status === "ready" && !existingPrefetch_0.cacheStale) return;
            interactionTimeRef.current = performance.now();
            prefetchTriggeredRef.current = false;
            prefetchTimeoutRef.current = setTimeout(()=>{
                prefetchTriggeredRef.current = true;
                prefetchIdRef.current = generatePrefetchId();
                (0, $0889ed5704e98880$export$d35410d056b9fa08)(itemId);
                sendPrefetchAnalyticsEvent("prefetchTriggered", itemId, {
                    prefetchId: prefetchIdRef.current,
                    isLive: isLive,
                    isDraft: isDraft,
                    contentType: contentType,
                    prefetchDelayMs: 125,
                    dwellTimeMs: performance.now() - interactionTimeRef.current,
                    trigger: "focus"
                });
            }, 125);
        };
        $[27] = contentType;
        $[28] = generatePrefetchId;
        $[29] = isDraft;
        $[30] = isLive;
        $[31] = isPrefetchEnabled;
        $[32] = itemId;
        $[33] = sendPrefetchAnalyticsEvent;
        $[34] = t7;
    } else t7 = $[34];
    const onPrefetchFocus = t7;
    let t8;
    if ($[35] !== contentType || $[36] !== isDraft || $[37] !== isLive || $[38] !== itemId || $[39] !== sendPrefetchAnalyticsEvent) {
        t8 = ()=>{
            if (prefetchTimeoutRef.current) {
                clearTimeout(prefetchTimeoutRef.current);
                prefetchTimeoutRef.current = undefined;
            }
            if (prefetchTriggeredRef.current) {
                const prefetchInfo_1 = (0, $0889ed5704e98880$export$3948cdcdec3474eb)(itemId);
                sendPrefetchAnalyticsEvent("prefetchUnused", itemId, {
                    prefetchId: prefetchIdRef.current,
                    isLive: isLive,
                    isDraft: isDraft,
                    contentType: contentType,
                    prefetchDelayMs: 125,
                    dwellTimeMs: performance.now() - interactionTimeRef.current,
                    prefetchStatus: prefetchInfo_1.status,
                    prefetchDurationMs: prefetchInfo_1.prefetchDurationMs,
                    trigger: "blur"
                });
                prefetchTriggeredRef.current = false;
                prefetchIdRef.current = null;
            }
        };
        $[35] = contentType;
        $[36] = isDraft;
        $[37] = isLive;
        $[38] = itemId;
        $[39] = sendPrefetchAnalyticsEvent;
        $[40] = t8;
    } else t8 = $[40];
    const onPrefetchBlur = t8;
    let t9;
    if ($[41] !== isPrefetchEnabled || $[42] !== onPrefetchBlur || $[43] !== onPrefetchFocus || $[44] !== onPrefetchMouseDown || $[45] !== onPrefetchMouseEnter || $[46] !== onPrefetchMouseLeave) {
        t9 = {
            isPrefetchEnabled: isPrefetchEnabled,
            onPrefetchMouseEnter: onPrefetchMouseEnter,
            onPrefetchMouseLeave: onPrefetchMouseLeave,
            onPrefetchMouseDown: onPrefetchMouseDown,
            onPrefetchFocus: onPrefetchFocus,
            onPrefetchBlur: onPrefetchBlur
        };
        $[41] = isPrefetchEnabled;
        $[42] = onPrefetchBlur;
        $[43] = onPrefetchFocus;
        $[44] = onPrefetchMouseDown;
        $[45] = onPrefetchMouseEnter;
        $[46] = onPrefetchMouseLeave;
        $[47] = t9;
    } else t9 = $[47];
    return t9;
};



var $c4LIS = parcelRequire("c4LIS");








var $jGj7w = parcelRequire("jGj7w");

const $7e591ee26122d641$export$9fdf9590bd980095 = ()=>{
    const $ = (0, $bDgLe.c)(11);
    const { deselectNestedContent: deselectNestedContent, updateTotalCount: updateTotalCount, getSelectedDescendantCount: getSelectedDescendantCount, decrementAncestors: decrementAncestors, removeLoadingDescendant: removeLoadingDescendant } = (0, $bwL2u.useContentTreeSelectionActions)();
    const { getState: getState } = (0, $jGj7w.usePageTreeActions)();
    const [t0] = (0, $bwL2u.useContentTreeSelection)();
    const { loadingDescendantIds: loadingDescendantIds } = t0;
    let t1;
    if ($[0] !== decrementAncestors || $[1] !== getState) {
        t1 = (pageTreeItem)=>{
            const { pages: pages, rootId: rootId } = getState();
            const ancestorContentIds = new Set();
            const getAncestorIds = (currItem)=>{
                const parentId = currItem.parentId;
                if (parentId && parentId != rootId) {
                    ancestorContentIds.add(currItem.parentId);
                    getAncestorIds(pages[currItem.parentId]);
                }
            };
            getAncestorIds(pageTreeItem);
            decrementAncestors([
                ...ancestorContentIds
            ], pageTreeItem.id);
        };
        $[0] = decrementAncestors;
        $[1] = getState;
        $[2] = t1;
    } else t1 = $[2];
    const decrementAncestorCount = t1;
    let t2;
    if ($[3] !== decrementAncestorCount || $[4] !== deselectNestedContent || $[5] !== getSelectedDescendantCount || $[6] !== getState || $[7] !== loadingDescendantIds || $[8] !== removeLoadingDescendant || $[9] !== updateTotalCount) {
        t2 = (itemId)=>{
            const { pages: pages_0 } = getState();
            const descendants = [];
            const pageTreeItem_0 = getState().pages[itemId];
            const selectedDescendantCount = getSelectedDescendantCount(itemId);
            decrementAncestorCount(pageTreeItem_0);
            const isLoadingDescendants = loadingDescendantIds.has(itemId);
            const traverse = (currItem_0)=>{
                descendants.push({
                    id: currItem_0.id,
                    parentId: currItem_0.parentId ?? undefined
                });
                const children = currItem_0.children || [];
                for (const childId of children){
                    const child = pages_0[childId];
                    if (child) traverse(child);
                }
            };
            traverse(pageTreeItem_0);
            deselectNestedContent(descendants.map($7e591ee26122d641$var$_temp), descendants.map($7e591ee26122d641$var$_temp2));
            if (isLoadingDescendants) removeLoadingDescendant(itemId);
            else updateTotalCount(-selectedDescendantCount - 1);
        };
        $[3] = decrementAncestorCount;
        $[4] = deselectNestedContent;
        $[5] = getSelectedDescendantCount;
        $[6] = getState;
        $[7] = loadingDescendantIds;
        $[8] = removeLoadingDescendant;
        $[9] = updateTotalCount;
        $[10] = t2;
    } else t2 = $[10];
    const deselectContentAndDescendants = t2;
    return deselectContentAndDescendants;
};
function $7e591ee26122d641$var$_temp(t0) {
    const { id: id } = t0;
    return id;
}
function $7e591ee26122d641$var$_temp2(t0) {
    const { parentId: parentId_0 } = t0;
    return parentId_0 ?? "";
}



var $7qclg = parcelRequire("7qclg");








var $8hkPB = parcelRequire("8hkPB");


var $jAOzg = parcelRequire("jAOzg");

const $4aaac2bbbee1596e$export$e2b4d5eac1a63b12 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(1);
    const { folderId: folderId } = t0;
    const isSyncing = (0, $jAOzg.useIsFolderSyncing)(folderId);
    if (!isSyncing) return null;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $8hkPB.SmartFolderSyncIcon), {
            testId: "page-tree-folder-sync-spinner"
        });
        $[0] = t1;
    } else t1 = $[0];
    return t1;
});


const $f3181cddc4d39a3c$export$b128294488e41c39 = (contentType, emoji)=>{
    // Add other checks for other content types and corresponding feature flags here as they get implemented.
    if (contentType === 'whiteboard') return !!emoji && (0, $9wGTI.fg)('confluence_frontend_whiteboard_emoji_titles');
    if (contentType === 'page') return !!emoji;
    return false;
};
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $f3181cddc4d39a3c$var$TitleWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3iDTPbvbI6 _1ANEUSLRg7 _39HuIbz8Lp",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f3181cddc4d39a3c$var$contentIconWrapperStyles = (0, $buxP3.xcss)({
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: 'space.050',
    marginLeft: 'space.025',
    width: '24px',
    height: '24px',
    flexShrink: 0
});
const $f3181cddc4d39a3c$export$e31a6cc0a4c97f0e = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "span" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_1pp6NdYbGa _3iDTPbQ4SZ _3YEZNOdnbC _0hPCNLDIqT _0adFHs2ADO _2XsHFMgVvo _0jFU0Vey7F _39xV02ey7F _0LETLXey7F _2Qxi4ney7F _1tJeXfey7F _27VeLCey7F",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $f3181cddc4d39a3c$var$emojiWrapperStyles = null;
const $f3181cddc4d39a3c$export$b2a0cd0ad960a454 = ({ hasCoverPicture: _hasCoverPicture, isPageTitleComponent: _isPageTitleComponent, shouldRemoveEmojiLeftPadding: _shouldRemoveEmojiLeftPadding, ...props })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
        ...props,
        className: (0, $hekY6.default)([
            "_4bt5LAnQyn _2WAcuGnQyn _3SamIH1Y8M _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT _0GTcwRgVvo _2xTnZx2ADO _0jFU0Vey7F _39xV02ey7F _3YEZNOdnbC"
        ])
    });
}; // Wrapper around the after-icon area. We need align-items: center here so our direct
// children (sync spinner + AfterIconContainer) sit on the title baseline. The
// AfterIconContainer itself sets alignItems: center — see PageTreeAfterIcon.tsx.
const $f3181cddc4d39a3c$var$afterIconRowStyles = {
    root: "_0jFU0VoWWg"
};
const $f3181cddc4d39a3c$export$4d23b38ef990da69 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(38);
    const { id: id, displayHomePageIcon: displayHomePageIcon, displayEmoji: displayEmoji, displayTitle: displayTitle, isDraft: isDraft, renderResourcedEmoji: renderResourcedEmoji, contentType: contentType, isSelected: isSelected, draggableState: draggableState, emoji: emoji, isExpanded: isExpanded, isLive: isLive, isManaged: isManaged, isDisabled: isDisabled } = t0;
    const iconColor = isSelected ? "var(--ds-icon-selected, #1868DB)" : undefined;
    const isDragging = draggableState === "dragging";
    const isEmojiSet = $f3181cddc4d39a3c$export$b128294488e41c39(contentType, emoji);
    let t1;
    if ($[0] !== contentType || $[1] !== isEmojiSet) {
        t1 = contentType && (0, $6bZDi.includesValidContentTreeType)(contentType) && !isEmojiSet;
        $[0] = contentType;
        $[1] = isEmojiSet;
        $[2] = t1;
    } else t1 = $[2];
    const isContentTreeIconVisible = t1;
    const isEmojiOptimized = !!emoji;
    const isEmbedWithoutEmoji = contentType === "embed" && !displayEmoji;
    const iconPrimaryColor = isDragging || isDisabled ? "var(--ds-icon-disabled, #080F214A)" : iconColor;
    const isLiveDoc = contentType === "page" && isLive;
    const isManagedFolder = contentType === "folder" && isManaged;
    const isMarkdownMode = (0, $LSims.useIsMarkdownMode)(isLiveDoc ? id : undefined);
    let t2;
    if ($[3] !== displayHomePageIcon) {
        t2 = displayHomePageIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $283076e3bd0fbc90$export$eb28ea972995380e), null) : null;
        $[3] = displayHomePageIcon;
        $[4] = t2;
    } else t2 = $[4];
    let t3;
    if ($[5] !== contentType || $[6] !== iconPrimaryColor || $[7] !== isContentTreeIconVisible || $[8] !== isExpanded || $[9] !== isLiveDoc || $[10] !== isManagedFolder || $[11] !== isMarkdownMode) {
        t3 = isContentTreeIconVisible && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
            as: "span",
            xcss: $f3181cddc4d39a3c$var$contentIconWrapperStyles
        }, isManagedFolder ? isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $a6VRS.ManagedFolderOpenIcon), {
            label: "",
            size: "small",
            color: iconPrimaryColor
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5tsXU.ManagedFolderClosedIcon), {
            label: "",
            size: "small",
            color: iconPrimaryColor
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4K4h4.ContentTreeIconLoader), {
            type: isLiveDoc && (0, $9wGTI.fg)("confluence_live_pages_open_beta_trait_opted_in") ? "liveDoc" : contentType,
            label: "",
            color: iconPrimaryColor,
            isExpanded: isExpanded,
            isMarkdownMode: isMarkdownMode
        }));
        $[5] = contentType;
        $[6] = iconPrimaryColor;
        $[7] = isContentTreeIconVisible;
        $[8] = isExpanded;
        $[9] = isLiveDoc;
        $[10] = isManagedFolder;
        $[11] = isMarkdownMode;
        $[12] = t3;
    } else t3 = $[12];
    let t4;
    if ($[13] !== contentType || $[14] !== displayEmoji || $[15] !== emoji || $[16] !== iconPrimaryColor || $[17] !== isEmbedWithoutEmoji || $[18] !== isEmojiOptimized || $[19] !== renderResourcedEmoji) {
        t4 = (displayEmoji || isEmbedWithoutEmoji) && (isEmojiOptimized ? emoji : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
            key: displayEmoji,
            emoji: displayEmoji,
            contentType: contentType,
            context: "pageTree",
            height: 14,
            primaryColor: iconPrimaryColor,
            wrapper: $f3181cddc4d39a3c$export$e31a6cc0a4c97f0e,
            renderResourcedEmoji: renderResourcedEmoji
        }));
        $[13] = contentType;
        $[14] = displayEmoji;
        $[15] = emoji;
        $[16] = iconPrimaryColor;
        $[17] = isEmbedWithoutEmoji;
        $[18] = isEmojiOptimized;
        $[19] = renderResourcedEmoji;
        $[20] = t4;
    } else t4 = $[20];
    let t5;
    if ($[21] !== isDragging || $[22] !== isSelected) {
        t5 = $f3181cddc4d39a3c$var$getTitleTextColor(isDragging, isSelected);
        $[21] = isDragging;
        $[22] = isSelected;
        $[23] = t5;
    } else t5 = $[23];
    const t6 = isLiveDoc && isMarkdownMode && displayTitle ? `${displayTitle}.md` : displayTitle;
    let t7;
    if ($[24] !== t5 || $[25] !== t6) {
        t7 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $6Pqow.default), {
            weight: "medium",
            color: t5
        }, t6);
        $[24] = t5;
        $[25] = t6;
        $[26] = t7;
    } else t7 = $[26];
    let t8;
    if ($[27] !== id || $[28] !== t7) {
        t8 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f3181cddc4d39a3c$var$TitleWrapper, {
            id: id,
            className: "title"
        }, t7);
        $[27] = id;
        $[28] = t7;
        $[29] = t8;
    } else t8 = $[29];
    let t9;
    if ($[30] !== isDraft) {
        t9 = isDraft && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d246470bc74a0a93$export$86b665ce7b1d6912), null);
        $[30] = isDraft;
        $[31] = t9;
    } else t9 = $[31];
    let t10;
    if ($[32] !== t2 || $[33] !== t3 || $[34] !== t4 || $[35] !== t8 || $[36] !== t9) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            as: "span",
            alignBlock: "center"
        }, t2, t3, t4, t8, t9);
        $[32] = t2;
        $[33] = t3;
        $[34] = t4;
        $[35] = t8;
        $[36] = t9;
        $[37] = t10;
    } else t10 = $[37];
    return t10;
});
const $f3181cddc4d39a3c$var$getTitleTextColor = (isDragging, isSelected)=>{
    if (isDragging) return 'color.text.disabled';
    else if (isSelected) return 'color.text.selected';
    return 'color.text.subtle';
};
const $f3181cddc4d39a3c$var$PageTreeItemComponent = (t0)=>{
    const $ = (0, $bDgLe.c)(214);
    const { item: item, draftText: t1, spaceHomePageId: spaceHomePageId, onExpand: onExpand, onCollapse: onCollapse, onInteractionSourceChange: onInteractionSourceChange, onHighlight: onHighlight, draggableState: draggableState, isSuperAdmin: isSuperAdmin, onClick: onClick, spaceKey: spaceKey, indent: indent, dragHandleProps: dragHandleProps, isHoverPageCardOptedIn: isHoverPageCardOptedIn, closeAllHoverPageCards: closeAllHoverPageCards, isQuickActionsOpen: isQuickActionsOpen, setOpenQuickActionsId: setOpenQuickActionsId, isQuickActionsFocused: isQuickActionsFocused, setFocusedQuickActionsId: setFocusedQuickActionsId, editingTitle: editingTitle, setIsEditingTitleId: setIsEditingTitleId, onEnterHoverTarget: onEnterHoverTarget, onLeaveHoverTarget: onLeaveHoverTarget, onBlurHoverTarget: onBlurHoverTarget, isDraft: isDraft, updateSinglePage: updateSinglePage, shouldRenderAfterIcon: shouldRenderAfterIcon, contentStatus: contentStatus, isSmartFoldersEnabledForTree: isSmartFoldersEnabledForTree, renderResourcedEmoji: renderResourcedEmoji, hideDraftHrefs: hideDraftHrefs, emoji: emoji, flags: flags, renderServerPlaceholder: renderServerPlaceholder } = t0;
    const draftText = t1 === undefined ? "" : t1;
    const intl = (0, $kSwu1.useIntl)();
    const hoverPageCardTriggerRef = (0, $cozmU.useRef)(null);
    const displayEmoji = item.data.emoji;
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    const [t2] = (0, $bwL2u.useContentTreeSelection)();
    const { selectedContent: selectedContent } = t2;
    let t3;
    if ($[0] !== item.id) {
        t3 = item.id.toString();
        $[0] = item.id;
        $[1] = t3;
    } else t3 = $[1];
    const isChecked = t3 in selectedContent;
    let t4;
    if ($[2] !== item.id || $[3] !== updateSinglePage) {
        t4 = (_, title)=>{
            updateSinglePage(item.id, {
                title: title,
                fullTitle: title
            });
        };
        $[2] = item.id;
        $[3] = updateSinglePage;
        $[4] = t4;
    } else t4 = $[4];
    const onOptimisticUpdate = t4;
    const defaultTitle = item.data.title || draftText;
    const { optimisticTitle: optimisticTitle } = (0, $kSPGK.useOptimisticTitleChange)(item.id, defaultTitle, onOptimisticUpdate);
    const displayTitle = optimisticTitle || draftText;
    const contentType = item.data.type;
    const isHighlighted = item.data.isHighlighted;
    const selected = item.data.isSelected;
    const isLive = !!(item?.data?.subType === "live");
    const isManaged = item?.data?.subType === "managed";
    const isSmartFoldersEnabled = isSmartFoldersEnabledForTree ?? false;
    const { isHideTitleInUrl: isHideTitleInUrl } = (0, $bQm3c.useSessionData)();
    let t5;
    if ($[5] !== hideDraftHrefs || $[6] !== isDraft || $[7] !== isHideTitleInUrl || $[8] !== item.data.editorVersion || $[9] !== item.data.type || $[10] !== item.data.webui || $[11] !== item.id || $[12] !== spaceKey) {
        const bypassHref = isDraft && hideDraftHrefs ? null : (0, $huWyw.getURLBypassingResumeDraftAction)({
            url: `${(0, $jlIaF.CONTEXT_PATH)}${item.data.webui}`,
            spaceKey: spaceKey,
            contentType: item.data.type,
            editorVersion: item.data.editorVersion,
            contentId: item.id
        });
        t5 = isHideTitleInUrl && bypassHref && (0, $6mKj3.expValEquals)("confluence_hide_content_title_in_url", "isEnabled", true) ? (0, $bI0Bv.removeContentSlugFromUrl)(bypassHref) : bypassHref;
        $[5] = hideDraftHrefs;
        $[6] = isDraft;
        $[7] = isHideTitleInUrl;
        $[8] = item.data.editorVersion;
        $[9] = item.data.type;
        $[10] = item.data.webui;
        $[11] = item.id;
        $[12] = spaceKey;
        $[13] = t5;
    } else t5 = $[13];
    const itemHref = t5;
    let t6;
    let t7;
    if ($[14] !== isHighlighted || $[15] !== onHighlight) {
        t6 = ()=>{
            if (isHighlighted) {
                const timeoutId = setTimeout(onHighlight, (0, $3qtLb.ANIMATE_TIME_SEC) * 1000);
                return ()=>clearTimeout(timeoutId);
            }
        };
        t7 = [
            isHighlighted,
            onHighlight
        ];
        $[14] = isHighlighted;
        $[15] = onHighlight;
        $[16] = t6;
        $[17] = t7;
    } else {
        t6 = $[16];
        t7 = $[17];
    }
    (0, $cozmU.useEffect)(t6, t7);
    const editingTitleId = editingTitle?.contentId;
    const isEditingTitle = editingTitleId === item.id;
    const editingTitleIsNewContent = editingTitle?.isNewContent;
    let t8;
    let t9;
    if ($[18] !== contentType || $[19] !== editingTitleIsNewContent || $[20] !== isEditingTitle || $[21] !== item.data.createdDate || $[22] !== selected) {
        t8 = ()=>{
            let isNewContent = false;
            if (editingTitleIsNewContent && isEditingTitle) isNewContent = true;
            else if (selected && item.data.createdDate) {
                const now = new Date();
                const createdDate = new Date(Number(item.data.createdDate));
                if (now.getTime() - createdDate.getTime() < 20000) isNewContent = true;
            }
            if (isNewContent) (0, $9eE57.perfMarkEnd)({
                subject: "PageTree",
                subjectId: "newContentRendered",
                details: {
                    contentType: contentType
                }
            });
        };
        t9 = [
            selected,
            item.data.createdDate,
            editingTitleIsNewContent,
            contentType,
            isEditingTitle
        ];
        $[18] = contentType;
        $[19] = editingTitleIsNewContent;
        $[20] = isEditingTitle;
        $[21] = item.data.createdDate;
        $[22] = selected;
        $[23] = t8;
        $[24] = t9;
    } else {
        t8 = $[23];
        t9 = $[24];
    }
    (0, $cozmU.useEffect)(t8, t9);
    const isCursor = item.data.isCursor;
    let t10;
    let t11;
    if ($[25] !== isCursor) {
        t10 = ()=>{
            if (isCursor) (0, $9eE57.perfMarkEnd)({
                subject: "PageTree",
                subjectId: "loadMorePages"
            });
        };
        t11 = [
            isCursor
        ];
        $[25] = isCursor;
        $[26] = t10;
        $[27] = t11;
    } else {
        t10 = $[26];
        t11 = $[27];
    }
    (0, $cozmU.useEffect)(t10, t11);
    const [isContextualCreateFocused, setIsContextualCreateFocused] = (0, $cozmU.useState)(false);
    let t12;
    if ($[28] !== item.id) {
        t12 = item.id.toString();
        $[28] = item.id;
        $[29] = t12;
    } else t12 = $[29];
    const t13 = contentType || "page";
    const t14 = Boolean(selected);
    let t15;
    if ($[30] !== isLive || $[31] !== t12 || $[32] !== t13 || $[33] !== t14) {
        t15 = {
            itemId: t12,
            isLive: isLive,
            contentType: t13,
            isSelected: t14
        };
        $[30] = isLive;
        $[31] = t12;
        $[32] = t13;
        $[33] = t14;
        $[34] = t15;
    } else t15 = $[34];
    const { onPreloadMouseEnter: onPreloadMouseEnter, onPreloadMouseLeave: onPreloadMouseLeave, onPreloadMouseDown: onPreloadMouseDown, onPreloadMouseMove: onPreloadMouseMove, isPreloadOnDelayedHoverEnabled: isPreloadOnDelayedHoverEnabled } = (0, $80f3b2a1ed983d07$export$e30b04a35ab95455)(t15);
    let t16;
    if ($[35] !== item.id) {
        t16 = item.id.toString();
        $[35] = item.id;
        $[36] = t16;
    } else t16 = $[36];
    const t17 = contentType || "page";
    let t18;
    if ($[37] !== isDraft || $[38] !== isLive || $[39] !== t16 || $[40] !== t17) {
        t18 = {
            itemId: t16,
            isLive: isLive,
            isDraft: isDraft,
            contentType: t17
        };
        $[37] = isDraft;
        $[38] = isLive;
        $[39] = t16;
        $[40] = t17;
        $[41] = t18;
    } else t18 = $[41];
    const { onPrefetchMouseEnter: onPrefetchMouseEnter, onPrefetchMouseLeave: onPrefetchMouseLeave, onPrefetchMouseDown: onPrefetchMouseDown, onPrefetchFocus: onPrefetchFocus, onPrefetchBlur: onPrefetchBlur } = (0, $7b4f28511d8385e8$export$8b4729b796915618)(t18);
    const isCheckboxDisabled = isDraft || isManaged;
    let t19;
    if ($[42] !== contentType || $[43] !== displayEmoji || $[44] !== displayTitle || $[45] !== draggableState || $[46] !== emoji || $[47] !== isCheckboxDisabled || $[48] !== isDraft || $[49] !== isLive || $[50] !== isManaged || $[51] !== isMultiSelectActive || $[52] !== isPreloadOnDelayedHoverEnabled || $[53] !== item.id || $[54] !== item.isExpanded || $[55] !== onPrefetchBlur || $[56] !== onPrefetchFocus || $[57] !== onPreloadMouseDown || $[58] !== onPreloadMouseEnter || $[59] !== onPreloadMouseLeave || $[60] !== onPreloadMouseMove || $[61] !== renderResourcedEmoji || $[62] !== selected || $[63] !== spaceHomePageId) {
        t19 = isPreloadOnDelayedHoverEnabled ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
            role: "presentation",
            onMouseEnter: onPreloadMouseEnter,
            onMouseLeave: onPreloadMouseLeave,
            onFocus: onPrefetchFocus,
            onBlur: onPrefetchBlur,
            onMouseDown: onPreloadMouseDown,
            onMouseMove: onPreloadMouseMove
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f3181cddc4d39a3c$export$4d23b38ef990da69, {
            id: item.id.toString(),
            displayHomePageIcon: item.id === spaceHomePageId,
            isDraft: isDraft,
            displayTitle: displayTitle,
            displayEmoji: displayEmoji,
            contentType: contentType,
            isSelected: selected,
            renderResourcedEmoji: renderResourcedEmoji,
            draggableState: draggableState,
            emoji: emoji,
            isExpanded: item.isExpanded,
            isLive: isLive,
            isManaged: isManaged,
            isDisabled: isMultiSelectActive && isCheckboxDisabled
        })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($f3181cddc4d39a3c$export$4d23b38ef990da69, {
            id: item.id.toString(),
            displayHomePageIcon: item.id === spaceHomePageId,
            isDraft: isDraft,
            displayTitle: displayTitle,
            displayEmoji: displayEmoji,
            contentType: contentType,
            isSelected: selected,
            renderResourcedEmoji: renderResourcedEmoji,
            draggableState: draggableState,
            emoji: emoji,
            isExpanded: item.isExpanded,
            isLive: isLive,
            isManaged: isManaged,
            isDisabled: isMultiSelectActive && isCheckboxDisabled
        });
        $[42] = contentType;
        $[43] = displayEmoji;
        $[44] = displayTitle;
        $[45] = draggableState;
        $[46] = emoji;
        $[47] = isCheckboxDisabled;
        $[48] = isDraft;
        $[49] = isLive;
        $[50] = isManaged;
        $[51] = isMultiSelectActive;
        $[52] = isPreloadOnDelayedHoverEnabled;
        $[53] = item.id;
        $[54] = item.isExpanded;
        $[55] = onPrefetchBlur;
        $[56] = onPrefetchFocus;
        $[57] = onPreloadMouseDown;
        $[58] = onPreloadMouseEnter;
        $[59] = onPreloadMouseLeave;
        $[60] = onPreloadMouseMove;
        $[61] = renderResourcedEmoji;
        $[62] = selected;
        $[63] = spaceHomePageId;
        $[64] = t19;
    } else t19 = $[64];
    const pageTreeItemContent = t19;
    const selectContentAndDescendants = (0, $c4LIS.useNestedSelect)();
    const deselectContentAndDescendants = (0, $7e591ee26122d641$export$9fdf9590bd980095)();
    let t20;
    if ($[65] !== onBlurHoverTarget || $[66] !== onPrefetchBlur) {
        t20 = (e)=>{
            onPrefetchBlur();
            onBlurHoverTarget(e);
        };
        $[65] = onBlurHoverTarget;
        $[66] = onPrefetchBlur;
        $[67] = t20;
    } else t20 = $[67];
    const onBlurCallback = t20;
    const t21 = isChecked && !isDraft;
    let t22;
    if ($[68] !== deselectContentAndDescendants || $[69] !== flags || $[70] !== item.id || $[71] !== selectContentAndDescendants) {
        t22 = (e_0)=>{
            if (e_0.target.checked) selectContentAndDescendants(item.id, true, flags);
            else deselectContentAndDescendants(item.id);
        };
        $[68] = deselectContentAndDescendants;
        $[69] = flags;
        $[70] = item.id;
        $[71] = selectContentAndDescendants;
        $[72] = t22;
    } else t22 = $[72];
    let t23;
    if ($[73] !== intl || $[74] !== item.data.title) {
        t23 = intl.formatMessage($f3181cddc4d39a3c$var$i18n.checkboxLabel, {
            contentTitle: item.data.title
        });
        $[73] = intl;
        $[74] = item.data.title;
        $[75] = t23;
    } else t23 = $[75];
    let t24;
    if ($[76] !== isCheckboxDisabled || $[77] !== t21 || $[78] !== t22 || $[79] !== t23) {
        t24 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2uDbg.Checkbox), {
            isChecked: t21,
            onChange: t22,
            name: "isPageTreeItemSelected",
            "aria-label": t23,
            isDisabled: isCheckboxDisabled
        });
        $[76] = isCheckboxDisabled;
        $[77] = t21;
        $[78] = t22;
        $[79] = t23;
        $[80] = t24;
    } else t24 = $[80];
    const checkBox = t24;
    if (isMultiSelectActive) {
        const selectedItem = selectedContent[item.id];
        const hasDescendantCount = selectedItem && selectedItem.selectedDescendantCount > 0;
        let t25;
        if ($[81] === Symbol.for("react.memo_cache_sentinel")) {
            t25 = {
                contain: "content"
            };
            $[81] = t25;
        } else t25 = $[81];
        let t26;
        if ($[82] !== checkBox || $[83] !== intl || $[84] !== isDraft || $[85] !== isManaged) {
            t26 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), null, (props)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", props, isDraft ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                    content: intl.formatMessage($f3181cddc4d39a3c$var$i18n.draftTooltip)
                }, checkBox) : isManaged ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                    content: intl.formatMessage($f3181cddc4d39a3c$var$i18n.managedTooltip)
                }, checkBox) : checkBox));
            $[82] = checkBox;
            $[83] = intl;
            $[84] = isDraft;
            $[85] = isManaged;
            $[86] = t26;
        } else t26 = $[86];
        let t27;
        if ($[87] !== deselectContentAndDescendants || $[88] !== displayTitle || $[89] !== flags || $[90] !== hasDescendantCount || $[91] !== indent || $[92] !== isCheckboxDisabled || $[93] !== isChecked || $[94] !== isSuperAdmin || $[95] !== item || $[96] !== itemHref || $[97] !== onCollapse || $[98] !== onExpand || $[99] !== onInteractionSourceChange || $[100] !== pageTreeItemContent || $[101] !== selectContentAndDescendants || $[102] !== selected || $[103] !== selectedItem) {
            t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $57p4j.default), {
                entranceDirection: "left"
            }, (props_0)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("span", {
                    ...props_0,
                    style: {
                        ...props_0.style,
                        flexGrow: 1,
                        minWidth: 0
                    }
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2703b103d1a678c3$export$cba03ec732da70ea), {
                    title: displayTitle,
                    isHoverPageCardOptedIn: false,
                    isQuickActionsOpen: false
                }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lkcsM.PageTreeLinkItem), {
                    renderAs: "span",
                    isSelected: Boolean(selected),
                    onClick: (event)=>{
                        event.preventDefault();
                        event.stopPropagation();
                        if (!isCheckboxDisabled) {
                            if (!isChecked) selectContentAndDescendants(item.id, true, flags);
                            else deselectContentAndDescendants(item.id);
                        }
                    },
                    href: itemHref,
                    item: item,
                    isSuperAdmin: isSuperAdmin,
                    indent: indent,
                    forceHoverBackground: false,
                    isQuickActionsFocused: false,
                    isDisabled: isCheckboxDisabled,
                    beforeIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7qclg.BeforeIcon), {
                        item: item,
                        isSuperAdmin: isSuperAdmin,
                        onExpand: (event_0)=>{
                            event_0.preventDefault();
                            event_0.stopPropagation();
                            onInteractionSourceChange?.(item.id, "chevron");
                            onExpand?.(item.id);
                        },
                        onCollapse: (event_1)=>{
                            event_1.preventDefault();
                            event_1.stopPropagation();
                            onInteractionSourceChange?.(item.id, "chevron");
                            onCollapse?.(item.id);
                        }
                    }),
                    afterIcon: item.hasChildren && !item.isExpanded && hasDescendantCount ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9KSWX.default), {
                        isBold: true
                    }, "+", selectedItem.selectedDescendantCount) : undefined
                }, pageTreeItemContent))));
            $[87] = deselectContentAndDescendants;
            $[88] = displayTitle;
            $[89] = flags;
            $[90] = hasDescendantCount;
            $[91] = indent;
            $[92] = isCheckboxDisabled;
            $[93] = isChecked;
            $[94] = isSuperAdmin;
            $[95] = item;
            $[96] = itemHref;
            $[97] = onCollapse;
            $[98] = onExpand;
            $[99] = onInteractionSourceChange;
            $[100] = pageTreeItemContent;
            $[101] = selectContentAndDescendants;
            $[102] = selected;
            $[103] = selectedItem;
            $[104] = t27;
        } else t27 = $[104];
        let t28;
        if ($[105] !== t26 || $[106] !== t27) {
            t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                style: t25
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
                alignInline: "start",
                alignBlock: "center",
                space: "space.0"
            }, t26, t27));
            $[105] = t26;
            $[106] = t27;
            $[107] = t28;
        } else t28 = $[107];
        return t28;
    }
    if (renderServerPlaceholder) {
        const t25 = item.id;
        const t26 = Boolean(selected);
        let t27;
        if ($[108] !== isSuperAdmin || $[109] !== item) {
            t27 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7qclg.BeforeIcon), {
                item: item,
                isSuperAdmin: isSuperAdmin,
                onCollapse: $f3181cddc4d39a3c$var$noop,
                onExpand: $f3181cddc4d39a3c$var$noop
            });
            $[108] = isSuperAdmin;
            $[109] = item;
            $[110] = t27;
        } else t27 = $[110];
        let t28;
        if ($[111] !== dragHandleProps || $[112] !== draggableState || $[113] !== indent || $[114] !== isSuperAdmin || $[115] !== item || $[116] !== itemHref || $[117] !== pageTreeItemContent || $[118] !== t26 || $[119] !== t27) {
            t28 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lkcsM.PageTreeLinkItem), {
                dragHandleProps: dragHandleProps,
                isSelected: t26,
                href: itemHref,
                item: item,
                draggableState: draggableState,
                isSuperAdmin: isSuperAdmin,
                indent: indent,
                onClick: $f3181cddc4d39a3c$var$noop,
                forceHoverBackground: false,
                isQuickActionsFocused: false,
                beforeIcon: t27
            }, pageTreeItemContent);
            $[111] = dragHandleProps;
            $[112] = draggableState;
            $[113] = indent;
            $[114] = isSuperAdmin;
            $[115] = item;
            $[116] = itemHref;
            $[117] = pageTreeItemContent;
            $[118] = t26;
            $[119] = t27;
            $[120] = t28;
        } else t28 = $[120];
        let t29;
        if ($[121] !== item.id || $[122] !== t28) {
            t29 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                role: "presentation"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
                "data-contentid": t25,
                role: "presentation"
            }, t28)));
            $[121] = item.id;
            $[122] = t28;
            $[123] = t29;
        } else t29 = $[123];
        return t29;
    }
    const t25 = itemHref ?? "";
    let t26;
    if ($[124] !== closeAllHoverPageCards || $[125] !== contentType || $[126] !== isDraft || $[127] !== isQuickActionsOpen || $[128] !== onPrefetchMouseDown || $[129] !== setOpenQuickActionsId) {
        t26 = ()=>{
            onPrefetchMouseDown();
            if (contentType === "page" && !isDraft) (0, $lXYVJ.setViewTransitionSource)((0, $1C3B1.PAGE_TREE_ITEM_CLICK));
            closeAllHoverPageCards();
            isQuickActionsOpen && setOpenQuickActionsId(null);
        };
        $[124] = closeAllHoverPageCards;
        $[125] = contentType;
        $[126] = isDraft;
        $[127] = isQuickActionsOpen;
        $[128] = onPrefetchMouseDown;
        $[129] = setOpenQuickActionsId;
        $[130] = t26;
    } else t26 = $[130];
    const t27 = item.id;
    const t28 = item.id;
    const t29 = item.data.fullTitle || "";
    const t30 = item.data.emojiFromProperties || "";
    let t31;
    if ($[131] !== isContextualCreateFocused || $[132] !== isQuickActionsFocused || $[133] !== item.id || $[134] !== onEnterHoverTarget) {
        t31 = ()=>{
            onEnterHoverTarget({
                itemID: item.id.toString(),
                isQuickActionsFocused: isQuickActionsFocused,
                hoverPageCardTriggerRef: hoverPageCardTriggerRef,
                isContextualCreateFocused: isContextualCreateFocused
            });
        };
        $[131] = isContextualCreateFocused;
        $[132] = isQuickActionsFocused;
        $[133] = item.id;
        $[134] = onEnterHoverTarget;
        $[135] = t31;
    } else t31 = $[135];
    const t32 = Boolean(selected);
    const t33 = isQuickActionsOpen || isContextualCreateFocused;
    let t34;
    if ($[136] !== item.id || $[137] !== onExpand || $[138] !== onInteractionSourceChange) {
        t34 = (event_2)=>{
            event_2.preventDefault();
            event_2.stopPropagation();
            onInteractionSourceChange?.(item.id, "chevron");
            onExpand?.(item.id);
        };
        $[136] = item.id;
        $[137] = onExpand;
        $[138] = onInteractionSourceChange;
        $[139] = t34;
    } else t34 = $[139];
    let t35;
    if ($[140] !== item.id || $[141] !== onCollapse || $[142] !== onInteractionSourceChange) {
        t35 = (event_3)=>{
            event_3.preventDefault();
            event_3.stopPropagation();
            onInteractionSourceChange?.(item.id, "chevron");
            onCollapse?.(item.id);
        };
        $[140] = item.id;
        $[141] = onCollapse;
        $[142] = onInteractionSourceChange;
        $[143] = t35;
    } else t35 = $[143];
    let t36;
    if ($[144] !== isSuperAdmin || $[145] !== item || $[146] !== t34 || $[147] !== t35) {
        t36 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $7qclg.BeforeIcon), {
            item: item,
            isSuperAdmin: isSuperAdmin,
            onExpand: t34,
            onCollapse: t35
        });
        $[144] = isSuperAdmin;
        $[145] = item;
        $[146] = t34;
        $[147] = t35;
        $[148] = t36;
    } else t36 = $[148];
    let t37;
    if ($[149] !== closeAllHoverPageCards || $[150] !== contentType || $[151] !== displayTitle || $[152] !== isContextualCreateFocused || $[153] !== isManaged || $[154] !== isQuickActionsOpen || $[155] !== isSmartFoldersEnabled || $[156] !== isSuperAdmin || $[157] !== item || $[158] !== setFocusedQuickActionsId || $[159] !== setIsEditingTitleId || $[160] !== setOpenQuickActionsId || $[161] !== shouldRenderAfterIcon || $[162] !== spaceKey) {
        t37 = isManaged || shouldRenderAfterIcon ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1l0kj.Inline), {
            as: "span",
            alignBlock: "center",
            space: "space.050",
            xcss: (0, $w6R6I.cx)($f3181cddc4d39a3c$var$afterIconRowStyles.root)
        }, isManaged && isSmartFoldersEnabled && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4aaac2bbbee1596e$export$e2b4d5eac1a63b12), {
            folderId: item.id
        }), shouldRenderAfterIcon && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $g0MxG.PageTreeAfterIconLoader), {
            setFocusedQuickActionsId: setFocusedQuickActionsId,
            isSuperAdmin: isSuperAdmin,
            isQuickActionsOpen: isQuickActionsOpen,
            setOpenQuickActionsId: setOpenQuickActionsId,
            setIsEditingTitleId: setIsEditingTitleId,
            closeAllHoverPageCards: closeAllHoverPageCards,
            spaceKey: spaceKey,
            item: item,
            isContextualCreateFocused: isContextualCreateFocused,
            setIsContextualCreateFocused: setIsContextualCreateFocused,
            displayTitle: displayTitle,
            contentType: contentType
        })) : null;
        $[149] = closeAllHoverPageCards;
        $[150] = contentType;
        $[151] = displayTitle;
        $[152] = isContextualCreateFocused;
        $[153] = isManaged;
        $[154] = isQuickActionsOpen;
        $[155] = isSmartFoldersEnabled;
        $[156] = isSuperAdmin;
        $[157] = item;
        $[158] = setFocusedQuickActionsId;
        $[159] = setIsEditingTitleId;
        $[160] = setOpenQuickActionsId;
        $[161] = shouldRenderAfterIcon;
        $[162] = spaceKey;
        $[163] = t37;
    } else t37 = $[163];
    let t38;
    if ($[164] !== dragHandleProps || $[165] !== draggableState || $[166] !== indent || $[167] !== isQuickActionsFocused || $[168] !== isSuperAdmin || $[169] !== item || $[170] !== itemHref || $[171] !== onBlurHoverTarget || $[172] !== onClick || $[173] !== onLeaveHoverTarget || $[174] !== pageTreeItemContent || $[175] !== t31 || $[176] !== t32 || $[177] !== t33 || $[178] !== t36 || $[179] !== t37) {
        t38 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lkcsM.PageTreeLinkItem), {
            dragHandleProps: dragHandleProps,
            onMouseEnter: t31,
            onMouseLeave: onLeaveHoverTarget,
            onBlur: onBlurHoverTarget,
            isSelected: t32,
            onClick: onClick,
            href: itemHref,
            item: item,
            draggableState: draggableState,
            isSuperAdmin: isSuperAdmin,
            indent: indent,
            forceHoverBackground: t33,
            isQuickActionsFocused: isQuickActionsFocused,
            beforeIcon: t36,
            afterIcon: t37
        }, pageTreeItemContent);
        $[164] = dragHandleProps;
        $[165] = draggableState;
        $[166] = indent;
        $[167] = isQuickActionsFocused;
        $[168] = isSuperAdmin;
        $[169] = item;
        $[170] = itemHref;
        $[171] = onBlurHoverTarget;
        $[172] = onClick;
        $[173] = onLeaveHoverTarget;
        $[174] = pageTreeItemContent;
        $[175] = t31;
        $[176] = t32;
        $[177] = t33;
        $[178] = t36;
        $[179] = t37;
        $[180] = t38;
    } else t38 = $[180];
    let t39;
    if ($[181] !== displayTitle || $[182] !== isHoverPageCardOptedIn || $[183] !== isQuickActionsOpen || $[184] !== t38) {
        t39 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2703b103d1a678c3$export$cba03ec732da70ea), {
            title: displayTitle,
            isHoverPageCardOptedIn: isHoverPageCardOptedIn,
            isQuickActionsOpen: isQuickActionsOpen
        }, t38);
        $[181] = displayTitle;
        $[182] = isHoverPageCardOptedIn;
        $[183] = isQuickActionsOpen;
        $[184] = t38;
        $[185] = t39;
    } else t39 = $[185];
    let t40;
    if ($[186] !== contentStatus || $[187] !== contentType || $[188] !== editingTitleIsNewContent || $[189] !== indent || $[190] !== isEditingTitle || $[191] !== isLive || $[192] !== item.id || $[193] !== setFocusedQuickActionsId || $[194] !== setIsEditingTitleId || $[195] !== t29 || $[196] !== t30 || $[197] !== t39 || $[198] !== updateSinglePage) {
        t40 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $l0o5N.ConditionalInlineRename), {
            id: t28,
            title: t29,
            displayEmoji: t30,
            isEditingTitle: isEditingTitle,
            isNewContent: editingTitleIsNewContent,
            setIsEditingTitleId: setIsEditingTitleId,
            setFocusedQuickActionsId: setFocusedQuickActionsId,
            updateContentTreeItem: updateSinglePage,
            contentStatus: contentStatus,
            contentType: contentType,
            isLive: isLive,
            indent: indent
        }, t39);
        $[186] = contentStatus;
        $[187] = contentType;
        $[188] = editingTitleIsNewContent;
        $[189] = indent;
        $[190] = isEditingTitle;
        $[191] = isLive;
        $[192] = item.id;
        $[193] = setFocusedQuickActionsId;
        $[194] = setIsEditingTitleId;
        $[195] = t29;
        $[196] = t30;
        $[197] = t39;
        $[198] = updateSinglePage;
        $[199] = t40;
    } else t40 = $[199];
    let t41;
    if ($[200] !== item.id || $[201] !== onBlurCallback || $[202] !== onPrefetchFocus || $[203] !== onPrefetchMouseEnter || $[204] !== onPrefetchMouseLeave || $[205] !== t26 || $[206] !== t40) {
        t41 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
            onMouseEnter: onPrefetchMouseEnter,
            onMouseLeave: onPrefetchMouseLeave,
            onFocus: onPrefetchFocus,
            onBlur: onBlurCallback,
            onMouseDown: t26,
            ref: hoverPageCardTriggerRef,
            "data-contentid": t27,
            role: "presentation"
        }, t40);
        $[200] = item.id;
        $[201] = onBlurCallback;
        $[202] = onPrefetchFocus;
        $[203] = onPrefetchMouseEnter;
        $[204] = onPrefetchMouseLeave;
        $[205] = t26;
        $[206] = t40;
        $[207] = t41;
    } else t41 = $[207];
    let t42;
    if ($[208] !== t25 || $[209] !== t41) {
        t42 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hXDOc.HoverPreloader), {
            name: "page-tree-item",
            preloadUrl: t25,
            preloadOptions: (0, $hXDOc.PreloadingPresets).onlyJS
        }, t41);
        $[208] = t25;
        $[209] = t41;
        $[210] = t42;
    } else t42 = $[210];
    let t43;
    if ($[211] !== isLive || $[212] !== t42) {
        t43 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $dYA5q.LivePagePreloader), {
            isLivePage: isLive
        }, t42);
        $[211] = isLive;
        $[212] = t42;
        $[213] = t43;
    } else t43 = $[213];
    return t43;
};
const $f3181cddc4d39a3c$export$66351858996683dc = (0, $7aRa9.withFlags)($f3181cddc4d39a3c$var$PageTreeItemComponent);
const $f3181cddc4d39a3c$var$i18n = (0, $kSwu1.defineMessages)({
    checkboxLabel: {
        id: "page-tree.page-tree-item.checkbox.label",
        defaultMessage: "{contentTitle} checkbox"
    },
    draftTooltip: {
        id: "page-tree.page-tree-item.draft.tooltip",
        defaultMessage: "Drafts can\u2019t be selected for bulk actions."
    },
    managedTooltip: {
        id: "page-tree.page-tree-item.managed.tooltip",
        defaultMessage: "Synced content can\u2019t be selected for bulk actions."
    }
});
const $f3181cddc4d39a3c$var$noop = ()=>{};
module.exports["useIsEmojiSetForType"] = $f3181cddc4d39a3c$export$b128294488e41c39;
module.exports["EmojiWrapper"] = $f3181cddc4d39a3c$export$e31a6cc0a4c97f0e;
module.exports["PageTreeItemContent"] = $f3181cddc4d39a3c$export$4d23b38ef990da69;
module.exports["PageTreeItem"] = $f3181cddc4d39a3c$export$66351858996683dc;

});

parcelRegister("l0o5N", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hySOz = parcelRequire("hySOz");

const $208c4dcc8619080d$export$2305c9520b042855 = (t0)=>{
    const $ = (0, $bDgLe.c)(10);
    let children;
    let isEditingTitle;
    let props;
    if ($[0] !== t0) {
        ({ children: children, isEditingTitle: isEditingTitle, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = isEditingTitle;
        $[3] = props;
    } else {
        children = $[1];
        isEditingTitle = $[2];
        props = $[3];
    }
    if (isEditingTitle) {
        let t1;
        if ($[4] !== children || $[5] !== isEditingTitle || $[6] !== props) {
            t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $hySOz.InlineRename), {
                ...props,
                isEditingTitle: isEditingTitle
            }, children);
            $[4] = children;
            $[5] = isEditingTitle;
            $[6] = props;
            $[7] = t1;
        } else t1 = $[7];
        return t1;
    }
    let t1;
    if ($[8] !== children) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[8] = children;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
};
module.exports["ConditionalInlineRename"] = $208c4dcc8619080d$export$2305c9520b042855;

});

parcelRegister("dcWqf", function(module, exports) {

let $99d9b6d106f005bb$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $99d9b6d106f005bb$var$load("k0Z8C"),
    $99d9b6d106f005bb$var$load("fnoJZ")
]).then(()=>parcelRequire('7He8T'));

});

parcelRegister("6dFT0", function(module, exports) {
"use strict";


let $487472ade577be65$var$load = (maxShards)=>(id)=>{
        // eslint-disable-next-line no-undef
        return import((parcelRequire("clX3F")).shardUrl((parcelRequire("1hiTA")).resolve(id), maxShards));
    };
module.exports = $487472ade577be65$var$load;

});

parcelRegister("clX3F", function(module, exports) {
"use strict";
Object.defineProperty(module.exports, "__esModule", {
    value: true
});
module.exports.applyShardToDomain = $8fe541edd234eb0b$var$applyShardToDomain;
module.exports.domainShardingKey = void 0;
module.exports.getDomainShardIndex = $8fe541edd234eb0b$var$getDomainShardIndex;
module.exports.shardUrl = $8fe541edd234eb0b$var$shardUrl;
module.exports.shardUrlUnchecked = $8fe541edd234eb0b$var$shardUrlUnchecked;
const $8fe541edd234eb0b$var$globalKeyName = '__ATLASPACK_ENABLE_DOMAIN_SHARDS';
/**
 * Extracts the file name from a static asset path.
 * Will throw if the path doesn't have segments or ends in a trailing slash.
 */ function $8fe541edd234eb0b$var$getFilenameFromUrlPath(pathname) {
    const lastSlashIdx = pathname.lastIndexOf('/');
    if (lastSlashIdx === -1 || lastSlashIdx === pathname.length - 1) throw new Error(`Expected an absolute URL with a file name, unable to apply sharding.`);
    // Add 1 to skip over the / itself
    return pathname.slice(lastSlashIdx + 1);
}
/**
 * Generates a bounded numeric hash in [0, maxShards)
 */ function $8fe541edd234eb0b$var$getDomainShardIndex(str, maxShards) {
    // As we include the base domain as a shard option then we add 1 to maxShards
    // to account for that.
    const totalShards = maxShards + 1;
    let shard = str.split('').reduce((a, b)=>{
        const n = (a << totalShards) - a + b.charCodeAt(0);
        // The value returned by << is 64 bit, the & operator coerces to 32,
        // prevents overflow as we iterate.
        return n & n;
    }, 0);
    shard = shard % totalShards;
    // Make number positive
    if (shard < 0) shard += totalShards;
    return shard;
}
const $8fe541edd234eb0b$var$trailingShardRegex = /-\d+$/;
/**
 * Removes trailing shard number from subdomain
 */ function $8fe541edd234eb0b$var$removeTrailingShard(subdomain) {
    if (!$8fe541edd234eb0b$var$trailingShardRegex.test(subdomain)) return subdomain;
    const shardIdx = subdomain.lastIndexOf('-');
    return subdomain.slice(0, shardIdx);
}
/**
 * Given a shard number, inserts that shard in the expected pattern within the
 * domain
 */ function $8fe541edd234eb0b$var$applyShardToDomain(domain, shard) {
    const i = domain.indexOf('.');
    // If the shard is 0, then just use the base domain.
    // If the shard is > 0, then remove 1 as the shards domains index from 0
    const shardSuffix = shard === 0 ? '' : `-${shard - 1}`;
    // Domains like localhost have no . separators
    if (i === -1) return `${$8fe541edd234eb0b$var$removeTrailingShard(domain)}${shardSuffix}`;
    // If this domain already has a shard number in it, strip it
    // out before adding the new one
    const firstSubdomain = $8fe541edd234eb0b$var$removeTrailingShard(domain.slice(0, i));
    return `${firstSubdomain}${shardSuffix}${domain.slice(i)}`;
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * Unlike `shardUrl`, this function will always apply sharding, without any
 * conditional logic.
 */ function $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards) {
    const parsedUrl = new URL(url);
    const fileName = $8fe541edd234eb0b$var$getFilenameFromUrlPath(parsedUrl.pathname);
    const shardNumber = $8fe541edd234eb0b$var$getDomainShardIndex(fileName, maxShards);
    parsedUrl.hostname = $8fe541edd234eb0b$var$applyShardToDomain(parsedUrl.hostname, shardNumber);
    return parsedUrl.toString();
}
/**
 * Takes an absolute URL and applies a shard to the top level subdomain.
 * The shard number is based on a hash of the file name, which is
 * the content after the last / in the URL.
 *
 * This function only applies the sharding if the
 * __ATLASPACK_ENABLE_DOMAIN_SHARDS global variable has been set to true
 */ function $8fe541edd234eb0b$var$shardUrl(url, maxShards) {
    // Global variable is set by SSR servers when HTTP1.1 traffic is detected
    if (!globalThis[$8fe541edd234eb0b$var$globalKeyName]) return url;
    return $8fe541edd234eb0b$var$shardUrlUnchecked(url, maxShards);
}
const $8fe541edd234eb0b$var$domainShardingKey = module.exports.domainShardingKey = $8fe541edd234eb0b$var$globalKeyName;

});

parcelRegister("1hiTA", function(module, exports) {
$parcel$export(module.exports, "register", () => $0ee60939fdb4dc28$export$6503ec6e8aabbaf, (v) => $0ee60939fdb4dc28$export$6503ec6e8aabbaf = v);
$parcel$export(module.exports, "resolve", () => $0ee60939fdb4dc28$export$f7ad0328861e2f03, (v) => $0ee60939fdb4dc28$export$f7ad0328861e2f03 = v);
var $0ee60939fdb4dc28$export$6503ec6e8aabbaf;
var $0ee60939fdb4dc28$export$f7ad0328861e2f03;
"use strict";
var $0ee60939fdb4dc28$var$mapping = new Map();
function $0ee60939fdb4dc28$var$register(/** @type {string} */ baseUrl, /** @type {Array<string>} */ manifest // ['id', 'path', 'id2', 'path2']
) {
    for(var i = 0; i < manifest.length - 1; i += 2)$0ee60939fdb4dc28$var$mapping.set(manifest[i], {
        baseUrl: baseUrl,
        path: manifest[i + 1]
    });
}
function $0ee60939fdb4dc28$var$resolve(id) {
    var resolved = $0ee60939fdb4dc28$var$mapping.get(id);
    if (resolved == null) throw new Error('Could not resolve bundle with id ' + id);
    return new URL(resolved.path, resolved.baseUrl).toString();
}
$0ee60939fdb4dc28$export$6503ec6e8aabbaf = $0ee60939fdb4dc28$var$register;
$0ee60939fdb4dc28$export$f7ad0328861e2f03 = $0ee60939fdb4dc28$var$resolve;

});

parcelRegister("fHWLA", function(module, exports) {

let $b6f874fccead8370$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $b6f874fccead8370$var$load("6gau7").then(()=>parcelRequire('90bwg'));

});

parcelRegister("7qclg", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $hekY6 = parcelRequire("hekY6");


var $lfoFx = parcelRequire("lfoFx");


var $aDSIl = parcelRequire("aDSIl");


var $7sJoX = parcelRequire("7sJoX");


var $dovdS = parcelRequire("dovdS");


var $eYg5X = parcelRequire("eYg5X");


var $9wGTI = parcelRequire("9wGTI");

const $562183fc931a4366$var$SPINNER_SIZE_MEDIUM = 16; // eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $562183fc931a4366$var$PageTreeItemSpinner = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(13);
    let T0;
    let t1;
    let t2;
    let t3;
    let t4;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t5, style: __cmpls, ...__cmplp } = t0;
        const C = t5 === undefined ? "div" : t5;
        T0 = C;
        t1 = __cmplp;
        t2 = __cmpls;
        t3 = __cmplr;
        t4 = (0, $hekY6.default)([
            "_2XghbEChhn",
            __cmplp.className
        ]);
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = T0;
        $[3] = t1;
        $[4] = t2;
        $[5] = t3;
        $[6] = t4;
    } else {
        T0 = $[2];
        t1 = $[3];
        t2 = $[4];
        t3 = $[5];
        t4 = $[6];
    }
    let t5;
    if ($[7] !== T0 || $[8] !== t1 || $[9] !== t2 || $[10] !== t3 || $[11] !== t4) {
        t5 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(T0, {
            ...t1,
            style: t2,
            ref: t3,
            className: t4
        });
        $[7] = T0;
        $[8] = t1;
        $[9] = t2;
        $[10] = t3;
        $[11] = t4;
        $[12] = t5;
    } else t5 = $[12];
    return t5;
});
const $562183fc931a4366$var$beforeIconStyles = null;
const $562183fc931a4366$var$beforeIconMotionStyles = null;
const $562183fc931a4366$export$89817f2a7aa927f4 = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(12);
    const { item: item, isSuperAdmin: isSuperAdmin, onExpand: onExpand, onCollapse: onCollapse } = t0;
    const { isChildrenLoading: isChildrenLoading, hasChildren: hasChildren, isExpanded: isExpanded, hasRestrictions: hasRestrictions, hasInheritedRestrictions: hasInheritedRestrictions } = item;
    const shouldDisplayRed = Boolean(!!isSuperAdmin && (hasRestrictions || hasInheritedRestrictions));
    let t1;
    if ($[0] !== onExpand) {
        t1 = (event)=>{
            (0, $eYg5X.default)("page-tree-item-expand", event.timeStamp);
            onExpand(event);
        };
        $[0] = onExpand;
        $[1] = t1;
    } else t1 = $[1];
    const handleOnExpand = t1;
    let t2;
    if ($[2] !== onCollapse) {
        t2 = (event_0)=>{
            (0, $eYg5X.default)("page-tree-item-collapse", event_0.timeStamp);
            onCollapse(event_0);
        };
        $[2] = onCollapse;
        $[3] = t2;
    } else t2 = $[3];
    const handleOnCollapse = t2;
    const iconColor = shouldDisplayRed ? "var(--ds-icon-danger, #C9372C)" : undefined;
    if (isChildrenLoading) {
        let t3;
        if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($562183fc931a4366$var$PageTreeItemSpinner, {
                "data-testid": "tree-item-spinner"
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
                size: $562183fc931a4366$var$SPINNER_SIZE_MEDIUM
            }));
            $[4] = t3;
        } else t3 = $[4];
        return t3;
    }
    if (hasChildren || item.data.type === "folder") {
        let t3;
        if ($[5] !== handleOnCollapse || $[6] !== handleOnExpand || $[7] !== iconColor || $[8] !== isExpanded || $[9] !== item.id) {
            t3 = isExpanded ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
                onClick: handleOnCollapse,
                "data-testid": "chevron-down",
                "data-no-global-anchor-handler": true,
                "aria-expanded": isExpanded,
                "aria-labelledby": item.id,
                className: (0, $hekY6.default)([
                    "_30huDKYbGa _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _0bjKvDzXzM _23rrnHyKLB _42Yu6B7dHp _3iDTPbQ4SZ _0KLXrujOvk _0wOv4Q7zJH _0jFU0VNHnM _39xV02NHnM _0hPCNLDIqT _37wbyuDIqT _1UtDYzZpcK _1eOmH6o126",
                    (0, $9wGTI.fg)("platform-dst-motion-uplift-custom-button") && "_23rrnHyKLB"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($7sJoX))), {
                color: iconColor,
                label: "",
                size: "small"
            })) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("button", {
                onClick: handleOnExpand,
                "data-testid": "chevron-right",
                "data-no-global-anchor-handler": true,
                "aria-expanded": isExpanded,
                "aria-labelledby": item.id,
                className: (0, $hekY6.default)([
                    "_30huDKYbGa _313842dnbC _0adFHsdnbC _1DCdHidnbC _2XsHFMdnbC _0Of8r2dnbC _1ZnuxbdnbC _1wydGWdnbC _2Zuz6QdnbC _00uqCY98eZ _3xtjKNYbGa _0H9qDF6wH8 _0bjKvDzXzM _23rrnHyKLB _42Yu6B7dHp _3iDTPbQ4SZ _0KLXrujOvk _0wOv4Q7zJH _0jFU0VNHnM _39xV02NHnM _0hPCNLDIqT _37wbyuDIqT _1UtDYzZpcK _1eOmH6o126",
                    (0, $9wGTI.fg)("platform-dst-motion-uplift-custom-button") && "_23rrnHyKLB"
                ])
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($aDSIl))), {
                color: iconColor,
                label: "",
                size: "small"
            }));
            $[5] = handleOnCollapse;
            $[6] = handleOnExpand;
            $[7] = iconColor;
            $[8] = isExpanded;
            $[9] = item.id;
            $[10] = t3;
        } else t3 = $[10];
        return t3;
    }
    let t3;
    if ($[11] === Symbol.for("react.memo_cache_sentinel")) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($dovdS))), {
            label: "",
            color: "var(--ds-text-subtle, #505258)"
        });
        $[11] = t3;
    } else t3 = $[11];
    return t3;
});
module.exports["BeforeIcon"] = $562183fc931a4366$export$89817f2a7aa927f4;

});

parcelRegister("lUMkS", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $3u5lg = parcelRequire("3u5lg");


var $6SsN4 = parcelRequire("6SsN4");


var $g6KTr = parcelRequire("g6KTr");


var $h11I1 = parcelRequire("h11I1");


var $422HI = parcelRequire("422HI");


var $e4o8D = parcelRequire("e4o8D");


var $6mKj3 = parcelRequire("6mKj3");


var $di8q4 = parcelRequire("di8q4");


var $3Xs1I = parcelRequire("3Xs1I");

var $c0urc = parcelRequire("c0urc");


var $jmjWc = parcelRequire("jmjWc");


var $ep3mz = parcelRequire("ep3mz");


var $ficwO = parcelRequire("ficwO");


var $2vuKf = parcelRequire("2vuKf");


var $1NBp8 = parcelRequire("1NBp8");


var $7zgzO = parcelRequire("7zgzO");

/**
 * @generated SignedSource<<e88be0a0f47ceafecf65f9838fd660e1>>
 * @relayHash c4df84ea0fb09cca4d217d3f3b1e6526
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 9dcd3c7b3dba0bc2788ae9ccaa6f4ea9319b527b9306aeb8643830dc382a94fc
const $eaeaab3296b1b924$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "action"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "action",
                    "variableName": "action"
                },
                {
                    "kind": "Variable",
                    "name": "contentId",
                    "variableName": "contentId"
                }
            ],
            "concreteType": "DeleteContentResponsePayload",
            "kind": "LinkedField",
            "name": "deleteContent",
            "plural": false,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "contentId"
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeSmartLinkDropMonitorDeleteMutation",
            "selections": v2 /*: any*/ ,
            "type": "Mutation"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v0 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeSmartLinkDropMonitorDeleteMutation",
            "selections": v2 /*: any*/ 
        },
        "params": {
            "cacheID": "c4df84ea0fb09cca4d217d3f3b1e6526",
            "id": "9dcd3c7b3dba0bc2788ae9ccaa6f4ea9319b527b9306aeb8643830dc382a94fc",
            "metadata": {},
            "name": "PageTreeSmartLinkDropMonitorDeleteMutation",
            "operationKind": "mutation",
            "text": "mutation PageTreeSmartLinkDropMonitorDeleteMutation($contentId:ID!,$action:ContentDeleteActionType!){deleteContent(contentId:$contentId,action:$action){contentId}}"
        }
    };
}();
$eaeaab3296b1b924$var$node.hash = "03dea5e17e424646c6535f7b61c07883";
var $eaeaab3296b1b924$export$2e2bcd8739ae039 = $eaeaab3296b1b924$var$node;









var $iIYTj = parcelRequire("iIYTj");


var $9DHhW = parcelRequire("9DHhW");


var $4Vdlk = parcelRequire("4Vdlk");


var $51Cpe = parcelRequire("51Cpe");


var $308Wd = parcelRequire("308Wd");


var $Wsgbu = parcelRequire("Wsgbu");


var $gMtye = parcelRequire("gMtye");

const $492ff87f1027b57e$var$VIRTUAL_ROOT_IDS = new Set([
    'VIRTUAL_ROOT_ID',
    'VIRTUAL_LOCAL_ROOT_ID'
]);
const $492ff87f1027b57e$var$i18n = (0, $kSwu1.defineMessages)({
    successTitle: {
        id: "smart-link-droppable.drop-monitor.success.title",
        defaultMessage: "\"{title}\" added to content tree"
    },
    successTitleFallback: {
        id: "smart-link-droppable.drop-monitor.success.title-fallback",
        defaultMessage: "Link added to content tree"
    },
    undoAction: {
        id: "smart-link-droppable.drop-monitor.success.undo",
        defaultMessage: "Undo"
    },
    undoSuccessTitle: {
        id: "smart-link-droppable.drop-monitor.undo-success.title",
        defaultMessage: "Smart link removed"
    },
    errorTitle: {
        id: "smart-link-droppable.drop-monitor.error.title",
        defaultMessage: "We're unable to create right now"
    },
    errorDescription: {
        id: "smart-link-droppable.drop-monitor.error.description",
        defaultMessage: "Refresh or wait a few minutes and try again. If this keeps happening, contact support."
    }
});
function $492ff87f1027b57e$export$2a8966ce55c8c689({ spaceKey: spaceKey, flags: flags, onInsert: onInsert, onDelete: onDelete }) {
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const { formatMessage: formatMessage } = (0, $kSwu1.useIntl)();
    const [commitMutation] = (0, $308Wd.useMutationInterop)((0, $eaeaab3296b1b924$export$2e2bcd8739ae039), {
        __callerPackage__: "smart-link-droppable"
    });
    const deleteSmartLinkEmbed = (0, $cozmU.useCallback)((contentId)=>{
        return commitMutation({
            variables: {
                contentId: contentId,
                action: 'MOVE_TO_TRASH'
            }
        });
    }, [
        commitMutation
    ]);
    const handleUndoSmartLinkEmbed = (0, $cozmU.useCallback)((contentId)=>{
        createAnalyticsEvent({
            type: 'sendUIEvent',
            data: {
                action: 'clicked',
                actionSubject: 'button',
                actionSubjectId: 'smartLinkDragDropUndo',
                source: (0, $gMtye.SMART_LINK_DND_ANALYTICS_SOURCE),
                attributes: {
                    dropTarget: 'contentTree'
                }
            }
        }).fire();
        onDelete(contentId);
        deleteSmartLinkEmbed(contentId).then(()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleted',
                    actionSubject: 'smartLink',
                    source: (0, $gMtye.SMART_LINK_DND_ANALYTICS_SOURCE),
                    attributes: {
                        dropTarget: 'contentTree'
                    }
                }
            }).fire();
            if (flags) flags.showSuccessFlag({
                title: formatMessage($492ff87f1027b57e$var$i18n.undoSuccessTitle),
                isAutoDismiss: true
            });
        }).catch(()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'deleteFailed',
                    actionSubject: 'smartLink',
                    source: (0, $gMtye.SMART_LINK_DND_ANALYTICS_SOURCE),
                    attributes: {
                        dropTarget: 'contentTree'
                    }
                }
            }).fire();
            if (flags) flags.showErrorFlag({
                title: formatMessage($492ff87f1027b57e$var$i18n.errorTitle),
                description: formatMessage($492ff87f1027b57e$var$i18n.errorDescription),
                isAutoDismiss: true
            });
        });
    }, [
        createAnalyticsEvent,
        deleteSmartLinkEmbed,
        flags,
        formatMessage,
        onDelete
    ]);
    const handleSmartLinkEmbedDrop = (0, $cozmU.useCallback)(({ url: url, title: title, iconUrl: iconUrl, parentId: parentId, instruction: instruction, dropTargetId: dropTargetId })=>{
        (0, $Wsgbu.createSmartLinkEmbedContent)({
            createAnalyticsEvent: createAnalyticsEvent,
            spaceKey: spaceKey,
            parentId: $492ff87f1027b57e$var$VIRTUAL_ROOT_IDS.has(parentId) ? undefined : parentId,
            embedUrl: url
        }).then(async (result)=>{
            const contentId = result.contentId;
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'created',
                    actionSubject: 'smartLink',
                    source: (0, $gMtye.SMART_LINK_DND_ANALYTICS_SOURCE),
                    attributes: {
                        dropTarget: 'contentTree',
                        ...result.analyticsAttributes
                    }
                }
            }).fire();
            if (contentId) {
                const position = instruction && (instruction.type === 'reorder-above' || instruction.type === 'reorder-below') ? {
                    siblingId: dropTargetId,
                    placement: instruction.type === 'reorder-above' ? 'before' : 'after'
                } : undefined;
                onInsert({
                    contentId: contentId,
                    parentId: parentId,
                    title: title,
                    url: url,
                    iconUrl: iconUrl,
                    position: position
                });
            }
            if (flags) flags.showSuccessFlag({
                id: 'smartLinkDropFlag',
                title: title ? formatMessage($492ff87f1027b57e$var$i18n.successTitle, {
                    title: title
                }) : formatMessage($492ff87f1027b57e$var$i18n.successTitleFallback),
                isAutoDismiss: true,
                actions: contentId ? [
                    {
                        content: formatMessage($492ff87f1027b57e$var$i18n.undoAction),
                        onClick: ()=>{
                            handleUndoSmartLinkEmbed(contentId);
                            flags.hideFlag('smartLinkDropFlag');
                        }
                    }
                ] : undefined
            });
        }).catch(()=>{
            createAnalyticsEvent({
                type: 'sendTrackEvent',
                data: {
                    action: 'createFailed',
                    actionSubject: 'smartLink',
                    source: (0, $gMtye.SMART_LINK_DND_ANALYTICS_SOURCE),
                    attributes: {
                        dropTarget: 'contentTree'
                    }
                }
            }).fire();
            if (flags) flags.showErrorFlag({
                title: formatMessage($492ff87f1027b57e$var$i18n.errorTitle),
                description: formatMessage($492ff87f1027b57e$var$i18n.errorDescription),
                isAutoDismiss: true
            });
        });
    }, [
        createAnalyticsEvent,
        flags,
        formatMessage,
        handleUndoSmartLinkEmbed,
        onInsert,
        spaceKey
    ]);
    (0, $cozmU.useEffect)(()=>{
        return (0, $4Vdlk.monitorForElements)({
            canMonitor: ({ source: source })=>(0, $iIYTj.isSmartLinkDrag)(source.data.type) || !!source.data.url && !!source.data.appearance,
            onDragStart: ()=>{
                createAnalyticsEvent({
                    type: 'sendUIEvent',
                    data: {
                        action: 'dragged',
                        actionSubject: 'smartLink',
                        source: (0, $gMtye.SMART_LINK_DND_ANALYTICS_SOURCE)
                    }
                }).fire();
            },
            onDrop: ({ source: source, location: location })=>{
                const { url: url, title: title, iconUrl: iconUrl } = source.data;
                const truncatedTitle = title && title.length > (0, $Wsgbu.MAX_SMART_LINK_EMBED_TITLE_LENGTH) ? `${title.slice(0, (0, $Wsgbu.MAX_SMART_LINK_EMBED_TITLE_LENGTH) - 3)}...` : title;
                const dropTarget = location?.current?.dropTargets[0];
                if (!url || !dropTarget || !dropTarget.data.id) {
                    createAnalyticsEvent({
                        type: 'sendUIEvent',
                        data: {
                            action: 'drop cancelled',
                            actionSubject: 'smartLink',
                            source: (0, $gMtye.SMART_LINK_DND_ANALYTICS_SOURCE)
                        }
                    }).fire();
                    return;
                }
                const instruction = (0, $51Cpe.extractInstruction)(dropTarget.data);
                const dropTargetId = dropTarget.data.id;
                let parentId;
                if (instruction && (instruction.type === 'reorder-above' || instruction.type === 'reorder-below')) parentId = dropTarget.data.parentId;
                else parentId = dropTargetId;
                handleSmartLinkEmbedDrop({
                    url: url,
                    title: truncatedTitle,
                    iconUrl: iconUrl,
                    parentId: parentId,
                    instruction: instruction,
                    dropTargetId: dropTargetId
                });
            }
        });
    }, [
        createAnalyticsEvent,
        handleSmartLinkEmbedDrop
    ]);
    return null;
}



var $jMyy4 = parcelRequire("jMyy4");


var $ftFOj = parcelRequire("ftFOj");


var $3aAh8 = parcelRequire("3aAh8");


var $k0x5M = parcelRequire("k0x5M");














var $7Sm4c = parcelRequire("7Sm4c");




const $a5d73907e88ffc90$export$2cce9f4627a56f63 = (pages, sourceId)=>Object.keys(pages).find((id)=>{
        const item = pages[id];
        const data = item?.data;
        return data?.hasSyntheticChild || item?.children?.includes(sourceId);
    });
const $a5d73907e88ffc90$export$72ba146c08ba1e60 = (error)=>{
    const maybeError = error;
    const maybeExtensions = maybeError?.extensions;
    let errorCode = 'unknown';
    if (typeof maybeExtensions?.errorType === 'string') errorCode = maybeExtensions.errorType;
    else if (typeof maybeExtensions?.code === 'string') errorCode = maybeExtensions.code;
    let errorName = 'unknown';
    if (typeof maybeError?.name === 'string') errorName = maybeError.name;
    else if (typeof error === 'string') errorName = 'string';
    return {
        errorName: errorName,
        errorCode: errorCode
    };
};
const $a5d73907e88ffc90$export$bbe5c57e0c1ae474 = ({ queryChildren: queryChildren, onExpansionFailure: onExpansionFailure })=>{
    return async (...args)=>{
        try {
            const result = await queryChildren(...args);
            if (result.error) {
                (0, $7Sm4c.markErrorAsHandled)(result.error);
                onExpansionFailure(result.error);
            }
            return result;
        } catch (error) {
            (0, $7Sm4c.markErrorAsHandled)(error);
            onExpansionFailure(error);
            return {
                nodes: [],
                error: error
            };
        }
    };
};
const $a5d73907e88ffc90$export$e3d42b19cdde07d4 = async ({ destinationPage: destinationPage, targetParentId: targetParentId, sourceId: sourceId, actions: actions, queryChildren: queryChildren, isMountedRef: isMountedRef, autoMoveRef: autoMoveRef, getCancelled: getCancelled, createAnalyticsEvent: createAnalyticsEvent })=>{
    const fireAutoMoveExpansionFailureEvent = (error)=>{
        createAnalyticsEvent({
            type: 'sendOperationalEvent',
            data: {
                action: 'failed',
                actionSubject: 'pageTreeRovoSuggestedParentAutoMoveExpansion',
                source: 'movePageDialog',
                attributes: $a5d73907e88ffc90$export$72ba146c08ba1e60(error)
            }
        }).fire();
    };
    try {
        if ((0, $k0x5M.isManagedFolder)(destinationPage.data) || destinationPage.data.status === 'DRAFT') return;
        if (destinationPage.hasChildren && !actions.getState().expandedPages.has(targetParentId)) {
            try {
                const queryChildrenWithExpansionFailureEvent = $a5d73907e88ffc90$export$bbe5c57e0c1ae474({
                    queryChildren: queryChildren,
                    onExpansionFailure: fireAutoMoveExpansionFailureEvent
                });
                await actions.expandPage(destinationPage, queryChildrenWithExpansionFailureEvent);
            } catch (error) {
                // Destination expansion is best effort; the item can still move into the parent. Mark
                // the error as handled so an expandPage rejection that bypasses the wrapped queryChildren
                // path is not double-reported via the global error boundary.
                (0, $7Sm4c.markErrorAsHandled)(error);
                fireAutoMoveExpansionFailureEvent(error);
            }
            if (getCancelled()) return;
        }
        const { pages: currentPages } = actions.getState();
        const currentSourceParentId = $a5d73907e88ffc90$export$2cce9f4627a56f63(currentPages, sourceId);
        if (!currentSourceParentId || currentSourceParentId === targetParentId) return;
        const index = currentPages[currentSourceParentId]?.children?.indexOf(sourceId) ?? -1;
        if (index === -1) return;
        if (!isMountedRef.current) return;
        if (autoMoveRef.current.parentId !== targetParentId) return;
        actions.movePageInState(sourceId, {
            parentId: currentSourceParentId,
            index: index
        }, {
            parentId: targetParentId,
            index: 0
        }, queryChildren, true);
    } finally{
        if (!getCancelled() && autoMoveRef.current.parentId === targetParentId) autoMoveRef.current.phase = 'done';
    }
};
const $a5d73907e88ffc90$export$b63d3cf443da8a6c = (t0)=>{
    const $ = (0, $bDgLe.c)(18);
    const { isMovePageTree: isMovePageTree, moveToParentId: moveToParentId, syntheticItem: syntheticItem, actions: actions, queryChildren: queryChildren, isMountedRef: isMountedRef, pages: pages } = t0;
    let t1;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = {
            parentId: null,
            phase: "pending"
        };
        $[0] = t1;
    } else t1 = $[0];
    const autoMoveRef = (0, $cozmU.useRef)(t1);
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    let t2;
    if ($[1] !== actions || $[2] !== createAnalyticsEvent || $[3] !== isMountedRef || $[4] !== isMovePageTree || $[5] !== moveToParentId || $[6] !== queryChildren || $[7] !== syntheticItem) {
        t2 = ()=>{
            if (!(0, $6mKj3.expVal)("confluence_rovo_suggested_parent_move_dialog_spark", "isEnabled", false) || !isMovePageTree || !moveToParentId || !syntheticItem) {
                autoMoveRef.current = {
                    parentId: null,
                    phase: "pending"
                };
                return;
            }
            if (autoMoveRef.current.parentId !== moveToParentId) autoMoveRef.current = {
                parentId: moveToParentId,
                phase: "pending"
            };
            if (autoMoveRef.current.phase !== "pending") return;
            const { pages: latestPages } = actions.getState();
            const destinationPage = latestPages[moveToParentId];
            if (!destinationPage) return;
            const sourceId = syntheticItem.id;
            const sourceParentId = $a5d73907e88ffc90$export$2cce9f4627a56f63(latestPages, sourceId);
            if (!sourceParentId) return;
            autoMoveRef.current.phase = "running";
            const targetParentId = moveToParentId;
            let cancelled = false;
            $a5d73907e88ffc90$export$e3d42b19cdde07d4({
                destinationPage: destinationPage,
                targetParentId: targetParentId,
                sourceId: sourceId,
                actions: actions,
                queryChildren: queryChildren,
                isMountedRef: isMountedRef,
                autoMoveRef: autoMoveRef,
                getCancelled: ()=>cancelled,
                createAnalyticsEvent: createAnalyticsEvent
            });
            return ()=>{
                cancelled = true;
                if (autoMoveRef.current.parentId === targetParentId && autoMoveRef.current.phase === "running") autoMoveRef.current.phase = "pending";
            };
        };
        $[1] = actions;
        $[2] = createAnalyticsEvent;
        $[3] = isMountedRef;
        $[4] = isMovePageTree;
        $[5] = moveToParentId;
        $[6] = queryChildren;
        $[7] = syntheticItem;
        $[8] = t2;
    } else t2 = $[8];
    let t3;
    if ($[9] !== actions || $[10] !== createAnalyticsEvent || $[11] !== isMountedRef || $[12] !== isMovePageTree || $[13] !== moveToParentId || $[14] !== pages || $[15] !== queryChildren || $[16] !== syntheticItem) {
        t3 = [
            isMovePageTree,
            moveToParentId,
            pages,
            syntheticItem,
            actions,
            queryChildren,
            isMountedRef,
            createAnalyticsEvent
        ];
        $[9] = actions;
        $[10] = createAnalyticsEvent;
        $[11] = isMountedRef;
        $[12] = isMovePageTree;
        $[13] = moveToParentId;
        $[14] = pages;
        $[15] = queryChildren;
        $[16] = syntheticItem;
        $[17] = t3;
    } else t3 = $[17];
    (0, $cozmU.useEffect)(t2, t3);
};



var $jGj7w = parcelRequire("jGj7w");


var $9rjMR = parcelRequire("9rjMR");

/* PageTreeComponent.tsx generated by @compiled/babel-plugin v3.0.2 */ 



var $hekY6 = parcelRequire("hekY6");





var $ad7Ou = parcelRequire("ad7Ou");


var $lfoFx = parcelRequire("lfoFx");


var $3izAL = parcelRequire("3izAL");


var $buxP3 = parcelRequire("buxP3");


var $lY1lm = parcelRequire("lY1lm");


var $4BeGP = parcelRequire("4BeGP");


var $luv00 = parcelRequire("luv00");


var $5Abqh = parcelRequire("5Abqh");


var $gAsUX = parcelRequire("gAsUX");

'use no memo';
function $1a3215c7f6382f73$var$_defineProperty(e, r, t) {
    return (r = $1a3215c7f6382f73$var$_toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
        value: t,
        enumerable: !0,
        configurable: !0,
        writable: !0
    }) : e[r] = t, e;
}
function $1a3215c7f6382f73$var$_toPropertyKey(t) {
    var i = $1a3215c7f6382f73$var$_toPrimitive(t, "string");
    return "symbol" == typeof i ? i : i + "";
}
function $1a3215c7f6382f73$var$_toPrimitive(t, r) {
    if ("object" != typeof t || !t) return t;
    var e = t[Symbol.toPrimitive];
    if (void 0 !== e) {
        var i = e.call(t, r || "default");
        if ("object" != typeof i) return i;
        throw new TypeError("@@toPrimitive must return a primitive value.");
    }
    return ("string" === r ? String : Number)(t);
}
const $1a3215c7f6382f73$var$INDENT_PER_LEVEL = 12;
const $1a3215c7f6382f73$var$INDENT_PER_LEVEL_NAV_3 = 16; // Container to expand Page tree to the remaining space
// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $1a3215c7f6382f73$var$AkTreeContainerFlex = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_2O5Vij7dHp _3YEZNOdnbC _39xV02N91d _3iDTPbQ4SZ _0aFT5vbt8w _1z0ZYF7dHp _0L0Mq3N91d",
            __cmplp.className
        ])
    });
}); // SPINNER_SIZE + 8px => to match the medium (24px) chevron.
const $1a3215c7f6382f73$var$LoadMorePagesButtonWrapper = /*#__PURE__*/ (0, $cozmU.forwardRef)(({ as: C = "div", style: __cmpls, ...__cmplp }, __cmplr)=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
        ...__cmplp,
        style: __cmpls,
        ref: __cmplr,
        className: (0, $hekY6.default)([
            "_313842uFDC _0adFHsdnbC _1DCdHiuFDC _2XsHFMdnbC _39xV02N91d",
            __cmplp.className
        ])
    });
});
const $1a3215c7f6382f73$var$inlineTreeSpinnerStyles = (0, $buxP3.xcss)({
    width: '100%',
    minHeight: '24px',
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
    flexGrow: 1
});
const $1a3215c7f6382f73$var$pageTreeContainerCSS = null;
const $1a3215c7f6382f73$var$pageTreeContainerLoadingCSS = null;
const $1a3215c7f6382f73$var$pageTreeDropTargetVerticalInset = "var(--ds-space-050, 4px)";
const $1a3215c7f6382f73$var$pageTreeDropTargetHorizontalInset = `calc(${"var(--ds-space-100, 8px)"} + ${"var(--ds-space-025, 2px)"})`; // To align the page tree's wrapper with shortcuts drop wrapper
const $1a3215c7f6382f73$var$pageTreeDropTargetCSS = null;
const $1a3215c7f6382f73$var$StyledPageTreeContainer = ({ children: children, loading: loading })=>{
    const ssrPlaceholderIdProp = (0, $luv00.useSSRPlaceholderReplaceIdProp)();
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("div", {
        "data-testid": "page-tree-container",
        "data-vc": "page-tree-container",
        id: "page-tree-container",
        ...ssrPlaceholderIdProp,
        className: (0, $hekY6.default)([
            "_3iDTPbQ4SZ _0aFT5vbt8w _2O5Vij7dHp _3YEZNOdnbC _0hPCNLchRC",
            loading && "_1YKVNsXvJ3 _1pp6NdYbGa _0wOv4Qsyl5"
        ])
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $gAsUX.SmartLinkDropTarget), {
        hideHoveredEdgeBorder: true,
        className: (0, $hekY6.default)([
            "_313842QPN6 _0adFHsoJRo _1DCdHiQPN6 _2XsHFMoJRo _0Of8r21Y8M _1Znuxb8O5V _1wydGW1Y8M _2Zuz6Q8O5V"
        ])
    }, children));
};
const $1a3215c7f6382f73$var$InlineTreePaginationSpinner = ()=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
        xcss: $1a3215c7f6382f73$var$inlineTreeSpinnerStyles
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lfoFx.default), {
        size: "medium",
        testId: "page-tree-loading"
    }));
const $1a3215c7f6382f73$var$LoadPreviousPagesButton = /*#__PURE__*/ (0, $cozmU.memo)(({ loadMorePages: loadMorePages })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a3215c7f6382f73$var$LoadMorePagesButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        shouldFitContainer: true,
        spacing: "compact",
        onClick: loadMorePages
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "page-tree.pages.show.more.above",
        defaultMessage: "Show more above"
    })));
});
const $1a3215c7f6382f73$var$LoadFollowingPagesButton = /*#__PURE__*/ (0, $cozmU.memo)(({ loadMorePages: loadMorePages })=>{
    return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a3215c7f6382f73$var$LoadMorePagesButtonWrapper, null, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $ad7Ou.default), {
        shouldFitContainer: true,
        spacing: "compact",
        onClick: loadMorePages
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "page-tree.pages.show.more.below",
        defaultMessage: "Show more below"
    })));
}); /**
     * This is a purely presentational component. Please don't add any
     * non-presentational logic _directly_ to this component - use optional
     * callback props instead.
     */ 
class $1a3215c7f6382f73$export$330dddbe7c08afed extends (0, $cozmU.PureComponent) {
    componentDidMount() {
        const { tree: tree } = this.props;
        if (Object.keys(tree.items).length) {
            this.props.onInitialLoadComplete?.(Object.keys(tree.items).length);
            this.onInitialLoadCompleteSubmitted = true;
        }
    }
    componentDidUpdate(prevProps) {
        if (this.onInitialLoadCompleteSubmitted) return;
        const { tree: tree } = this.props;
        const justFinishedLoading = prevProps.loading && !this.props.loading || window.__SSR_RENDERED__;
        if (justFinishedLoading) {
            this.props.onInitialLoadComplete?.(Object.keys(tree.items).length);
            this.onInitialLoadCompleteSubmitted = true;
        }
    }
    render() {
        const { tree: tree, loadPreviousPages: loadPreviousPages, loadFollowingPages: loadFollowingPages, isTreeTruncatedPrevious: isTreeTruncatedPrevious, isTreeTruncatedFollowing: isTreeTruncatedFollowing, isDraggable: isDraggable, dragPreview: dragPreview, loading: loading, isNav4Enabled: isNav4Enabled } = this.props;
        return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a3215c7f6382f73$var$StyledPageTreeContainer, {
            loading: loading
        }, !isTreeTruncatedPrevious && !isTreeTruncatedFollowing && loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a3215c7f6382f73$var$InlineTreePaginationSpinner, null), isTreeTruncatedPrevious && (!loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a3215c7f6382f73$var$LoadPreviousPagesButton, {
            loadMorePages: loadPreviousPages
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a3215c7f6382f73$var$InlineTreePaginationSpinner, null)), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a3215c7f6382f73$var$AkTreeContainerFlex, {
            "data-testid": "tree-container-flex"
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $4BeGP.Tree), {
            tree: tree,
            isDragEnabled: isDraggable,
            onDragBlocked: this.props.onDragBlocked,
            renderItem: this.props.renderItem,
            renderItemEmptyState: this.props.renderItemEmptyState,
            onExpand: this.expandPage,
            onCollapse: this.collapsePage,
            onDragStart: this.props.onDragStart,
            onDragEnd: this.dragEnd,
            dragPreview: dragPreview,
            indentPerLevel: isNav4Enabled ? $1a3215c7f6382f73$var$INDENT_PER_LEVEL : $1a3215c7f6382f73$var$INDENT_PER_LEVEL_NAV_3
        }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lY1lm.TreeMonitorLoader), {
            setIsDraggingItem: this.props.setIsDraggingItem
        })), isTreeTruncatedFollowing && (!loading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a3215c7f6382f73$var$LoadFollowingPagesButton, {
            loadMorePages: loadFollowingPages
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($1a3215c7f6382f73$var$InlineTreePaginationSpinner, null)), !loading && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $5Abqh.SetSSRPartialSuccess), {
            name: (0, $5Abqh.SSR_PARTIAL_COMPONENT).PageTree
        }));
    }
    constructor(...args){
        super(...args);
        $1a3215c7f6382f73$var$_defineProperty(this, "onInitialLoadCompleteSubmitted", false);
        $1a3215c7f6382f73$var$_defineProperty(this, "collapsePage", (pageId)=>{
            const { tree: tree, onCollapse: onCollapse } = this.props;
            onCollapse(tree.items[pageId]);
        });
        $1a3215c7f6382f73$var$_defineProperty(this, "expandPage", (pageId)=>{
            const { tree: tree, onExpand: onExpand } = this.props;
            onExpand(tree.items[pageId]);
        });
        $1a3215c7f6382f73$var$_defineProperty(this, "dragEnd", async (source, destination, instruction)=>{
            const { onDragEnd: onDragEnd } = this.props;
            onDragEnd(source, destination, instruction);
        });
    }
}






var $9wGTI = parcelRequire("9wGTI");





var $9eCf8 = parcelRequire("9eCf8");

/**
 * @generated SignedSource<<92cfa7340fb517eabb9be6bddb70fe72>>
 * @relayHash 09fa6b69b6ecabf69f28c3d20846542c
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 046e70b0a3f96051db04e76206595f6c4fba9a2ca64560160ae4a0685d1b4f0a
const $93d715cfc896c3c6$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "kind": "ScalarField",
        "name": "value"
    }, v8 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "MILLIS"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": [
            v7 /*: any*/ 
        ],
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v9 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v10 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v11 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v12 = {
        "kind": "ScalarField",
        "name": "type"
    }, v13 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v14 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v15 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    v7 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
    }, v16 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "pageTree",
                    "variableName": "paginationLimit"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "ptStatuses"
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "followingSiblings",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v4 /*: any*/ ,
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v15 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                }
                            ]
                        }
                    ]
                }
            ]
        },
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "key",
                    "variableName": "spaceKey"
                }
            ],
            "concreteType": "Space",
            "kind": "LinkedField",
            "name": "space",
            "plural": false,
            "selections": [
                v4 /*: any*/ ,
                {
                    "concreteType": "Content",
                    "kind": "LinkedField",
                    "name": "homepage",
                    "plural": false,
                    "selections": [
                        v4 /*: any*/ 
                    ]
                },
                {
                    "concreteType": "OperationCheckResult",
                    "kind": "LinkedField",
                    "name": "operations",
                    "plural": true,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "operation"
                        },
                        {
                            "kind": "ScalarField",
                            "name": "targetType"
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeRootLevelQuery",
            "selections": v16 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v3 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeRootLevelQuery",
            "selections": v16 /*: any*/ 
        },
        "params": {
            "cacheID": "09fa6b69b6ecabf69f28c3d20846542c",
            "id": "046e70b0a3f96051db04e76206595f6c4fba9a2ca64560160ae4a0685d1b4f0a",
            "metadata": {},
            "name": "PageTreeRootLevelQuery",
            "operationKind": "query",
            "text": "query PageTreeRootLevelQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$isSuperAdmin:Boolean!,$paginationLimit:Int){ptpage(spaceKey:$spaceKey,status:$ptStatuses,pageTree:$paginationLimit){id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},followingSiblings{nodes{id,title,status,createdDate(format:MILLIS){value},hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}},space(key:$spaceKey){id,homepage{id},operations{operation,targetType}}}"
        }
    };
}();
$93d715cfc896c3c6$var$node.hash = "1d326a119d28d4c0f9ae0adb18f61cbc";
var $93d715cfc896c3c6$export$2e2bcd8739ae039 = $93d715cfc896c3c6$var$node;



var $1oGPE = parcelRequire("1oGPE");








var $2qvBe = parcelRequire("2qvBe");





var $9eE57 = parcelRequire("9eE57");

/**
 * @generated SignedSource<<676a931533f5c69f833d897b6797b00e>>
 * @relayHash 721de05816b4a23d4956957fad6733b2
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 7c1ca0f9ddc2648482e7ea8ed8bbfef84a3c38973644e78dc2f1db27d9257083
const $a1f6f5e5f6be4295$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "kind": "ScalarField",
        "name": "status"
    }, v8 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v9 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v10 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v13 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
    }, v15 = {
        "concreteType": "PTPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v16 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": [
            {
                "concreteType": "PTPage",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v6 /*: any*/ ,
                    v7 /*: any*/ ,
                    v8 /*: any*/ ,
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v14 /*: any*/ 
                ]
            },
            v15 /*: any*/ 
        ]
    }, v17 = [
        {
            "alias": "currentPage",
            "args": [
                {
                    "kind": "Literal",
                    "name": "enablePaging",
                    "value": true
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "pageTree",
                    "variableName": "paginationLimit"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "ptStatuses"
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ ,
                                v16 /*: any*/ 
                            ]
                        }
                    ]
                },
                v16 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreePreviousItemsQuery",
            "selections": v17 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreePreviousItemsQuery",
            "selections": v17 /*: any*/ 
        },
        "params": {
            "cacheID": "721de05816b4a23d4956957fad6733b2",
            "id": "7c1ca0f9ddc2648482e7ea8ed8bbfef84a3c38973644e78dc2f1db27d9257083",
            "metadata": {},
            "name": "PageTreePreviousItemsQuery",
            "operationKind": "query",
            "text": "query PageTreePreviousItemsQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$contentId:ID!,$paginationLimit:Int,$isSuperAdmin:Boolean!){currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage},nodes{id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},previousSiblings{nodes{id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}},previousSiblings{nodes{id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}}"
        }
    };
}();
$a1f6f5e5f6be4295$var$node.hash = "4d500f939ab5ebf8e00183c0d9277bcf";
var $a1f6f5e5f6be4295$export$2e2bcd8739ae039 = $a1f6f5e5f6be4295$var$node;


/**
 * @generated SignedSource<<2d9590d705ff7416fcbbefe55f0f082a>>
 * @relayHash 37c794da865172d609c23565f793e233
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID acc71c1cc1e805fd4f6e7e71f984116c1e247bcb4c88e72d79072f118f5d4c40
const $56adeec417a0fbae$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "paginationLimit"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "ptStatuses"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "spaceKey"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "kind": "ScalarField",
        "name": "status"
    }, v8 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v9 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v10 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v13 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
    }, v15 = {
        "concreteType": "PTPageInfo",
        "kind": "LinkedField",
        "name": "pageInfo",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasNextPage"
            }
        ]
    }, v16 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": [
            {
                "concreteType": "PTPage",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    v6 /*: any*/ ,
                    v7 /*: any*/ ,
                    v8 /*: any*/ ,
                    v9 /*: any*/ ,
                    v10 /*: any*/ ,
                    v11 /*: any*/ ,
                    v12 /*: any*/ ,
                    v13 /*: any*/ ,
                    v14 /*: any*/ 
                ]
            },
            v15 /*: any*/ 
        ]
    }, v17 = [
        {
            "alias": "currentPage",
            "args": [
                {
                    "kind": "Literal",
                    "name": "enablePaging",
                    "value": true
                },
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "pageTree",
                    "variableName": "paginationLimit"
                },
                {
                    "kind": "Variable",
                    "name": "spaceKey",
                    "variableName": "spaceKey"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "ptStatuses"
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                {
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "nearestAncestors",
                    "plural": false,
                    "selections": [
                        v15 /*: any*/ ,
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v16 /*: any*/ ,
                                v5 /*: any*/ 
                            ]
                        }
                    ]
                },
                v16 /*: any*/ 
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeFollowingItemsQuery",
            "selections": v17 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v4 /*: any*/ ,
                v3 /*: any*/ ,
                v0 /*: any*/ ,
                v2 /*: any*/ ,
                v1 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeFollowingItemsQuery",
            "selections": v17 /*: any*/ 
        },
        "params": {
            "cacheID": "37c794da865172d609c23565f793e233",
            "id": "acc71c1cc1e805fd4f6e7e71f984116c1e247bcb4c88e72d79072f118f5d4c40",
            "metadata": {},
            "name": "PageTreeFollowingItemsQuery",
            "operationKind": "query",
            "text": "query PageTreeFollowingItemsQuery($spaceKey:String!,$ptStatuses:[PTGraphQLPageStatus],$contentId:ID!,$paginationLimit:Int,$isSuperAdmin:Boolean!){currentPage:ptpage(id:$contentId,spaceKey:$spaceKey,pageTree:$paginationLimit,status:$ptStatuses,enablePaging:true){id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},nearestAncestors{pageInfo{hasNextPage},nodes{followingSiblings{nodes{id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n            hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}},id}},followingSiblings{nodes{id,title,status,hasChildren,blank,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage}}}}"
        }
    };
}();
$56adeec417a0fbae$var$node.hash = "664ef7426d14280a779aeff96cb4c699";
var $56adeec417a0fbae$export$2e2bcd8739ae039 = $56adeec417a0fbae$var$node;











const $851be28f149687b8$export$519f493ae7d5823b = (query)=>{
    const $ = (0, $bDgLe.c)(3);
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = {
            skip: true
        };
        $[0] = t0;
    } else t0 = $[0];
    const { refetch: refetch } = (0, $jMyy4.useQueryInterop)(query, {
        ...t0,
        __callerPackage__: "page-tree"
    });
    let t1;
    if ($[1] !== refetch) {
        t1 = (variables)=>refetch(variables);
        $[1] = refetch;
        $[2] = t1;
    } else t1 = $[2];
    const imperativelyCallQuery = t1;
    return imperativelyCallQuery;
};








const $3c47156b255753b0$var$isPageTreeTruncatedDirectionally = {
    previous: (0, $2qvBe.isPageTreeTruncatedPrevious),
    following: (0, $2qvBe.isPageTreeTruncatedFollowing)
};
const $3c47156b255753b0$var$mergePages = {
    previous: (0, $2qvBe.mergePreviousPages),
    following: (0, $2qvBe.mergeFollowingPages)
};
const $3c47156b255753b0$export$a7e70ccb70edf19f = ({ statuses: statuses })=>{
    // eslint-disable-next-line confluence-sweet-state/sweet-state-prefer-actions-hook
    const [rootId, actions] = (0, $jGj7w.usePageTreeState)();
    const getMorePreviousPages = (0, $851be28f149687b8$export$519f493ae7d5823b)((0, $a1f6f5e5f6be4295$export$2e2bcd8739ae039));
    const getMoreFollowingPages = (0, $851be28f149687b8$export$519f493ae7d5823b)((0, $56adeec417a0fbae$export$2e2bcd8739ae039));
    const loadMorePages = (0, $cozmU.useCallback)((contentId, spaceKey, isSuperAdmin, cursors, allPages, direction = 'following', previousCounts = {
        children: 0,
        previousSiblings: 0,
        followingSiblings: 0
    })=>{
        (0, $9eE57.perfMarkStart)({
            subject: 'PageTree',
            subjectId: 'loadMorePages'
        });
        const id = cursors?.[direction]?.id || undefined;
        const ancestorIndex = cursors?.[direction]?.ancestorIndex || undefined;
        const directionalGetMorePages = {
            previous: getMorePreviousPages,
            following: getMoreFollowingPages
        }[direction];
        return directionalGetMorePages({
            contentId: id,
            paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE),
            spaceKey: spaceKey,
            isSuperAdmin: isSuperAdmin,
            statuses: statuses,
            ptStatuses: statuses
        }).then((response)=>{
            const { data: data, error: error } = response;
            if (error) {
                actions.handleLoadingError(error, direction);
                return;
            } else if (data && Object.keys(data).length > 0) {
                const { currentPage: currentPage, rootLevelPages: rootLevelPages } = data;
                const mergedPages = $3c47156b255753b0$var$mergePages[direction](currentPage, allPages, ancestorIndex);
                const childrenLength = mergedPages.children.count;
                const previousSiblingsLength = mergedPages.previousSiblings.count;
                const followingSiblingsLength = mergedPages.followingSiblings.count;
                //infinite loop check:
                if (childrenLength > previousCounts.children || previousSiblingsLength > previousCounts.previousSiblings || followingSiblingsLength > previousCounts.followingSiblings) //congrats one of the counts got bigger, paging was worth it
                {
                    if ($3c47156b255753b0$var$isPageTreeTruncatedDirectionally[direction](currentPage)) {
                        const nextCursors = (0, $2qvBe.getDirectionalCursors)(currentPage, rootId, cursors, direction);
                        return loadMorePages(contentId, spaceKey, isSuperAdmin, nextCursors, mergedPages, direction, {
                            children: childrenLength,
                            previousSiblings: previousSiblingsLength,
                            followingSiblings: followingSiblingsLength
                        });
                    }
                }
                return {
                    mergedPages: mergedPages,
                    rootLevelPages: rootLevelPages
                };
            }
        }).catch((error_0)=>{
            actions.handleLoadingError(error_0, direction);
            return {
                error: error_0
            };
        });
    }, [
        getMorePreviousPages,
        getMoreFollowingPages,
        actions,
        statuses,
        rootId
    ]);
    return {
        loadMorePages: loadMorePages
    };
};








/**
 * @generated SignedSource<<81d89c2a89bfbb48c0b37603ccb8e74c>>
 * @relayHash e2382e54faefb52da6b779a5a0e4e131
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 46083f55348a2768eb4c27f76700156905d8719d60931948117bb501219e68bd
const $8728d416e54b77da$var$node = function() {
    var v0 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "after"
    }, v1 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "contentId"
    }, v2 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "first"
    }, v3 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "isSuperAdmin"
    }, v4 = {
        "defaultValue": null,
        "kind": "LocalArgument",
        "name": "statuses"
    }, v5 = {
        "kind": "ScalarField",
        "name": "id"
    }, v6 = {
        "kind": "ScalarField",
        "name": "title"
    }, v7 = {
        "kind": "ScalarField",
        "name": "status"
    }, v8 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v9 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v10 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v13 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v5 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    {
                        "kind": "ScalarField",
                        "name": "value"
                    },
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
    }, v15 = [
        {
            "args": [
                {
                    "kind": "Variable",
                    "name": "id",
                    "variableName": "contentId"
                },
                {
                    "kind": "Variable",
                    "name": "status",
                    "variableName": "statuses"
                }
            ],
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "ptpage",
            "plural": false,
            "selections": [
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v7 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                {
                    "args": [
                        {
                            "kind": "Variable",
                            "name": "after",
                            "variableName": "after"
                        },
                        {
                            "kind": "Variable",
                            "name": "first",
                            "variableName": "first"
                        }
                    ],
                    "concreteType": "PTPaginatedPageList",
                    "kind": "LinkedField",
                    "name": "children",
                    "plural": false,
                    "selections": [
                        {
                            "concreteType": "PTPage",
                            "kind": "LinkedField",
                            "name": "nodes",
                            "plural": true,
                            "selections": [
                                v5 /*: any*/ ,
                                v6 /*: any*/ ,
                                v7 /*: any*/ ,
                                v8 /*: any*/ ,
                                v9 /*: any*/ ,
                                v10 /*: any*/ ,
                                v11 /*: any*/ ,
                                v12 /*: any*/ ,
                                v13 /*: any*/ ,
                                v14 /*: any*/ 
                            ]
                        },
                        {
                            "concreteType": "PTPageInfo",
                            "kind": "LinkedField",
                            "name": "pageInfo",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "hasNextPage"
                                },
                                {
                                    "kind": "ScalarField",
                                    "name": "endCursor"
                                }
                            ]
                        }
                    ]
                }
            ]
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [
                v0 /*: any*/ ,
                v1 /*: any*/ ,
                v2 /*: any*/ ,
                v3 /*: any*/ ,
                v4 /*: any*/ 
            ],
            "kind": "Fragment",
            "name": "PageTreeChildrenQuery",
            "selections": v15 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [
                v1 /*: any*/ ,
                v4 /*: any*/ ,
                v2 /*: any*/ ,
                v0 /*: any*/ ,
                v3 /*: any*/ 
            ],
            "kind": "Operation",
            "name": "PageTreeChildrenQuery",
            "selections": v15 /*: any*/ 
        },
        "params": {
            "cacheID": "e2382e54faefb52da6b779a5a0e4e131",
            "id": "46083f55348a2768eb4c27f76700156905d8719d60931948117bb501219e68bd",
            "metadata": {},
            "name": "PageTreeChildrenQuery",
            "operationKind": "query",
            "text": "query PageTreeChildrenQuery($contentId:ID!,$statuses:[PTGraphQLPageStatus],$first:Int,$after:String,$isSuperAdmin:Boolean!){ptpage(id:$contentId,status:$statuses){id,title,status,blank,hasChildren,hasRestrictions@include(if:$isSuperAdmin)\n    hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}},children(first:$first,after:$after){nodes{id,title,status,blank,hasChildren,hasRestrictions@include(if:$isSuperAdmin)\n        hasInheritedRestrictions@include(if:$isSuperAdmin),type,subType,links{webui},properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"]){nodes{id,key,value,version{number}}}},pageInfo{hasNextPage,endCursor}}}}"
        }
    };
}();
$8728d416e54b77da$var$node.hash = "7f4eadf7c16e9b339dd6bec11ab87380";
var $8728d416e54b77da$export$2e2bcd8739ae039 = $8728d416e54b77da$var$node;









const $1280e1da13e18af8$export$d88ca1c37ff75e1 = ({ statuses: statuses, isSuperAdmin: isSuperAdmin })=>{
    const [state, actions] = (0, $jGj7w.usePageTreeState)();
    const getPageChildren = (0, $851be28f149687b8$export$519f493ae7d5823b)((0, $8728d416e54b77da$export$2e2bcd8739ae039));
    const queryChildren = (0, $cozmU.useCallback)((pageId, after, allChildren = {
        count: 0,
        nodes: []
    }, iteration = 0)=>{
        return getPageChildren({
            contentId: pageId,
            statuses: statuses,
            first: (0, $1oGPE.CHILDREN_PAGE_SIZE),
            after: after,
            isSuperAdmin: isSuperAdmin || false
        }).then((response)=>{
            if (response.data) {
                const children = response.data?.ptpage?.children;
                const mergedChildren = children ? (0, $2qvBe.mergeChildren)(allChildren, children) : {
                    nodes: []
                };
                return children?.pageInfo?.hasNextPage && after !== children?.pageInfo?.endCursor && // ensure the new cursor is different
                iteration < 100 // prevent a potential infinite loop
                 ? queryChildren(pageId, children?.pageInfo?.endCursor, mergedChildren, iteration + 1) : {
                    ...mergedChildren,
                    error: null
                };
            }
            return {
                nodes: [],
                error: null
            };
        }).catch((error)=>{
            actions.handleLoadingError(error, 'children');
            return {
                nodes: [],
                error: error
            };
        });
    }, [
        getPageChildren,
        isSuperAdmin,
        statuses,
        actions
    ]);
    const reloadChildren = (0, $cozmU.useCallback)(()=>{
        // @ts-ignore
        queryChildren(state.focusedPageId);
    // @ts-ignore
    }, [
        queryChildren,
        state.focusedPageId
    ]);
    return {
        queryChildren: queryChildren,
        reloadChildren: reloadChildren
    };
};



var $ivyMZ = parcelRequire("ivyMZ");

const $34ce551f827e69ec$export$c22e67505d83a820 = (targetPage, paginated, forceFetch, detached, spaceKey, isSuperAdmin)=>{
    const query = targetPage ? (0, $9eCf8.default) : (0, $93d715cfc896c3c6$export$2e2bcd8739ae039);
    const defaultVariables = targetPage ? {
        spaceKey: spaceKey,
        isSuperAdmin: isSuperAdmin,
        statuses: (0, $ivyMZ.PAGE_TREE_STATUSES),
        ptStatuses: (0, $ivyMZ.PAGE_TREE_STATUSES),
        contentId: targetPage
    } : {
        spaceKey: spaceKey,
        isSuperAdmin: isSuperAdmin,
        statuses: (0, $ivyMZ.PAGE_TREE_STATUSES),
        emojiTitleEnabled: true
    };
    const variablesForPagination = {
        paginationLimit: (0, $1oGPE.INITIAL_PAGE_SIZE),
        ...defaultVariables
    };
    return {
        query: query,
        options: {
            fetchPolicy: detached ? 'no-cache' : forceFetch ? 'network-only' : 'cache-first',
            variables: paginated === true || !targetPage ? variablesForPagination : defaultVariables
        }
    };
};
const $34ce551f827e69ec$export$b005fb2b94547bd6 = (spaceKey, isSuperAdmin, statuses, onLoadMore)=>{
    const $ = (0, $bDgLe.c)(22);
    const [state, actions] = (0, $jGj7w.usePageTreeState)();
    const { focusedPageId: focusedPageId } = state;
    let t0;
    if ($[0] !== statuses) {
        t0 = {
            statuses: statuses
        };
        $[0] = statuses;
        $[1] = t0;
    } else t0 = $[1];
    const { loadMorePages: loadMorePages } = (0, $3c47156b255753b0$export$a7e70ccb70edf19f)(t0);
    let t1;
    if ($[2] !== isSuperAdmin || $[3] !== statuses) {
        t1 = {
            statuses: statuses,
            isSuperAdmin: isSuperAdmin
        };
        $[2] = isSuperAdmin;
        $[3] = statuses;
        $[4] = t1;
    } else t1 = $[4];
    const { reloadChildren: reloadChildren, queryChildren: queryChildren } = (0, $1280e1da13e18af8$export$d88ca1c37ff75e1)(t1);
    let t2;
    if ($[5] !== actions || $[6] !== focusedPageId || $[7] !== isSuperAdmin || $[8] !== loadMorePages || $[9] !== onLoadMore || $[10] !== spaceKey || $[11] !== state) {
        t2 = async (direction)=>{
            actions.setIsPageTreeLoading(true);
            const followingNodeHidden = (0, $2qvBe.isFollowingNodeHidden)(state.initialPages);
            let pages = state.initialPages;
            if (direction === "following" && followingNodeHidden) {
                const { mergedPages: prevPages, error: prevError } = await loadMorePages(focusedPageId, spaceKey, isSuperAdmin, state.cursors, pages, "previous");
                if (prevError) return;
                pages = prevPages;
            }
            const { mergedPages: mergedPages, rootLevelPages: rootLevelPages, error: error } = await loadMorePages(focusedPageId, spaceKey, isSuperAdmin, state.cursors, pages, direction);
            if (error) return;
            const newState = (0, $k0x5M.deriveStateFromData)({
                currentPage: mergedPages,
                rootLevelPages: rootLevelPages,
                space: state.space
            }, spaceKey, state, false, undefined, false);
            actions.setStateWithUIAttributes(newState);
            const flattenedPages = (0, $k0x5M.flattenTreeData)(mergedPages, rootLevelPages);
            actions.setIsPageTreeLoading(false);
            if (onLoadMore) onLoadMore(Object.keys(flattenedPages).length, direction);
        };
        $[5] = actions;
        $[6] = focusedPageId;
        $[7] = isSuperAdmin;
        $[8] = loadMorePages;
        $[9] = onLoadMore;
        $[10] = spaceKey;
        $[11] = state;
        $[12] = t2;
    } else t2 = $[12];
    const loadMoreDirectionalPages = t2;
    let t3;
    if ($[13] !== loadMoreDirectionalPages) {
        t3 = ()=>loadMoreDirectionalPages("previous");
        $[13] = loadMoreDirectionalPages;
        $[14] = t3;
    } else t3 = $[14];
    const loadPreviousPages = t3;
    let t4;
    if ($[15] !== loadMoreDirectionalPages) {
        t4 = ()=>loadMoreDirectionalPages("following");
        $[15] = loadMoreDirectionalPages;
        $[16] = t4;
    } else t4 = $[16];
    const loadFollowingPages = t4;
    let t5;
    if ($[17] !== loadFollowingPages || $[18] !== loadPreviousPages || $[19] !== queryChildren || $[20] !== reloadChildren) {
        t5 = {
            loadPreviousPages: loadPreviousPages,
            loadFollowingPages: loadFollowingPages,
            reloadChildren: reloadChildren,
            queryChildren: queryChildren
        };
        $[17] = loadFollowingPages;
        $[18] = loadPreviousPages;
        $[19] = queryChildren;
        $[20] = reloadChildren;
        $[21] = t5;
    } else t5 = $[21];
    return t5;
};
const $34ce551f827e69ec$export$2876891f14dc554a = (currentPageId, paginated, forceFetch, detached, spaceKey, isSuperAdmin)=>{
    const $ = (0, $bDgLe.c)(10);
    let t0;
    if ($[0] !== currentPageId || $[1] !== detached || $[2] !== forceFetch || $[3] !== isSuperAdmin || $[4] !== paginated || $[5] !== spaceKey) {
        t0 = $34ce551f827e69ec$export$c22e67505d83a820(currentPageId, paginated, forceFetch, detached, spaceKey, isSuperAdmin);
        $[0] = currentPageId;
        $[1] = detached;
        $[2] = forceFetch;
        $[3] = isSuperAdmin;
        $[4] = paginated;
        $[5] = spaceKey;
        $[6] = t0;
    } else t0 = $[6];
    const { query: query, options: options } = t0;
    const t1 = options.fetchPolicy;
    let t2;
    if ($[7] !== options.variables || $[8] !== t1) {
        t2 = {
            skip: true,
            fetchPolicy: t1,
            variables: options.variables
        };
        $[7] = options.variables;
        $[8] = t1;
        $[9] = t2;
    } else t2 = $[9];
    return (0, $jMyy4.useQueryInterop)(query, {
        ...t2,
        __callerPackage__: "page-tree"
    });
};
const $34ce551f827e69ec$export$4a34638c035ec952 = (spaceKey, expandSpaceHomepage, syntheticItem, t0, t1, statuses, syntheticItemIsDraft, pageTreeStateUpdatesContainer)=>{
    const $ = (0, $bDgLe.c)(13);
    const isPeekingFromBlogs = t0 === undefined ? false : t0;
    const isSuperAdmin = t1 === undefined ? false : t1;
    const [state, actions] = (0, $jGj7w.usePageTreeState)();
    let t2;
    if ($[0] !== isSuperAdmin || $[1] !== statuses) {
        t2 = {
            statuses: statuses,
            isSuperAdmin: isSuperAdmin
        };
        $[0] = isSuperAdmin;
        $[1] = statuses;
        $[2] = t2;
    } else t2 = $[2];
    const { queryChildren: queryChildren } = (0, $1280e1da13e18af8$export$d88ca1c37ff75e1)(t2);
    let t3;
    if ($[3] !== actions || $[4] !== expandSpaceHomepage || $[5] !== isPeekingFromBlogs || $[6] !== pageTreeStateUpdatesContainer || $[7] !== queryChildren || $[8] !== spaceKey || $[9] !== state || $[10] !== syntheticItem || $[11] !== syntheticItemIsDraft) {
        t3 = (data)=>{
            if (data && Object.keys(data).length > 0) {
                const spaceHomePageId = data.space?.homepage?.id;
                const newState = (0, $k0x5M.deriveStateFromData)(data, spaceKey, state, isPeekingFromBlogs, syntheticItem, syntheticItemIsDraft, pageTreeStateUpdatesContainer, (0, $9wGTI.fg)("confluence_frontend_whiteboard_emoji_titles"));
                actions.setStateWithUIAttributes(newState);
                const { rootId: rootId, pages: allPages } = newState;
                if (expandSpaceHomepage && spaceHomePageId && rootId !== spaceHomePageId && allPages[spaceHomePageId]) return actions.expandPage(allPages[spaceHomePageId], queryChildren);
                return allPages;
            }
            return data;
        };
        $[3] = actions;
        $[4] = expandSpaceHomepage;
        $[5] = isPeekingFromBlogs;
        $[6] = pageTreeStateUpdatesContainer;
        $[7] = queryChildren;
        $[8] = spaceKey;
        $[9] = state;
        $[10] = syntheticItem;
        $[11] = syntheticItemIsDraft;
        $[12] = t3;
    } else t3 = $[12];
    return t3;
};














const $5118cf9ac37d7a42$var$determineMovePageParams = (destinationParent, pageId, destination)=>{
    if (typeof destination.index === 'undefined') return {
        pageId: pageId,
        parentId: destination.parentId
    };
    const movedToFirstPosition = destination.index === 0;
    const currentIndexUnderDestinationParent = destinationParent.children.indexOf(pageId);
    const movedDownOnSameLevel = currentIndexUnderDestinationParent > -1 && currentIndexUnderDestinationParent < destination.index;
    const isSiblingShifted = movedToFirstPosition || movedDownOnSameLevel;
    const siblingIndex = isSiblingShifted ? destination.index : destination.index - 1;
    const siblingId = String(destinationParent.children[siblingIndex]);
    return {
        pageId: pageId,
        siblingId: siblingId,
        positionToSibling: destination.index === 0 ? 'before' : 'after'
    };
};
const $5118cf9ac37d7a42$var$validateMove = (source, destination, pages)=>{
    if (!destination || (0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(source, destination) || !pages[destination.parentId]) return 'INVALID_MOVE_LOCATION';
    if (pages[destination.parentId].data.status === 'DRAFT') return 'INVALID_MOVE_LOCATION_DRAFT';
    if ((0, $k0x5M.isManagedFolder)(pages[destination.parentId].data)) return 'INVALID_MOVE_LOCATION_MANAGED_FOLDER';
    // Also block drops onto items that are themselves inside a managed folder
    const destGrandparentId = pages[destination.parentId]?.parentId;
    if (destGrandparentId && (0, $k0x5M.isManagedFolder)(pages[destGrandparentId]?.data)) return 'INVALID_MOVE_LOCATION_MANAGED_FOLDER';
    // Any move whose source parent is a managed folder is invalid
    // (covers both moving out and reordering within the managed folder).
    if ((0, $k0x5M.isManagedFolder)(pages[source.parentId]?.data)) return 'INVALID_MOVE_LOCATION_MANAGED_FOLDER';
    return null;
};
const $5118cf9ac37d7a42$export$63f1f45217bf3813 = (t0)=>{
    const $ = (0, $bDgLe.c)(6);
    const { onMoveInvalid: onMoveInvalid, syntheticItem: syntheticItem, onPageMove: onPageMove, queryChildren: queryChildren } = t0;
    const [, actions] = (0, $jGj7w.usePageTreeState)();
    let t1;
    if ($[0] !== actions || $[1] !== onMoveInvalid || $[2] !== onPageMove || $[3] !== queryChildren || $[4] !== syntheticItem?.id) {
        t1 = (source, destination, instructionType)=>{
            const { pages: pages, space: space } = actions.getState();
            const reason = $5118cf9ac37d7a42$var$validateMove(source, destination, pages);
            if (reason) {
                onMoveInvalid?.({
                    reason: reason
                });
                return;
            }
            const pageId = syntheticItem?.id || pages[source.parentId].children[source.index];
            const contentStatus = pages[pageId]?.data?.status || null;
            const destinationParent = pages[destination.parentId];
            const sourceParent = pages[source.parentId];
            const expandAfter = pageId === syntheticItem?.id;
            actions.movePageInState(pageId, source, destination, queryChildren, expandAfter);
            const movePageParams = $5118cf9ac37d7a42$var$determineMovePageParams(destinationParent, pageId, destination);
            onPageMove(movePageParams, {
                contentStatus: contentStatus,
                destination: destination,
                instructionType: instructionType,
                movedPageTitle: pages[pageId].data.title,
                source: source,
                sourceParent: sourceParent,
                spaceId: space?.id,
                revertMove: ()=>{
                    const { pages: pages_0 } = actions.getState();
                    const updatedSourceParent = pages_0[sourceParent.id];
                    const inverseDestination = updatedSourceParent.children.length > 0 ? source : {
                        parentId: sourceParent.id
                    };
                    actions.movePageInState(pageId, destination, inverseDestination, queryChildren, true);
                    return $5118cf9ac37d7a42$var$determineMovePageParams(updatedSourceParent, pageId, inverseDestination);
                }
            });
        };
        $[0] = actions;
        $[1] = onMoveInvalid;
        $[2] = onPageMove;
        $[3] = queryChildren;
        $[4] = syntheticItem?.id;
        $[5] = t1;
    } else t1 = $[5];
    syntheticItem?.id;
    return t1;
};



var $55DRn = parcelRequire("55DRn");










var $9aYkv = parcelRequire("9aYkv");




// eslint-disable-next-line @atlaskit/ui-styling-standard/no-styled -- To migrate as part of go/ui-styling-standard
const $5b61e06162a9104b$var$TreeItemEmptyState = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, __cmplr)=>{
    const $ = (0, $bDgLe.c)(3);
    let t1;
    if ($[0] !== __cmplr || $[1] !== t0) {
        const { as: t2, style: __cmpls, ...__cmplp } = t0;
        const C = t2 === undefined ? "div" : t2;
        const { indent: indent, ...__cmpldp } = __cmplp;
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement(C, {
            ...__cmpldp,
            style: {
                ...__cmpls,
                "--_gg0ene": (0, $9aYkv.default)(__cmplp.indent, "px")
            },
            ref: __cmplr,
            className: (0, $hekY6.default)([
                "_3iDTPbQ4SZ _0hPCNLDIqT _0wOv4Q18ZR _0jFU0VnlTt _1UtDYzKGUX",
                __cmplp.indent ? "_2Zuz6QDm6q" : "_2Zuz6QdnbC",
                __cmplp.className
            ])
        });
        $[0] = __cmplr;
        $[1] = t0;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
});
const $5b61e06162a9104b$export$4fcfc92bcfdf296e = ({ item: item, indent: indent })=>{
    if (item.data.type === 'folder') return /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($5b61e06162a9104b$var$TreeItemEmptyState, {
        indent: indent
    }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kSwu1.FormattedMessage), {
        id: "page-tree.folder.empty-state",
        defaultMessage: "There\u2019s nothing in this folder yet"
    }));
};












var $kNIYN = parcelRequire("kNIYN");





var $2wCqQ = parcelRequire("2wCqQ");





var $l3wuH = parcelRequire("l3wuH");


var $31le2 = parcelRequire("31le2");


var $iDfTs = parcelRequire("iDfTs");


var $9GVkD = parcelRequire("9GVkD");


var $lpNn5 = parcelRequire("lpNn5");





var $irVI7 = parcelRequire("irVI7");


var $1kHsc = parcelRequire("1kHsc");


var $jwg5H = parcelRequire("jwg5H");


var $abCbd = parcelRequire("abCbd");


var $eQjI7 = parcelRequire("eQjI7");


var $aqBZ0 = parcelRequire("aqBZ0");


var $bwL2u = parcelRequire("bwL2u");


var $kRW4Y = parcelRequire("kRW4Y");


var $gqqjz = parcelRequire("gqqjz");











var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");

/**
 * Below is the exported type with comments next to it for context because the variable names are not very clear.
 *
 * export type MutationOutputItem = {
	pageID: string;
	hasChildren: boolean;
	areChildrenIncluded: boolean; // Are all descendants included?
	excludedBranchRootPageIDs: string[]; // All direct children that are excluded.
	hasRestrictions: boolean; // Current node has restrictions
	hasInheritedRestrictions: boolean; // Within this tree, there are inherited restrictions
	contentType: string | null;

	// These attributes below will have preset values
	hasSelectedAncestor: boolean; // This is for archived pages w| note, which is not required.
	excludedBranchRootPageHasInheritedRestrictions: boolean[]; // We are not addressing this because we are excluding it.
	isSelected: boolean; // This will always be true in our scenario, we always want to include the current tree item.
};
 */ const $4060ba72f705a372$var$createPrimaryActionInput = ({ treeItem: treeItem, areChildrenIncluded: areChildrenIncluded, excludedBranchRootPageIDs: excludedBranchRootPageIDs = [], hasInheritedRestrictions: hasInheritedRestrictions = false })=>({
        pageID: treeItem.id,
        areChildrenIncluded: areChildrenIncluded,
        hasRestrictions: treeItem.hasRestrictions ?? false,
        hasInheritedRestrictions: hasInheritedRestrictions ?? false,
        excludedBranchRootPageIDs: excludedBranchRootPageIDs,
        hasChildren: treeItem.hasChildren,
        contentType: treeItem.data.type ?? null,
        // These attributes are expected in the schema but will have preset values and can be ignored for our use case.
        isSelected: true,
        excludedBranchRootPageHasInheritedRestrictions: [],
        hasSelectedAncestor: false
    });
const $4060ba72f705a372$export$860ea5d378df4698 = (root, pages, contentIdsWithLoadedChildren, selectedContent)=>{
    // This is a set of contentIds that should be ignored if a parent node has addressed all of its descendants from the areChildrenIncluded argument
    let ignoreSet = new Set();
    // Checking if all descendants are selected and saving the selected descendants in a set to be ignored
    // if and only if all descendants are selected to prevent another recursive traversal against the TreeNodeItem
    const collectSelectedItemsAndStatus = (item)=>{
        const selectedSet = new Set();
        let hasInheritedRestrictions = false;
        const traverse = (currItem)=>{
            if (selectedContent[currItem.id] === undefined || selectedContent[currItem.id].deselectedChildren.size > 0) return false;
            const isSelected = selectedContent.hasOwnProperty(currItem.id);
            if (isSelected) {
                selectedSet.add(currItem.id);
                if (currItem.hasRestrictions && currItem.hasChildren) hasInheritedRestrictions = true;
            }
            const children = currItem.children || [];
            let allChildrenSelected = true;
            for (const childId of children){
                const child = pages[childId];
                if (child.data.status !== 'DRAFT') {
                    if (child) {
                        const childAllSelected = traverse(child);
                        allChildrenSelected = allChildrenSelected && childAllSelected;
                    } else // If the child doesn't exist in pages, treat it as not selected
                    allChildrenSelected = false;
                }
            }
            // Current node must be selected AND all children must be selected
            return isSelected && allChildrenSelected;
        };
        const allSelected = traverse(item);
        return {
            selectedSet: selectedSet,
            allSelected: allSelected,
            hasInheritedRestrictions: hasInheritedRestrictions
        };
    };
    const result = [];
    const getSelectedItems = (treeItem)=>{
        const isSelected = treeItem.id in selectedContent;
        const hasChildren = treeItem.hasChildren;
        const children = treeItem.children;
        if (!ignoreSet.has(treeItem.id) && treeItem.data.status !== 'DRAFT') {
            // Leaf node is selected
            if (isSelected && !hasChildren) result.push($4060ba72f705a372$var$createPrimaryActionInput({
                treeItem: treeItem,
                areChildrenIncluded: false
            }));
            else if (isSelected && hasChildren && !contentIdsWithLoadedChildren.has(treeItem.id)) result.push($4060ba72f705a372$var$createPrimaryActionInput({
                treeItem: treeItem,
                areChildrenIncluded: true
            }));
            else if (isSelected && hasChildren && selectedContent[treeItem.id].deselectedChildren.size > 0) result.push($4060ba72f705a372$var$createPrimaryActionInput({
                treeItem: treeItem,
                areChildrenIncluded: false,
                excludedBranchRootPageIDs: [
                    ...selectedContent[treeItem.id].deselectedChildren
                ]
            }));
            else if (isSelected && hasChildren) {
                const { selectedSet: selectedSet, allSelected: allSelected, hasInheritedRestrictions: hasInheritedRestrictions } = collectSelectedItemsAndStatus(treeItem);
                if (allSelected) {
                    result.push($4060ba72f705a372$var$createPrimaryActionInput({
                        treeItem: treeItem,
                        areChildrenIncluded: true,
                        excludedBranchRootPageIDs: [],
                        hasInheritedRestrictions: hasInheritedRestrictions
                    }));
                    ignoreSet = new Set([
                        ...selectedSet,
                        ...ignoreSet
                    ]);
                } else {
                    // This scenario should never be reached, but this is a just in case. It should also be covered by the archive/delete mutation when it fails.
                    const err = new Error('[Bulk Actions on Content Tree] Error formatting selected items for primary actions (delete or archive)');
                    (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                        attribution: (0, $3IBnw.Attribution).DISCO
                    });
                    return err;
                }
            }
        }
        for (const childId of children || []){
            const child = pages[childId];
            if (child) getSelectedItems(child);
        }
        // Has previously been addressed by parent with the areChildrenIncluded argument
        if (isSelected && ignoreSet.has(treeItem.id)) {
            if (!hasChildren) {
                // TODO @awu address the case where nodes with children have also been accounted for
                delete selectedContent[treeItem.id];
                ignoreSet.delete(treeItem.id);
            }
        }
        return result;
    };
    return getSelectedItems(root);
};


const $5153e67ad09ff2bc$export$a2dcefe26b9fbedd = ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [t0] = (0, $bwL2u.useContentTreeSelection)();
    const { selectedContent: selectedContent } = t0;
    const { getState: getState } = (0, $jGj7w.usePageTreeActions)();
    let t1;
    if ($[0] !== getState || $[1] !== selectedContent) {
        t1 = ()=>{
            const { rootId: rootId, pages: pages, contentIdsWithLoadedChildren: contentIdsWithLoadedChildren } = getState();
            const selectedContentCopy = {
                ...selectedContent
            };
            return (0, $4060ba72f705a372$export$860ea5d378df4698)(pages[rootId], pages, contentIdsWithLoadedChildren, selectedContentCopy);
        };
        $[0] = getState;
        $[1] = selectedContent;
        $[2] = t1;
    } else t1 = $[2];
    const getPrimaryActionInput = t1;
    let t2;
    if ($[3] !== getState) {
        t2 = ()=>{
            const { spaceKey: spaceKey, spaceId: spaceId } = getState();
            return {
                spaceKey: spaceKey,
                spaceId: spaceId
            };
        };
        $[3] = getState;
        $[4] = t2;
    } else t2 = $[4];
    const getCurrentSpace = t2;
    let t3;
    if ($[5] !== getCurrentSpace || $[6] !== getPrimaryActionInput) {
        t3 = {
            getPrimaryActionInput: getPrimaryActionInput,
            getCurrentSpace: getCurrentSpace
        };
        $[5] = getCurrentSpace;
        $[6] = getPrimaryActionInput;
        $[7] = t3;
    } else t3 = $[7];
    return t3;
};















var $w6R6I = parcelRequire("w6R6I");


var $kh0hi = parcelRequire("kh0hi");


var $1l0kj = parcelRequire("1l0kj");


var $iMnC5 = parcelRequire("iMnC5");


var $4n1IT = parcelRequire("4n1IT");


var $lMGh1 = parcelRequire("lMGh1");





const $c33509509e92d1b9$var$styles = {
    button: "_0bjKvDKTcp _4c065U1Y8M _2Y7lL42ADO _1EqgXlE6Kk _0KLXrugozt",
    activeButton: "_1eOmH6kTlo _3gzVzLVbka",
    disabledButton: "_1pp6NdYbGa",
    disabledBox: "_0wOv4Qsyl5",
    inline: "_2sNsIgmnOE _2Y7lL42ADO _0jFU0VUofl _1UtDYze5R3",
    limitDialog: "_0bjKvDKTcp _4c065U1Y8M _2Y7lL42ADO _0KLXrugozt _1UtDYze5R3 _3iDTPbQ4SZ _37wbyuDIqT _0hPCNLDIqT",
    popup: "_0bjKvDKTcp _39xV02pahA",
    deleteButton: "_1eOmH6EISo"
};
const $c33509509e92d1b9$export$70bde410d897c00a = (t0)=>{
    const $ = (0, $bDgLe.c)(38);
    const { actionText: actionText, actionIcon: actionIcon, actionName: actionName, count: count, onClick: onClick, isSelectionLimitReached: t1, actionLimit: t2, isLoading: t3, isDisabled: t4 } = t0;
    const isSelectionLimitReached = t1 === undefined ? false : t1;
    const actionLimit = t2 === undefined ? 0 : t2;
    const isLoading = t3 === undefined ? false : t3;
    const isDisabled = t4 === undefined ? false : t4;
    const isButtonDisabled = actionName !== (0, $60ad31f4e0dd72f9$export$f320192b45e546dc) && (count === 0 || isLoading || isDisabled);
    if (isSelectionLimitReached) {
        let t5;
        if ($[0] !== actionLimit) {
            t5 = ()=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    xcss: (0, $w6R6I.cx)($c33509509e92d1b9$var$styles.limitDialog)
                }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    space: "space.100",
                    xcss: (0, $w6R6I.cx)($c33509509e92d1b9$var$styles.inline)
                }, /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...$c33509509e92d1b9$var$i18n.overTheLimitWarning,
                    values: {
                        limit: actionLimit
                    }
                })));
            $[0] = actionLimit;
            $[1] = t5;
        } else t5 = $[1];
        let t6;
        if ($[2] !== actionText || $[3] !== count) {
            t6 = (triggerProps)=>/*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
                    ...triggerProps,
                    xcss: (0, $w6R6I.cx)($c33509509e92d1b9$var$styles.disabledBox)
                }, /*#__PURE__*/ $cozmU.createElement((0, $kh0hi.default), {
                    xcss: (0, $w6R6I.cx)($c33509509e92d1b9$var$styles.button, $c33509509e92d1b9$var$styles.disabledButton),
                    "aria-disabled": true
                }, /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
                    alignBlock: "center",
                    space: "space.100",
                    xcss: (0, $w6R6I.cx)($c33509509e92d1b9$var$styles.inline)
                }, /*#__PURE__*/ $cozmU.createElement((0, (/*@__PURE__*/$parcel$interopDefault($lMGh1))), {
                    label: "",
                    color: "var(--ds-icon-warning, #E06C00)"
                }), /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
                    ...actionText,
                    values: {
                        count: count
                    }
                }))));
            $[2] = actionText;
            $[3] = count;
            $[4] = t6;
        } else t6 = $[4];
        let t7;
        if ($[5] === Symbol.for("react.memo_cache_sentinel")) {
            t7 = [
                0,
                -70
            ];
            $[5] = t7;
        } else t7 = $[5];
        let t8;
        if ($[6] !== t5 || $[7] !== t6) {
            t8 = /*#__PURE__*/ $cozmU.createElement((0, $4n1IT.Popup), {
                placement: "right",
                isOpen: true,
                content: t5,
                trigger: t6,
                popupComponent: $c33509509e92d1b9$var$CustomPopupContainer,
                offset: t7,
                shouldRenderToParent: true
            });
            $[6] = t5;
            $[7] = t6;
            $[8] = t8;
        } else t8 = $[8];
        return t8;
    }
    const t5 = isButtonDisabled && $c33509509e92d1b9$var$styles.disabledBox;
    let t6;
    if ($[9] !== t5) {
        t6 = (0, $w6R6I.cx)(t5);
        $[9] = t5;
        $[10] = t6;
    } else t6 = $[10];
    const t7 = isButtonDisabled && $c33509509e92d1b9$var$styles.disabledButton;
    const t8 = actionName === (0, $60ad31f4e0dd72f9$export$2298ba3671f5c8c7) && $c33509509e92d1b9$var$styles.deleteButton;
    let t9;
    if ($[11] !== t7 || $[12] !== t8) {
        t9 = (0, $w6R6I.cx)($c33509509e92d1b9$var$styles.button, $c33509509e92d1b9$var$styles.activeButton, t7, t8);
        $[11] = t7;
        $[12] = t8;
        $[13] = t9;
    } else t9 = $[13];
    const t10 = `${actionName}Button`;
    let t11;
    if ($[14] !== count || $[15] !== t10) {
        t11 = {
            source: "contentTreeBulkActions",
            attributes: {
                name: t10,
                selectedItemCount: count
            }
        };
        $[14] = count;
        $[15] = t10;
        $[16] = t11;
    } else t11 = $[16];
    let t12;
    if ($[17] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = (0, $w6R6I.cx)($c33509509e92d1b9$var$styles.inline);
        $[17] = t12;
    } else t12 = $[17];
    let t13;
    if ($[18] !== actionIcon || $[19] !== isLoading) {
        t13 = isLoading ? /*#__PURE__*/ $cozmU.createElement((0, $lfoFx.default), {
            size: "small",
            appearance: "invert"
        }) : actionIcon;
        $[18] = actionIcon;
        $[19] = isLoading;
        $[20] = t13;
    } else t13 = $[20];
    let t14;
    if ($[21] !== count) {
        t14 = {
            count: count
        };
        $[21] = count;
        $[22] = t14;
    } else t14 = $[22];
    let t15;
    if ($[23] !== actionText || $[24] !== t14) {
        t15 = /*#__PURE__*/ $cozmU.createElement((0, $kSwu1.FormattedMessage), {
            ...actionText,
            values: t14
        });
        $[23] = actionText;
        $[24] = t14;
        $[25] = t15;
    } else t15 = $[25];
    let t16;
    if ($[26] !== t13 || $[27] !== t15) {
        t16 = /*#__PURE__*/ $cozmU.createElement((0, $1l0kj.Inline), {
            alignBlock: "center",
            space: "space.100",
            xcss: t12
        }, t13, t15);
        $[26] = t13;
        $[27] = t15;
        $[28] = t16;
    } else t16 = $[28];
    let t17;
    if ($[29] !== isButtonDisabled || $[30] !== onClick || $[31] !== t11 || $[32] !== t16 || $[33] !== t9) {
        t17 = /*#__PURE__*/ $cozmU.createElement((0, $kh0hi.default), {
            onClick: onClick,
            xcss: t9,
            analyticsContext: t11,
            "aria-disabled": isButtonDisabled
        }, t16);
        $[29] = isButtonDisabled;
        $[30] = onClick;
        $[31] = t11;
        $[32] = t16;
        $[33] = t9;
        $[34] = t17;
    } else t17 = $[34];
    let t18;
    if ($[35] !== t17 || $[36] !== t6) {
        t18 = /*#__PURE__*/ $cozmU.createElement((0, $iMnC5.Box), {
            xcss: t6
        }, t17);
        $[35] = t17;
        $[36] = t6;
        $[37] = t18;
    } else t18 = $[37];
    return t18;
};
// Need custom popup container to allow us to override the border radius styling
const $c33509509e92d1b9$var$CustomPopupContainer = /*#__PURE__*/ (0, $cozmU.forwardRef)((t0, ref)=>{
    const $ = (0, $bDgLe.c)(8);
    let children;
    let props;
    if ($[0] !== t0) {
        ({ children: children, ...props } = t0);
        $[0] = t0;
        $[1] = children;
        $[2] = props;
    } else {
        children = $[1];
        props = $[2];
    }
    let t1;
    if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
        t1 = (0, $hekY6.default)([
            $c33509509e92d1b9$var$styles.popup
        ]);
        $[3] = t1;
    } else t1 = $[3];
    let t2;
    if ($[4] !== children || $[5] !== props || $[6] !== ref) {
        t2 = /*#__PURE__*/ $cozmU.createElement("div", {
            ...props,
            ref: ref,
            className: t1
        }, children);
        $[4] = children;
        $[5] = props;
        $[6] = ref;
        $[7] = t2;
    } else t2 = $[7];
    return t2;
});
const $c33509509e92d1b9$var$i18n = (0, $kSwu1.defineMessages)({
    overTheLimitWarning: {
        id: "page-tree.bulk-actions-menu.over-the-limit-warning",
        defaultMessage: "This action can only be applied to {limit} items at a time. Please deselect some items to continue."
    }
});


const $60ad31f4e0dd72f9$export$4b71c44db98cf846 = 'contentTreeBulkActions';
const $60ad31f4e0dd72f9$var$BULK_ACTION_SUBJECT_ID = 'bulkAction';
const $60ad31f4e0dd72f9$export$9abc4b344c9f62bb = 'clearSelection';
const $60ad31f4e0dd72f9$export$bcfb39b8f6d9105e = 'bulkArchive';
const $60ad31f4e0dd72f9$export$2298ba3671f5c8c7 = 'bulkDelete';
const $60ad31f4e0dd72f9$export$f320192b45e546dc = 'exit';
const $60ad31f4e0dd72f9$export$e3351feaa340049 = ()=>{
    const $ = (0, $bDgLe.c)(49);
    const intl = (0, $kSwu1.useIntl)();
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const experienceTracker = (0, $cozmU.useContext)((0, $1kHsc.ExperienceTrackerContext));
    const [t0, t1] = (0, $bwL2u.useContentTreeSelection)();
    const { count: count, loadingDescendantIds: loadingDescendantIds } = t0;
    const { clearSelection: clearSelection, exitMultiSelect: exitMultiSelect } = t1;
    const [isModalOpen, setIsModalOpen] = (0, $cozmU.useState)(false);
    const isDeleteLimitReached = count > (0, $abCbd.BULK_DELETE_PAGE_SELECTION_LIMIT_DEFAULT);
    const isArchiveLimitReached = count > (0, $aqBZ0.BULK_ARCHIVE_PAGE_SELECTION_LIMIT);
    const { getPrimaryActionInput: getPrimaryActionInput, getCurrentSpace: getCurrentSpace } = (0, $5153e67ad09ff2bc$export$a2dcefe26b9fbedd)();
    let t2;
    if ($[0] !== getCurrentSpace) {
        t2 = getCurrentSpace();
        $[0] = getCurrentSpace;
        $[1] = t2;
    } else t2 = $[1];
    const { spaceKey: spaceKey, spaceId: spaceId } = t2;
    const isDescendantCountLoading = loadingDescendantIds.size > 0;
    let t3;
    if ($[2] !== createAnalyticsEvent || $[3] !== exitMultiSelect || $[4] !== isModalOpen) {
        t3 = (event)=>{
            if (event.key === "Escape" && !isModalOpen) {
                createAnalyticsEvent({
                    type: "sendTrackEvent",
                    data: {
                        source: $60ad31f4e0dd72f9$export$4b71c44db98cf846,
                        action: "closed",
                        actionSubject: "bulkActionsMenu",
                        attributes: {
                            method: "escapeKey"
                        }
                    }
                }).fire();
                exitMultiSelect();
            }
        };
        $[2] = createAnalyticsEvent;
        $[3] = exitMultiSelect;
        $[4] = isModalOpen;
        $[5] = t3;
    } else t3 = $[5];
    const handleKeydown = t3;
    let t4;
    let t5;
    if ($[6] !== handleKeydown) {
        t4 = ()=>{
            document.addEventListener("keydown", handleKeydown);
            return ()=>{
                document.removeEventListener("keydown", handleKeydown);
            };
        };
        t5 = [
            handleKeydown
        ];
        $[6] = handleKeydown;
        $[7] = t4;
        $[8] = t5;
    } else {
        t4 = $[7];
        t5 = $[8];
    }
    (0, $cozmU.useEffect)(t4, t5);
    let t6;
    if ($[9] !== clearSelection || $[10] !== count || $[11] !== createAnalyticsEvent || $[12] !== exitMultiSelect || $[13] !== experienceTracker || $[14] !== getPrimaryActionInput || $[15] !== intl || $[16] !== spaceId || $[17] !== spaceKey) {
        t6 = (dialogs, flags)=>{
            setIsModalOpen(true);
            const primaryActionInput = getPrimaryActionInput();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: $60ad31f4e0dd72f9$export$4b71c44db98cf846,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: $60ad31f4e0dd72f9$var$BULK_ACTION_SUBJECT_ID,
                    attributes: {
                        action: $60ad31f4e0dd72f9$export$bcfb39b8f6d9105e,
                        count: count,
                        spaceKey: spaceKey
                    }
                }
            }).fire();
            experienceTracker.start({
                name: (0, $irVI7.ARCHIVE_PAGES_EXPERIENCE),
                attributes: {
                    featureName: $60ad31f4e0dd72f9$export$4b71c44db98cf846
                }
            });
            if (primaryActionInput instanceof Error) flags.showErrorFlag({
                title: intl.formatMessage($60ad31f4e0dd72f9$var$i18n.flagErrorTitle),
                description: intl.formatMessage($60ad31f4e0dd72f9$var$i18n.flagErrorDescription)
            });
            else dialogs.showModal((0, $eQjI7.BulkArchivePagesLoader), {
                mutationOutputList: primaryActionInput,
                expectedPageCount: count,
                spaceKey: spaceKey ?? "",
                spaceId: spaceId,
                onSuccess: ()=>{
                    createAnalyticsEvent({
                        type: "sendTrackEvent",
                        data: {
                            source: "bulkArchive",
                            action: "completed",
                            actionSubject: $60ad31f4e0dd72f9$var$BULK_ACTION_SUBJECT_ID,
                            attributes: {
                                action: $60ad31f4e0dd72f9$export$bcfb39b8f6d9105e,
                                count: count,
                                spaceKey: spaceKey
                            }
                        }
                    }).fire();
                    exitMultiSelect();
                    clearSelection();
                    setIsModalOpen(false);
                },
                onClose: ()=>{
                    setIsModalOpen(false);
                },
                featureName: $60ad31f4e0dd72f9$export$4b71c44db98cf846
            });
        };
        $[9] = clearSelection;
        $[10] = count;
        $[11] = createAnalyticsEvent;
        $[12] = exitMultiSelect;
        $[13] = experienceTracker;
        $[14] = getPrimaryActionInput;
        $[15] = intl;
        $[16] = spaceId;
        $[17] = spaceKey;
        $[18] = t6;
    } else t6 = $[18];
    const handleArchiveClick = t6;
    let t7;
    if ($[19] !== count || $[20] !== createAnalyticsEvent || $[21] !== exitMultiSelect || $[22] !== experienceTracker || $[23] !== getPrimaryActionInput || $[24] !== intl || $[25] !== spaceId || $[26] !== spaceKey) {
        t7 = (dialogs_0, flags_0)=>{
            setIsModalOpen(true);
            const primaryActionInput_0 = getPrimaryActionInput();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: $60ad31f4e0dd72f9$export$4b71c44db98cf846,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: $60ad31f4e0dd72f9$var$BULK_ACTION_SUBJECT_ID,
                    attributes: {
                        action: $60ad31f4e0dd72f9$export$2298ba3671f5c8c7,
                        count: count,
                        spaceKey: spaceKey
                    }
                }
            }).fire();
            experienceTracker.start({
                name: (0, $irVI7.BULK_DELETE_PAGES_EXPERIENCE),
                attributes: {
                    featureName: $60ad31f4e0dd72f9$export$4b71c44db98cf846
                }
            });
            if (primaryActionInput_0 instanceof Error) flags_0.showErrorFlag({
                title: intl.formatMessage($60ad31f4e0dd72f9$var$i18n.flagErrorTitle),
                description: intl.formatMessage($60ad31f4e0dd72f9$var$i18n.flagErrorDescription)
            });
            else dialogs_0.showModal((0, $jwg5H.BulkDeletePagesActionLoader), {
                mutationOutputList: primaryActionInput_0,
                expectedPageCount: count,
                spaceKey: spaceKey ?? "",
                spaceId: spaceId,
                source: $60ad31f4e0dd72f9$export$4b71c44db98cf846,
                onSuccess: ()=>{
                    createAnalyticsEvent({
                        type: "sendTrackEvent",
                        data: {
                            source: "bulkDelete",
                            action: "completed",
                            actionSubject: $60ad31f4e0dd72f9$var$BULK_ACTION_SUBJECT_ID,
                            attributes: {
                                action: $60ad31f4e0dd72f9$export$2298ba3671f5c8c7,
                                count: count,
                                spaceKey: spaceKey
                            }
                        }
                    }).fire();
                    window.location.reload();
                    exitMultiSelect();
                    setIsModalOpen(false);
                },
                onClose: ()=>{
                    setIsModalOpen(false);
                },
                featureName: $60ad31f4e0dd72f9$export$4b71c44db98cf846
            });
        };
        $[19] = count;
        $[20] = createAnalyticsEvent;
        $[21] = exitMultiSelect;
        $[22] = experienceTracker;
        $[23] = getPrimaryActionInput;
        $[24] = intl;
        $[25] = spaceId;
        $[26] = spaceKey;
        $[27] = t7;
    } else t7 = $[27];
    const handleDeleteClick = t7;
    let t8;
    if ($[28] !== createAnalyticsEvent || $[29] !== exitMultiSelect || $[30] !== spaceKey) {
        t8 = ()=>{
            createAnalyticsEvent({
                type: "sendTrackEvent",
                data: {
                    source: "contentTreeBulkActions",
                    action: "closed",
                    actionSubject: "bulkActionsMenu",
                    attributes: {
                        method: "exitActionButton"
                    }
                }
            }).fire();
            createAnalyticsEvent({
                type: "sendUIEvent",
                data: {
                    source: $60ad31f4e0dd72f9$export$4b71c44db98cf846,
                    action: "clicked",
                    actionSubject: "button",
                    actionSubjectId: $60ad31f4e0dd72f9$var$BULK_ACTION_SUBJECT_ID,
                    attributes: {
                        action: $60ad31f4e0dd72f9$export$f320192b45e546dc,
                        spaceKey: spaceKey
                    }
                }
            }).fire();
            exitMultiSelect();
        };
        $[28] = createAnalyticsEvent;
        $[29] = exitMultiSelect;
        $[30] = spaceKey;
        $[31] = t8;
    } else t8 = $[31];
    const handleExitClick = t8;
    let t9;
    if ($[32] === Symbol.for("react.memo_cache_sentinel")) {
        t9 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($l3wuH))), {
            label: ""
        });
        $[32] = t9;
    } else t9 = $[32];
    let t10;
    if ($[33] !== clearSelection || $[34] !== count || $[35] !== isDescendantCountLoading) {
        t10 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c33509509e92d1b9$export$70bde410d897c00a), {
            actionText: $60ad31f4e0dd72f9$var$i18n.selected,
            actionIcon: t9,
            actionName: $60ad31f4e0dd72f9$export$9abc4b344c9f62bb,
            count: count,
            onClick: clearSelection,
            isLoading: isDescendantCountLoading
        });
        $[33] = clearSelection;
        $[34] = count;
        $[35] = isDescendantCountLoading;
        $[36] = t10;
    } else t10 = $[36];
    const countButton = t10;
    let t11;
    if ($[37] === Symbol.for("react.memo_cache_sentinel")) {
        t11 = [
            (0, $kRW4Y.DialogsStateContainer),
            (0, $gqqjz.FlagsStateContainer)
        ];
        $[37] = t11;
    } else t11 = $[37];
    let t12;
    if ($[38] !== count || $[39] !== countButton || $[40] !== handleArchiveClick || $[41] !== handleDeleteClick || $[42] !== handleExitClick || $[43] !== intl || $[44] !== isArchiveLimitReached || $[45] !== isDeleteLimitReached || $[46] !== isDescendantCountLoading || $[47] !== isModalOpen) {
        t12 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $kNIYN.Subscribe), {
            to: t11
        }, (dialogs_1, flags_1)=>/*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $2wCqQ.default), {
                space: "space.100",
                alignBlock: "start",
                xcss: $60ad31f4e0dd72f9$var$menuStyles,
                role: "toolbar",
                "aria-label": intl.formatMessage($60ad31f4e0dd72f9$var$i18n.bulkActionsLabel)
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $9GVkD.default), {
                role: "status",
                "aria-live": "assertive",
                "aria-atomic": "true"
            }, intl.formatMessage($60ad31f4e0dd72f9$var$i18n.announceMenuOpen)), isDescendantCountLoading ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $lpNn5.default), {
                content: intl.formatMessage($60ad31f4e0dd72f9$var$i18n.loadingTooltip),
                position: "right"
            }, countButton) : countButton, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c33509509e92d1b9$export$70bde410d897c00a), {
                actionText: $60ad31f4e0dd72f9$var$i18n.archive,
                actionIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($31le2))), {
                    label: ""
                }),
                actionName: $60ad31f4e0dd72f9$export$bcfb39b8f6d9105e,
                count: count,
                onClick: ()=>handleArchiveClick(dialogs_1, flags_1),
                isSelectionLimitReached: isArchiveLimitReached,
                actionLimit: (0, $aqBZ0.BULK_ARCHIVE_PAGE_SELECTION_LIMIT),
                isDisabled: isModalOpen
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c33509509e92d1b9$export$70bde410d897c00a), {
                actionText: $60ad31f4e0dd72f9$var$i18n.delete,
                actionIcon: /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, (/*@__PURE__*/$parcel$interopDefault($iDfTs))), {
                    label: ""
                }),
                actionName: $60ad31f4e0dd72f9$export$2298ba3671f5c8c7,
                count: count,
                onClick: ()=>handleDeleteClick(dialogs_1, flags_1),
                isSelectionLimitReached: isDeleteLimitReached,
                actionLimit: (0, $abCbd.BULK_DELETE_PAGE_SELECTION_LIMIT_DEFAULT),
                isDisabled: isModalOpen
            }), /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3izAL.default), {
                xcss: $60ad31f4e0dd72f9$var$exitButtonStyle
            }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $c33509509e92d1b9$export$70bde410d897c00a), {
                actionText: $60ad31f4e0dd72f9$var$i18n.exit,
                actionName: $60ad31f4e0dd72f9$export$f320192b45e546dc,
                count: count,
                onClick: handleExitClick
            }))));
        $[38] = count;
        $[39] = countButton;
        $[40] = handleArchiveClick;
        $[41] = handleDeleteClick;
        $[42] = handleExitClick;
        $[43] = intl;
        $[44] = isArchiveLimitReached;
        $[45] = isDeleteLimitReached;
        $[46] = isDescendantCountLoading;
        $[47] = isModalOpen;
        $[48] = t12;
    } else t12 = $[48];
    return t12;
};
const $60ad31f4e0dd72f9$var$i18n = (0, $kSwu1.defineMessages)({
    selected: {
        id: "page-tree.bulk-actions-menu.selected",
        defaultMessage: "{count, plural, one {# item} other {# items}} selected"
    },
    archive: {
        id: "page-tree.bulk-actions-menu.archive",
        defaultMessage: "Archive"
    },
    delete: {
        id: "page-tree.bulk-actions-menu.delete",
        defaultMessage: "Delete"
    },
    exit: {
        id: "page-tree.bulk-actions-menu.exit",
        defaultMessage: "Exit"
    },
    bulkActionsLabel: {
        id: "page-tree.bulk-actions-menu.label",
        defaultMessage: "Bulk actions menu"
    },
    announceMenuOpen: {
        id: "page-tree.bulk-actions-menu.announce-menu-open",
        defaultMessage: "Bulk actions menu for the content tree is open."
    },
    loadingTooltip: {
        id: "page-tree.bulk-actions-menu.loading-tooltip",
        defaultMessage: "We\u2019re still processing your selection. This may take longer depending on the amount of content."
    },
    flagErrorTitle: {
        id: "page-tree.bulk-actions-menu.error.title",
        defaultMessage: "Something went wrong"
    },
    flagErrorDescription: {
        id: "page-tree.bulk-actions-menu.error.description",
        defaultMessage: "Refresh and try again. If this keeps happening, contact your space administrator."
    }
});
const $60ad31f4e0dd72f9$var$menuStyles = (0, $buxP3.xcss)({
    position: 'fixed',
    top: 'calc(316px + var(--topNavigationHeight, 0px))',
    left: 'calc(9px + var(--leftSidebarWidth, 0px))'
});
const $60ad31f4e0dd72f9$var$exitButtonStyle = (0, $buxP3.xcss)({
    paddingTop: 'space.100'
});



var $c4LIS = parcelRequire("c4LIS");

/**
 * @generated SignedSource<<363a61548fb178724f0f1b1c17961304>>
 * @relayHash 9eaef2a34ca96ab2ac994463c9f14cdb
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID ab689671758f5e02698c97d26317ddce0a4da5c29c74139f329d82c758697d95
const $67a2e637a8df73cb$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = [
        {
            "alias": "user",
            "args": [
                {
                    "kind": "Literal",
                    "name": "current",
                    "value": true
                }
            ],
            "concreteType": "AtlassianUser",
            "kind": "LinkedField",
            "name": "confluence_atlassianUser",
            "plural": false,
            "selections": [
                v0 /*: any*/ ,
                {
                    "concreteType": "ConfluenceUser",
                    "kind": "LinkedField",
                    "name": "confluence",
                    "plural": false,
                    "selections": [
                        {
                            "kind": "ScalarField",
                            "name": "hasPersonalSpace"
                        },
                        {
                            "concreteType": "Space",
                            "kind": "LinkedField",
                            "name": "space",
                            "plural": false,
                            "selections": [
                                {
                                    "kind": "ScalarField",
                                    "name": "key"
                                },
                                v0 /*: any*/ 
                            ]
                        }
                    ]
                }
            ],
            "storageKey": "confluence_atlassianUser(current:true)"
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": [],
            "kind": "Fragment",
            "name": "useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery",
            "selections": v1 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": [],
            "kind": "Operation",
            "name": "useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery",
            "selections": v1 /*: any*/ 
        },
        "params": {
            "cacheID": "9eaef2a34ca96ab2ac994463c9f14cdb",
            "id": "ab689671758f5e02698c97d26317ddce0a4da5c29c74139f329d82c758697d95",
            "metadata": {},
            "name": "useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery",
            "operationKind": "query",
            "text": "query useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery{user:confluence_atlassianUser(current:true){id,confluence{hasPersonalSpace,space{key,id}}}}"
        }
    };
}();
$67a2e637a8df73cb$var$node.hash = "6fe5c1685a204de18171323aa7dc40fa";
var $67a2e637a8df73cb$export$2e2bcd8739ae039 = $67a2e637a8df73cb$var$node;






var $iDE8i = parcelRequire("iDE8i");








var $7QM6o = parcelRequire("7QM6o");


var $cLo2u = parcelRequire("cLo2u");


var $88DkZ = parcelRequire("88DkZ");

// GraphQL query to get the current user's personal space key
const $f64f941618d0e751$var$useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery = (0, $67a2e637a8df73cb$export$2e2bcd8739ae039);
// Keywords to detect meeting-related pages
const $f64f941618d0e751$var$MEETING_KEYWORDS = [
    '1:1',
    'meeting',
    '<>',
    'weekly',
    'biweekly',
    'ongoing',
    'running',
    'sync',
    'discussion',
    'session',
    '1-1'
];
const $f64f941618d0e751$export$bc0f5ad46d928429 = (pages)=>{
    const { createAnalyticsEvent: createAnalyticsEvent } = (0, $9DHhW.useAnalyticsEvents)();
    const context = (0, $iDE8i.usePostOfficeSideNavMessages)();
    const hasTrackedRef = (0, $cozmU.useRef)(false);
    const [shouldQueryPersonalSpace, setShouldQueryPersonalSpace] = (0, $cozmU.useState)(false);
    const spaceKey = (0, $cLo2u.useSpaceKey)();
    const spaceId = (0, $7QM6o.useSpaceId)();
    // Only query for personal space info if we detect 1+ meeting pages
    const { data: personalSpaceData } = (0, $jMyy4.useQueryInterop)($f64f941618d0e751$var$useOneOnOnePagesAnalyticsGetCurrentUserPersonalSpaceQuery, {
        skip: !shouldQueryPersonalSpace || !spaceKey,
        __callerPackage__: "page-tree"
    });
    (0, $cozmU.useEffect)(()=>{
        if (!pages || Object.keys(pages).length === 0 || !spaceKey || !context) return;
        const oneOnOnePages = Object.values(pages).filter((page)=>{
            const title = page.data?.title?.toLowerCase() || '';
            const fullTitle = page.data?.fullTitle?.toLowerCase() || '';
            return $f64f941618d0e751$var$MEETING_KEYWORDS.some((keyword)=>title.includes(keyword) || fullTitle.includes(keyword));
        });
        // First check if we have 1+ meeting pages
        if (oneOnOnePages.length >= 1) {
            // Enable the personal space query if not already done
            if (!shouldQueryPersonalSpace) {
                setShouldQueryPersonalSpace(true);
                return; // Wait for query to complete
            }
            // Now check if we're in the user's personal space
            const userPersonalSpaceKey = personalSpaceData?.user?.confluence?.space?.key;
            // Only fire analytics if current space is the user's personal space
            if (userPersonalSpaceKey && spaceKey === userPersonalSpaceKey && !hasTrackedRef.current) {
                createAnalyticsEvent((0, $88DkZ.oneOnOnePagesDetectedEvent)(oneOnOnePages.length, Object.keys(pages).length, spaceId)).fire();
                // Enable post office side nav message for 1:1 pages detected
                context.enablePostOfficeSideNavMessage('1_ON_1_LOOM_NUDGE');
                hasTrackedRef.current = true;
            }
        }
    }, [
        pages,
        createAnalyticsEvent,
        spaceId,
        spaceKey,
        personalSpaceData,
        shouldQueryPersonalSpace,
        context
    ]);
};






const $d41f1ffe44e2b386$export$e1c19f316cce4828 = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "3Vgv7",
    name: "PageTreeEmptyComponentLoader",
    loader: async ()=>(await (parcelRequire("4Wdup"))).PageTreeEmptyComponent
});






const $844bf5108de244e8$export$ab00dd23925d8af0 = (0, $jmjWc.LoadableAfterPaint)({
    __loadable_id__: "98kol",
    name: "FooterCreateButtons",
    loader: async ()=>(await (parcelRequire("2fuD6"))).FooterCreateButtons
});


/**
 * @generated SignedSource<<47c3069e91ca33dd72d3e422dc522c17>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $b73969b352088464$var$node = function() {
    var v0 = {
        "kind": "Literal",
        "name": "enablePaging",
        "value": true
    }, v1 = {
        "kind": "Variable",
        "name": "pageTree",
        "variableName": "paginationLimit"
    }, v2 = {
        "kind": "Variable",
        "name": "spaceKey",
        "variableName": "spaceKey"
    }, v3 = {
        "kind": "Variable",
        "name": "status",
        "variableName": "ptStatuses"
    }, v4 = {
        "kind": "ScalarField",
        "name": "id"
    }, v5 = {
        "kind": "ScalarField",
        "name": "title"
    }, v6 = {
        "kind": "ScalarField",
        "name": "status"
    }, v7 = {
        "kind": "ScalarField",
        "name": "value"
    }, v8 = {
        "args": [
            {
                "kind": "Literal",
                "name": "format",
                "value": "MILLIS"
            }
        ],
        "concreteType": "ConfluenceDate",
        "kind": "LinkedField",
        "name": "createdDate",
        "plural": false,
        "selections": [
            v7 /*: any*/ 
        ],
        "storageKey": "createdDate(format:\"MILLIS\")"
    }, v9 = {
        "kind": "ScalarField",
        "name": "hasChildren"
    }, v10 = {
        "kind": "ScalarField",
        "name": "blank"
    }, v11 = {
        "kind": "ScalarField",
        "name": "type"
    }, v12 = {
        "kind": "ScalarField",
        "name": "subType"
    }, v13 = {
        "concreteType": "Map_LinkType_String",
        "kind": "LinkedField",
        "name": "links",
        "plural": false,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "webui"
            }
        ]
    }, v14 = {
        "args": [
            {
                "kind": "Literal",
                "name": "keys",
                "value": [
                    "emoji-title-published",
                    "emoji-title-draft",
                    "editor"
                ]
            }
        ],
        "concreteType": "PaginatedJsonContentPropertyList",
        "kind": "LinkedField",
        "name": "properties",
        "plural": false,
        "selections": [
            {
                "concreteType": "JsonContentProperty",
                "kind": "LinkedField",
                "name": "nodes",
                "plural": true,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "kind": "ScalarField",
                        "name": "key"
                    },
                    v7 /*: any*/ ,
                    {
                        "concreteType": "Version",
                        "kind": "LinkedField",
                        "name": "version",
                        "plural": false,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "number"
                            }
                        ]
                    }
                ]
            }
        ],
        "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
    }, v15 = {
        "condition": "isSuperAdmin",
        "kind": "Condition",
        "passingValue": true,
        "selections": [
            {
                "kind": "ScalarField",
                "name": "hasRestrictions"
            },
            {
                "kind": "ScalarField",
                "name": "hasInheritedRestrictions"
            }
        ]
    }, v16 = {
        "kind": "ScalarField",
        "name": "hasNextPage"
    }, v17 = [
        {
            "concreteType": "PTPage",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                v4 /*: any*/ ,
                v5 /*: any*/ ,
                v6 /*: any*/ ,
                v8 /*: any*/ ,
                v9 /*: any*/ ,
                v10 /*: any*/ ,
                v11 /*: any*/ ,
                v12 /*: any*/ ,
                v13 /*: any*/ ,
                v14 /*: any*/ ,
                v15 /*: any*/ 
            ]
        },
        {
            "concreteType": "PTPageInfo",
            "kind": "LinkedField",
            "name": "pageInfo",
            "plural": false,
            "selections": [
                v16 /*: any*/ 
            ]
        }
    ], v18 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "previousSiblings",
        "plural": false,
        "selections": v17 /*: any*/ 
    }, v19 = {
        "concreteType": "PTPaginatedPageList",
        "kind": "LinkedField",
        "name": "followingSiblings",
        "plural": false,
        "selections": v17 /*: any*/ 
    }, v20 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        {
            "concreteType": "PTPaginatedPageList",
            "kind": "LinkedField",
            "name": "nearestAncestors",
            "plural": false,
            "selections": [
                {
                    "concreteType": "PTPageInfo",
                    "kind": "LinkedField",
                    "name": "pageInfo",
                    "plural": false,
                    "selections": [
                        v16 /*: any*/ ,
                        {
                            "kind": "ScalarField",
                            "name": "endCursor"
                        }
                    ]
                },
                {
                    "concreteType": "PTPage",
                    "kind": "LinkedField",
                    "name": "nodes",
                    "plural": true,
                    "selections": [
                        v4 /*: any*/ ,
                        v5 /*: any*/ ,
                        v6 /*: any*/ ,
                        v8 /*: any*/ ,
                        v9 /*: any*/ ,
                        v10 /*: any*/ ,
                        v11 /*: any*/ ,
                        v12 /*: any*/ ,
                        v13 /*: any*/ ,
                        v14 /*: any*/ ,
                        v15 /*: any*/ ,
                        v18 /*: any*/ ,
                        v19 /*: any*/ 
                    ]
                }
            ]
        },
        v18 /*: any*/ ,
        v19 /*: any*/ ,
        {
            "concreteType": "PTPaginatedPageList",
            "kind": "LinkedField",
            "name": "children",
            "plural": false,
            "selections": v17 /*: any*/ 
        }
    ], v21 = [
        v4 /*: any*/ ,
        v5 /*: any*/ ,
        v6 /*: any*/ ,
        v8 /*: any*/ ,
        v9 /*: any*/ ,
        v10 /*: any*/ ,
        v11 /*: any*/ ,
        v12 /*: any*/ ,
        v13 /*: any*/ ,
        v14 /*: any*/ ,
        v15 /*: any*/ ,
        v19 /*: any*/ 
    ];
    return {
        "argumentDefinitions": [
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "contentId"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "includeHomepageTreeVariant"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "includePageTree"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "isSuperAdmin"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "paginationLimit"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "ptStatuses"
            },
            {
                "defaultValue": null,
                "kind": "LocalArgument",
                "name": "spaceKey"
            }
        ],
        "kind": "Fragment",
        "name": "PageTreeInitialData_query",
        "selections": [
            {
                "condition": "includePageTree",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "currentPage",
                        "args": [
                            v0 /*: any*/ ,
                            {
                                "kind": "Variable",
                                "name": "id",
                                "variableName": "contentId"
                            },
                            v1 /*: any*/ ,
                            v2 /*: any*/ ,
                            v3 /*: any*/ 
                        ],
                        "concreteType": "PTPage",
                        "kind": "LinkedField",
                        "name": "ptpage",
                        "plural": false,
                        "selections": v20 /*: any*/ 
                    },
                    {
                        "alias": "rootPageTree",
                        "args": [
                            v0 /*: any*/ ,
                            v1 /*: any*/ ,
                            v2 /*: any*/ ,
                            v3 /*: any*/ 
                        ],
                        "concreteType": "PTPage",
                        "kind": "LinkedField",
                        "name": "ptpage",
                        "plural": false,
                        "selections": v21 /*: any*/ 
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Variable",
                        "name": "key",
                        "variableName": "spaceKey"
                    }
                ],
                "concreteType": "Space",
                "kind": "LinkedField",
                "name": "space",
                "plural": false,
                "selections": [
                    v4 /*: any*/ ,
                    {
                        "concreteType": "Content",
                        "kind": "LinkedField",
                        "name": "homepage",
                        "plural": false,
                        "selections": [
                            v4 /*: any*/ 
                        ]
                    },
                    {
                        "concreteType": "OperationCheckResult",
                        "kind": "LinkedField",
                        "name": "operations",
                        "plural": true,
                        "selections": [
                            {
                                "kind": "ScalarField",
                                "name": "operation"
                            },
                            {
                                "kind": "ScalarField",
                                "name": "targetType"
                            }
                        ]
                    },
                    {
                        "condition": "includeHomepageTreeVariant",
                        "kind": "Condition",
                        "passingValue": true,
                        "selections": [
                            {
                                "args": [
                                    v0 /*: any*/ ,
                                    v1 /*: any*/ ,
                                    v3 /*: any*/ 
                                ],
                                "concreteType": "PTPage",
                                "kind": "LinkedField",
                                "name": "pageTree",
                                "plural": false,
                                "selections": v20 /*: any*/ 
                            }
                        ]
                    }
                ]
            },
            {
                "condition": "includeHomepageTreeVariant",
                "kind": "Condition",
                "passingValue": true,
                "selections": [
                    {
                        "alias": "homepageRootPageTree",
                        "args": [
                            v2 /*: any*/ ,
                            v3 /*: any*/ 
                        ],
                        "concreteType": "PTPage",
                        "kind": "LinkedField",
                        "name": "ptpage",
                        "plural": false,
                        "selections": v21 /*: any*/ 
                    }
                ]
            }
        ],
        "type": "Query"
    };
}();
$b73969b352088464$var$node.hash = "e072e9ecc0309e9692fa9b3d05207e59";
var $b73969b352088464$export$2e2bcd8739ae039 = $b73969b352088464$var$node;


/**
 * @generated SignedSource<<38ff6b9fcdd2c559dc488303aa175746>>
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
const $05d9ea5225a4aed6$var$node = function() {
    var v0 = {
        "kind": "ScalarField",
        "name": "id"
    }, v1 = {
        "kind": "ScalarField",
        "name": "value"
    };
    return {
        "argumentDefinitions": [],
        "kind": "Fragment",
        "name": "PageTreeInitialDataNode_ptpage",
        "selections": [
            v0 /*: any*/ ,
            {
                "kind": "ScalarField",
                "name": "title"
            },
            {
                "kind": "ScalarField",
                "name": "status"
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "format",
                        "value": "MILLIS"
                    }
                ],
                "concreteType": "ConfluenceDate",
                "kind": "LinkedField",
                "name": "createdDate",
                "plural": false,
                "selections": [
                    v1 /*: any*/ 
                ],
                "storageKey": "createdDate(format:\"MILLIS\")"
            },
            {
                "kind": "ScalarField",
                "name": "hasChildren"
            },
            {
                "kind": "ScalarField",
                "name": "blank"
            },
            {
                "kind": "ScalarField",
                "name": "type"
            },
            {
                "kind": "ScalarField",
                "name": "subType"
            },
            {
                "concreteType": "Map_LinkType_String",
                "kind": "LinkedField",
                "name": "links",
                "plural": false,
                "selections": [
                    {
                        "kind": "ScalarField",
                        "name": "webui"
                    }
                ]
            },
            {
                "args": [
                    {
                        "kind": "Literal",
                        "name": "keys",
                        "value": [
                            "emoji-title-published",
                            "emoji-title-draft",
                            "editor"
                        ]
                    }
                ],
                "concreteType": "PaginatedJsonContentPropertyList",
                "kind": "LinkedField",
                "name": "properties",
                "plural": false,
                "selections": [
                    {
                        "concreteType": "JsonContentProperty",
                        "kind": "LinkedField",
                        "name": "nodes",
                        "plural": true,
                        "selections": [
                            v0 /*: any*/ ,
                            {
                                "kind": "ScalarField",
                                "name": "key"
                            },
                            v1 /*: any*/ ,
                            {
                                "concreteType": "Version",
                                "kind": "LinkedField",
                                "name": "version",
                                "plural": false,
                                "selections": [
                                    {
                                        "kind": "ScalarField",
                                        "name": "number"
                                    }
                                ]
                            }
                        ]
                    }
                ],
                "storageKey": "properties(keys:[\"emoji-title-published\",\"emoji-title-draft\",\"editor\"])"
            }
        ],
        "type": "PTPage"
    };
}();
$05d9ea5225a4aed6$var$node.hash = "96231be33dd9326741a8ab2ee7e340c8";
var $05d9ea5225a4aed6$export$2e2bcd8739ae039 = $05d9ea5225a4aed6$var$node;


const $73a87f824b3c592a$export$bf1c72e68d9b04fc = (0, $05d9ea5225a4aed6$export$2e2bcd8739ae039);
const $73a87f824b3c592a$export$9eeb1308c58021d8 = (0, $b73969b352088464$export$2e2bcd8739ae039);


const $4e592d9a1da9bab1$var$noop = ()=>{};

const $4e592d9a1da9bab1$var$PageTreeErrorComponentLoader = (0, $jmjWc.LoadableLazy)({
    __loadable_id__: "8EjeO",
    name: "PageTreeErrorComponentLoader",
    loader: async ()=>(await (parcelRequire("5EOno"))).PageTreeErrorComponent
});
const $4e592d9a1da9bab1$var$StopLinkClickSSRInlineScript = ()=>{
    const $ = (0, $bDgLe.c)(1);
    const nonceValue = window.__SSR_NONCE_VALUE__;
    let t0;
    if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement("script", {
            ...nonceValue !== undefined ? {
                nonce: nonceValue
            } : {},
            dangerouslySetInnerHTML: {
                __html: "(function(){\n  const rightChevrons = document.querySelectorAll('[data-testid=\"chevron-right\"]');\n  const downChevrons = document.querySelectorAll('[data-testid=\"chevron-down\"]');\n  const allChevrons = [...rightChevrons, ...downChevrons];\n  for(let i = 0; i <= allChevrons.length; i++){\n    allChevrons[i] ? allChevrons[i].onclick= function(e) {\n      e.preventDefault();\n      e.stopPropagation();\n    }: null;\n  }\n})()"
            }
        });
        $[0] = t0;
    } else t0 = $[0];
    return t0;
};
/**
 * Conditionally wraps `children` in a `MenuListItem` (`role="listitem"`).
 *
 * In the space sidebar the page tree renders inside `ExpandableMenuItemContent`, which is a
 * `role="list"`, so the tree's `<ul>`, the create buttons and the bulk-action menu all have to be
 * list items (CONFCLOUD-85073). Two reasons a callsite may opt out: the move dialog renders the same
 * tree outside any list, where a stray `role="listitem"` would be a violation of its own, and the
 * corrected markup is rolling out behind the `confluence_sidenav_content_list_semantics` experiment.
 */ const $4e592d9a1da9bab1$var$OptionalMenuListItem = (t0)=>{
    const $ = (0, $bDgLe.c)(3);
    const { asListItem: asListItem, children: children } = t0;
    let t1;
    if ($[0] !== asListItem || $[1] !== children) {
        t1 = asListItem ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $h11I1.MenuListItem), null, children) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, children);
        $[0] = asListItem;
        $[1] = children;
        $[2] = t1;
    } else t1 = $[2];
    return t1;
};
const $4e592d9a1da9bab1$export$9121ae6cff2a2b9f = /*#__PURE__*/ (0, $cozmU.memo)((t0)=>{
    const $ = (0, $bDgLe.c)(220);
    const { currentPageId: currentPageId, isPeekingFromBlogs: isPeekingFromBlogs, isSuperAdmin: isSuperAdmin, spaceKey: spaceKey, statuses: statuses, expandSpaceHomepage: t1, onInitialLoadComplete: t2, onLoadMore: t3, onDragStart: t4, onPageMove: t5, setIsPageTreeLoading: t6, onMoveInvalid: onMoveInvalid, renderItem: renderItem, forceFetchCurrentPage: t7, forceFetchedCallback: forceFetchedCallback, optimisticDeleteId: optimisticDeleteId, clearDeleteId: clearDeleteId, highlightPages: t8, isDraggable: isDraggable, syntheticItem: syntheticItem, detached: t9, syntheticItemIsDraft: syntheticItemIsDraft, getIsDraggingItem: getIsDraggingItem, setIsDraggingItem: setIsDraggingItem, dragPreview: dragPreview, renderResourcedEmoji: renderResourcedEmoji, setContentTreeSize: setContentTreeSize, setIsPageTreeEmpty: setIsPageTreeEmpty, isMovePageTree: isMovePageTree, moveToParentId: moveToParentId, pageTreeStateUpdatesContainer: pageTreeStateUpdatesContainer, isCreateContentRoute: t10, flags: flags } = t0;
    const expandSpaceHomepage = t1 === undefined ? false : t1;
    const onInitialLoadComplete = t2 === undefined ? $4e592d9a1da9bab1$var$noop : t2;
    const onLoadMore = t3 === undefined ? $4e592d9a1da9bab1$var$noop : t3;
    const onDragStart = t4 === undefined ? $4e592d9a1da9bab1$var$noop : t4;
    const onPageMove = t5 === undefined ? $4e592d9a1da9bab1$var$noop : t5;
    const setIsPageTreeLoading = t6 === undefined ? $4e592d9a1da9bab1$var$noop : t6;
    const forceFetchCurrentPage = t7 === undefined ? false : t7;
    let t11;
    if ($[0] !== t8) {
        t11 = t8 === undefined ? [] : t8;
        $[0] = t8;
        $[1] = t11;
    } else t11 = $[1];
    const highlightPages = t11;
    const detached = t9 === undefined ? false : t9;
    const isCreateContentRoute = t10 === undefined ? false : t10;
    let t12;
    if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
        t12 = {
            previousPageId: "",
            previousSpaceKey: "",
            previousHighlightedPages: [],
            previousForceFetchCurrentPage: false,
            loadingUseEffect: false
        };
        $[2] = t12;
    } else t12 = $[2];
    const prevPropsRef = (0, $cozmU.useRef)(t12);
    const isMountedRef = (0, $cozmU.useRef)(true);
    const intl = (0, $kSwu1.useIntl)();
    const [state, actions] = (0, $jGj7w.usePageTreeState)();
    const [isMultiSelectActive] = (0, $2vuKf.useIsMultiSelectActive)();
    const { pages: pages, space: space, rootId: rootId, isTreeTruncatedPrevious: isTreeTruncatedPrevious, isTreeTruncatedFollowing: isTreeTruncatedFollowing, isPageTreeLoading: isPageTreeLoading } = state;
    const renderServerPlaceholder = (0, $e4o8D.useRenderServerPlaceholder)();
    const { match: match } = (0, $cozmU.useContext)((0, $7zgzO.RoutesContext));
    const [contentIdsWithLoadedChildren] = (0, $jGj7w.useContentIdsWithLoadedChildren)();
    const selectContentAndDescendants = (0, $c4LIS.useNestedSelect)();
    const isMovingHomepage = isMovePageTree && syntheticItem?.id === space?.homepage?.id;
    let t13;
    if ($[3] !== isMovingHomepage || $[4] !== isPageTreeLoading || $[5] !== pages || $[6] !== rootId || $[7] !== space?.homepage?.id) {
        t13 = !isPageTreeLoading && (space?.homepage?.id && rootId == space?.homepage?.id && pages[rootId]?.children?.length == 0 && !isMovingHomepage || !space?.homepage?.id && Object.keys(pages).length <= 2 || space?.homepage?.id && rootId != space?.homepage?.id && Object.keys(pages).length < 3);
        $[3] = isMovingHomepage;
        $[4] = isPageTreeLoading;
        $[5] = pages;
        $[6] = rootId;
        $[7] = space?.homepage?.id;
        $[8] = t13;
    } else t13 = $[8];
    const isPageTreeEmpty = Boolean(t13);
    let t14;
    let t15;
    if ($[9] !== pages || $[10] !== setContentTreeSize) {
        t14 = ()=>{
            setContentTreeSize && setContentTreeSize(Object.keys(pages).length);
        };
        t15 = [
            pages,
            setContentTreeSize
        ];
        $[9] = pages;
        $[10] = setContentTreeSize;
        $[11] = t14;
        $[12] = t15;
    } else {
        t14 = $[11];
        t15 = $[12];
    }
    (0, $cozmU.useEffect)(t14, t15);
    let t16;
    let t17;
    if ($[13] !== isPageTreeEmpty || $[14] !== setIsPageTreeEmpty) {
        t16 = ()=>{
            setIsPageTreeEmpty && setIsPageTreeEmpty(isPageTreeEmpty);
        };
        t17 = [
            isPageTreeEmpty,
            setIsPageTreeEmpty
        ];
        $[13] = isPageTreeEmpty;
        $[14] = setIsPageTreeEmpty;
        $[15] = t16;
        $[16] = t17;
    } else {
        t16 = $[15];
        t17 = $[16];
    }
    (0, $cozmU.useEffect)(t16, t17);
    let t18;
    if ($[17] !== onLoadMore || $[18] !== space?.id) {
        t18 = (pageCount, direction)=>{
            if (onLoadMore) onLoadMore(pageCount, space?.id, direction);
        };
        $[17] = onLoadMore;
        $[18] = space?.id;
        $[19] = t18;
    } else t18 = $[19];
    const onLoadMoreFn = t18;
    const { loadPreviousPages: loadPreviousPages, loadFollowingPages: loadFollowingPages, reloadChildren: reloadChildren, queryChildren: queryChildren } = (0, $34ce551f827e69ec$export$b005fb2b94547bd6)(spaceKey, isSuperAdmin, statuses, onLoadMoreFn);
    const { refetch: loadPages } = (0, $34ce551f827e69ec$export$2876891f14dc554a)("1", true, false, detached, spaceKey, isSuperAdmin);
    const { refetch: forceFetchPages } = (0, $34ce551f827e69ec$export$2876891f14dc554a)("1", true, true, detached, spaceKey, isSuperAdmin);
    const { refetch: fetchRoot } = (0, $34ce551f827e69ec$export$2876891f14dc554a)(undefined, true, true, detached, spaceKey, isSuperAdmin);
    const updateData = (0, $34ce551f827e69ec$export$4a34638c035ec952)(spaceKey, expandSpaceHomepage, syntheticItem, isPeekingFromBlogs, isSuperAdmin, statuses, syntheticItemIsDraft, pageTreeStateUpdatesContainer);
    let t19;
    if ($[20] !== actions || $[21] !== match?.name) {
        t19 = (data)=>{
            if (data?.ptpage === null && data?.currentPage !== null && data?.space?.homepage !== null && match?.name === (0, $1NBp8.SPACE_OVERVIEW).name) actions.handleLoadingError(new (0, $422HI.ApolloErrorInterop)({
                errorMessage: "ptpage query unexpectedly returned null"
            }));
        };
        $[20] = actions;
        $[21] = match?.name;
        $[22] = t19;
    } else t19 = $[22];
    match?.name;
    const handleUnexpectedPtpageNull = t19;
    let t20;
    if ($[23] !== actions || $[24] !== forceFetchCurrentPage || $[25] !== forceFetchedCallback || $[26] !== handleUnexpectedPtpageNull || $[27] !== state || $[28] !== updateData) {
        t20 = async (response)=>{
            const { data: data_0, error: error } = response;
            handleUnexpectedPtpageNull(data_0);
            if (error) {
                if (isMountedRef.current) actions.handleLoadingError(error);
                return data_0;
            } else {
                actions.setIsPageTreeLoading(false);
                updateData(data_0);
                if (forceFetchCurrentPage && forceFetchedCallback) forceFetchedCallback(state);
                return data_0;
            }
        };
        $[23] = actions;
        $[24] = forceFetchCurrentPage;
        $[25] = forceFetchedCallback;
        $[26] = handleUnexpectedPtpageNull;
        $[27] = state;
        $[28] = updateData;
        $[29] = t20;
    } else t20 = $[29];
    const handleData = t20;
    let t21;
    if ($[30] !== onMoveInvalid || $[31] !== onPageMove || $[32] !== queryChildren || $[33] !== syntheticItem) {
        t21 = {
            onMoveInvalid: onMoveInvalid,
            syntheticItem: syntheticItem,
            onPageMove: onPageMove,
            queryChildren: queryChildren
        };
        $[30] = onMoveInvalid;
        $[31] = onPageMove;
        $[32] = queryChildren;
        $[33] = syntheticItem;
        $[34] = t21;
    } else t21 = $[34];
    const movePage = (0, $5118cf9ac37d7a42$export$63f1f45217bf3813)(t21);
    let t22;
    if ($[35] !== actions || $[36] !== intl || $[37] !== movePage) {
        t22 = (contentId, action)=>{
            const { pages: currentPages } = actions.getState();
            const item = currentPages[contentId];
            const parentId = item ? (0, $jGj7w.findParentId)(currentPages, contentId) : undefined;
            if (!parentId || !currentPages[parentId]) return;
            const siblings = currentPages[parentId].children ?? [];
            const index = siblings.indexOf(contentId);
            if (index === -1) return;
            const source = {
                parentId: parentId,
                index: index
            };
            if (action === "up" || action === "down" || action === "top" || action === "bottom") {
                const lastIndex = siblings.length - 1;
                const destinationIndex = action === "up" ? index - 1 : action === "down" ? index + 1 : action === "top" ? 0 : lastIndex;
                if (destinationIndex < 0 || destinationIndex > lastIndex || destinationIndex === index) return;
                const reason = action === "up" ? "keyboard-reorder-up" : action === "down" ? "keyboard-reorder-down" : action === "top" ? "keyboard-move-to-top" : "keyboard-move-to-bottom";
                movePage(source, {
                    parentId: parentId,
                    index: destinationIndex
                }, reason);
                const { pages: updatedPages } = actions.getState();
                const updatedSiblings = updatedPages[parentId]?.children ?? [];
                const newIndex = updatedSiblings.indexOf(contentId);
                if (newIndex !== -1 && newIndex !== index) (0, $g6KTr.announce)(intl.formatMessage($4e592d9a1da9bab1$var$i18nReorder.reorderAnnouncement, {
                    title: item.data.title,
                    position: newIndex + 1,
                    total: updatedSiblings.length
                }));
                return;
            }
            if (action === "out") {
                const grandparentId = (0, $jGj7w.findParentId)(currentPages, parentId);
                if (!grandparentId || grandparentId === (0, $9rjMR.VIRTUAL_ROOT_ID) || grandparentId === (0, $9rjMR.VIRTUAL_LOCAL_ROOT_ID) || !currentPages[grandparentId]) return;
                const parentIndex = (currentPages[grandparentId].children ?? []).indexOf(parentId);
                if (parentIndex === -1) return;
                movePage(source, {
                    parentId: grandparentId,
                    index: parentIndex + 1
                }, "keyboard-move-out");
                (0, $g6KTr.announce)(intl.formatMessage($4e592d9a1da9bab1$var$i18nReorder.moveOutAnnouncement, {
                    title: item.data.title
                }));
                return;
            }
            if (index === 0) return;
            const previousSiblingId = siblings[index - 1];
            const previousSibling = currentPages[previousSiblingId];
            if (!previousSibling) return;
            movePage(source, {
                parentId: previousSiblingId,
                index: undefined
            }, "keyboard-move-into");
            (0, $g6KTr.announce)(intl.formatMessage($4e592d9a1da9bab1$var$i18nReorder.moveIntoAnnouncement, {
                title: item.data.title,
                target: previousSibling.data.title
            }));
        };
        $[35] = actions;
        $[36] = intl;
        $[37] = movePage;
        $[38] = t22;
    } else t22 = $[38];
    const onMovePageAction = t22;
    let t23;
    if ($[39] !== actions || $[40] !== currentPageId || $[41] !== detached || $[42] !== forceFetchPages || $[43] !== handleData || $[44] !== isSuperAdmin || $[45] !== spaceKey) {
        t23 = ()=>{
            actions.clearError();
            actions.setIsPageTreeLoading(true);
            const { options: options } = (0, $34ce551f827e69ec$export$c22e67505d83a820)(currentPageId, true, false, detached, spaceKey, isSuperAdmin);
            forceFetchPages(options.variables).then((response_0)=>handleData(response_0)).catch((error_0)=>handleData({
                    error: error_0
                }));
        };
        $[39] = actions;
        $[40] = currentPageId;
        $[41] = detached;
        $[42] = forceFetchPages;
        $[43] = handleData;
        $[44] = isSuperAdmin;
        $[45] = spaceKey;
        $[46] = t23;
    } else t23 = $[46];
    const handleRetry = t23;
    let t24;
    if ($[47] !== isPageTreeLoading || $[48] !== setIsPageTreeLoading) {
        t24 = ()=>{
            setIsPageTreeLoading(isPageTreeLoading);
        };
        $[47] = isPageTreeLoading;
        $[48] = setIsPageTreeLoading;
        $[49] = t24;
    } else t24 = $[49];
    const firePropCallbacks = t24;
    let t25;
    if ($[50] !== actions || $[51] !== clearDeleteId || $[52] !== currentPageId || $[53] !== detached || $[54] !== fetchRoot || $[55] !== firePropCallbacks || $[56] !== forceFetchCurrentPage || $[57] !== forceFetchPages || $[58] !== handleData || $[59] !== highlightPages || $[60] !== isCreateContentRoute || $[61] !== isSuperAdmin || $[62] !== loadPages || $[63] !== optimisticDeleteId || $[64] !== pages || $[65] !== queryChildren || $[66] !== space?.homepage?.id || $[67] !== spaceKey) {
        t25 = ()=>{
            if (isCreateContentRoute) return;
            const { previousPageId: previousPageId, previousSpaceKey: previousSpaceKey, previousHighlightedPages: previousHighlightedPages, previousForceFetchCurrentPage: previousForceFetchCurrentPage } = prevPropsRef.current;
            const { options: options_0 } = (0, $34ce551f827e69ec$export$c22e67505d83a820)(currentPageId, true, false, detached, spaceKey, isSuperAdmin);
            const fetchPages = currentPageId ? loadPages : fetchRoot;
            const fetchData = async ()=>{
                const fetchAndHandle = ()=>forceFetchPages(options_0.variables).then((response_1)=>handleData(response_1)).catch((error_1)=>handleData({
                            error: error_1
                        }));
                if (currentPageId && (forceFetchCurrentPage || previousPageId !== currentPageId)) {
                    const currentPageInMemory = pages[currentPageId];
                    const hasHydratedCurrentPageInMemory = currentPageInMemory && !currentPageInMemory.data.isOptimistic;
                    if (forceFetchCurrentPage && !previousForceFetchCurrentPage) return fetchAndHandle();
                    else if (highlightPages.length && !(0, (/*@__PURE__*/$parcel$interopDefault($3u5lg)))(previousHighlightedPages, highlightPages)) {
                        const highlightPage = pages[highlightPages[0]];
                        if (!highlightPage) return fetchAndHandle();
                        else {
                            if (highlightPage) return actions.expandPage(highlightPage, queryChildren);
                        }
                    } else {
                        if (!currentPageInMemory || currentPageInMemory.data.isOptimistic || spaceKey !== previousSpaceKey && previousSpaceKey !== "") {
                            const isCrossSpaceTransition = spaceKey !== previousSpaceKey && previousSpaceKey !== "";
                            if (!isCrossSpaceTransition && hasHydratedCurrentPageInMemory && (0, $6mKj3.expVal)("confluence_optimize_overview_transition_nav", "isEnabled", false)) {
                                firePropCallbacks();
                                return;
                            }
                            return fetchAndHandle();
                        } else if (!window.__SSR_RENDERED__ && previousPageId === "") {
                            const isCrossSpaceTransition_0 = spaceKey !== previousSpaceKey && previousSpaceKey !== "";
                            if (!isCrossSpaceTransition_0 && hasHydratedCurrentPageInMemory && (0, $6mKj3.expVal)("confluence_optimize_overview_transition_nav", "isEnabled", false)) {
                                firePropCallbacks();
                                return;
                            }
                            return fetchAndHandle();
                        } else {
                            if (currentPageId !== space?.homepage?.id && previousPageId !== currentPageId && currentPageInMemory && (currentPageInMemory.hasChildren || currentPageInMemory.data.type === "folder")) return actions.expandPage(currentPageInMemory, queryChildren, {
                                suppressAnalytics: true,
                                respectUserCollapse: true
                            });
                        }
                    }
                }
                if (!currentPageId && spaceKey !== previousSpaceKey) return fetchPages(options_0.variables).then((response_2)=>handleData(response_2)).catch((error_2)=>handleData({
                        error: error_2
                    }));
            };
            if (optimisticDeleteId) actions.optimisticDeleteContent(optimisticDeleteId, clearDeleteId);
            if (!prevPropsRef.current.loadingUseEffect || forceFetchCurrentPage && !previousForceFetchCurrentPage) {
                prevPropsRef.current.loadingUseEffect = true;
                fetchData().then((data_1)=>{
                    if (data_1) firePropCallbacks();
                    prevPropsRef.current.loadingUseEffect = false;
                }).catch((error_3)=>handleData({
                        error: error_3
                    }));
            }
            prevPropsRef.current.previousPageId = currentPageId;
            prevPropsRef.current.previousSpaceKey = spaceKey;
            prevPropsRef.current.previousHighlightedPages = highlightPages;
            prevPropsRef.current.previousForceFetchCurrentPage = forceFetchCurrentPage;
            actions.updatePersistedState();
        };
        $[50] = actions;
        $[51] = clearDeleteId;
        $[52] = currentPageId;
        $[53] = detached;
        $[54] = fetchRoot;
        $[55] = firePropCallbacks;
        $[56] = forceFetchCurrentPage;
        $[57] = forceFetchPages;
        $[58] = handleData;
        $[59] = highlightPages;
        $[60] = isCreateContentRoute;
        $[61] = isSuperAdmin;
        $[62] = loadPages;
        $[63] = optimisticDeleteId;
        $[64] = pages;
        $[65] = queryChildren;
        $[66] = space?.homepage?.id;
        $[67] = spaceKey;
        $[68] = t25;
    } else t25 = $[68];
    const t26 = space?.homepage?.id;
    let t27;
    if ($[69] !== actions || $[70] !== clearDeleteId || $[71] !== currentPageId || $[72] !== detached || $[73] !== fetchRoot || $[74] !== firePropCallbacks || $[75] !== forceFetchCurrentPage || $[76] !== forceFetchPages || $[77] !== forceFetchedCallback || $[78] !== handleData || $[79] !== highlightPages || $[80] !== isCreateContentRoute || $[81] !== isPeekingFromBlogs || $[82] !== isSuperAdmin || $[83] !== loadPages || $[84] !== optimisticDeleteId || $[85] !== pages || $[86] !== queryChildren || $[87] !== spaceKey || $[88] !== state || $[89] !== syntheticItem || $[90] !== syntheticItemIsDraft || $[91] !== t26) {
        t27 = [
            actions,
            currentPageId,
            actions.expandPage,
            forceFetchCurrentPage,
            forceFetchPages,
            highlightPages,
            loadPages,
            fetchRoot,
            pages,
            spaceKey,
            forceFetchedCallback,
            queryChildren,
            firePropCallbacks,
            detached,
            handleData,
            isSuperAdmin,
            isPeekingFromBlogs,
            state,
            syntheticItem,
            syntheticItemIsDraft,
            isCreateContentRoute,
            clearDeleteId,
            optimisticDeleteId,
            t26
        ];
        $[69] = actions;
        $[70] = clearDeleteId;
        $[71] = currentPageId;
        $[72] = detached;
        $[73] = fetchRoot;
        $[74] = firePropCallbacks;
        $[75] = forceFetchCurrentPage;
        $[76] = forceFetchPages;
        $[77] = forceFetchedCallback;
        $[78] = handleData;
        $[79] = highlightPages;
        $[80] = isCreateContentRoute;
        $[81] = isPeekingFromBlogs;
        $[82] = isSuperAdmin;
        $[83] = loadPages;
        $[84] = optimisticDeleteId;
        $[85] = pages;
        $[86] = queryChildren;
        $[87] = spaceKey;
        $[88] = state;
        $[89] = syntheticItem;
        $[90] = syntheticItemIsDraft;
        $[91] = t26;
        $[92] = t27;
    } else t27 = $[92];
    (0, $cozmU.useEffect)(t25, t27);
    let t28;
    let t29;
    if ($[93] === Symbol.for("react.memo_cache_sentinel")) {
        t28 = ()=>()=>{
                isMountedRef.current = false;
            };
        t29 = [];
        $[93] = t28;
        $[94] = t29;
    } else {
        t28 = $[93];
        t29 = $[94];
    }
    (0, $cozmU.useEffect)(t28, t29);
    let t30;
    if ($[95] !== actions) {
        t30 = (newContent)=>{
            actions.optimisticInsertContent(newContent);
        };
        $[95] = actions;
        $[96] = t30;
    } else t30 = $[96];
    (0, $ficwO.useMessageSubscriber)((0, $ficwO.Message).ContentCreated, t30);
    let t31;
    if ($[97] !== actions || $[98] !== queryChildren) {
        t31 = (t32)=>{
            const { contentId: contentId_0, subType: subType } = t32;
            const { pages: latestPages } = actions.getState();
            if (!latestPages[contentId_0]) return;
            actions.updateSinglePage(contentId_0, {
                subType: subType
            });
            if (!subType) {
                const clearManagedDescendants = (parentId_0)=>{
                    const { pages: currentPages_0 } = actions.getState();
                    const childIds = currentPages_0[parentId_0]?.children ?? [];
                    for (const childId of childIds){
                        const child = currentPages_0[childId];
                        if (child?.data?.subType === "managed") {
                            actions.updateSinglePage(childId, {
                                subType: null
                            });
                            clearManagedDescendants(childId);
                        }
                    }
                };
                clearManagedDescendants(contentId_0);
            }
            actions.refreshChildren(contentId_0, queryChildren);
        };
        $[97] = actions;
        $[98] = queryChildren;
        $[99] = t31;
    } else t31 = $[99];
    (0, $ficwO.useMessageSubscriber)((0, $ficwO.Message).SmartFolderSyncStateChanged, t31);
    (0, $f64f941618d0e751$export$bc0f5ad46d928429)(pages);
    const { movePage: movePageHandler } = (0, $55DRn.useMovePageHandler)();
    let t32;
    if ($[100] !== pages) {
        t32 = (0, $k0x5M.applyManagedFolderRestrictions)(pages);
        $[100] = pages;
        $[101] = t32;
    } else t32 = $[101];
    let t33;
    if ($[102] !== rootId || $[103] !== t32) {
        t33 = {
            rootId: rootId,
            items: t32
        };
        $[102] = rootId;
        $[103] = t32;
        $[104] = t33;
    } else t33 = $[104];
    const memoizedTree = t33;
    let t34;
    if ($[105] !== actions || $[106] !== movePage || $[107] !== syntheticItem) {
        t34 = async (item_0)=>{
            if (!syntheticItem) return;
            const sourceId = syntheticItem.id;
            if (item_0.id === sourceId) return;
            const { pages: latestPages_0 } = actions.getState();
            const sourceParentId = (0, $a5d73907e88ffc90$export$2cce9f4627a56f63)(latestPages_0, sourceId);
            if (!sourceParentId) return;
            const source_0 = {
                parentId: sourceParentId,
                index: latestPages_0[sourceParentId]?.children?.indexOf(sourceId)
            };
            const destination = {
                parentId: item_0.id
            };
            source_0.index !== -1 && movePage(source_0, destination);
        };
        $[105] = actions;
        $[106] = movePage;
        $[107] = syntheticItem;
        $[108] = t34;
    } else t34 = $[108];
    const onClick = t34;
    let t35;
    if ($[109] !== actions || $[110] !== isMovePageTree || $[111] !== moveToParentId || $[112] !== pages || $[113] !== queryChildren || $[114] !== syntheticItem) {
        t35 = {
            isMovePageTree: isMovePageTree,
            moveToParentId: moveToParentId,
            syntheticItem: syntheticItem,
            actions: actions,
            queryChildren: queryChildren,
            isMountedRef: isMountedRef,
            pages: pages
        };
        $[109] = actions;
        $[110] = isMovePageTree;
        $[111] = moveToParentId;
        $[112] = pages;
        $[113] = queryChildren;
        $[114] = syntheticItem;
        $[115] = t35;
    } else t35 = $[115];
    (0, $a5d73907e88ffc90$export$b63d3cf443da8a6c)(t35);
    let t36;
    if ($[116] !== actions || $[117] !== contentIdsWithLoadedChildren || $[118] !== flags || $[119] !== isMultiSelectActive || $[120] !== queryChildren || $[121] !== selectContentAndDescendants) {
        t36 = (page)=>{
            const wereChildrenPreviouslyLoaded = contentIdsWithLoadedChildren?.has(page.id) ?? false;
            actions.expandPage(page, queryChildren).then(()=>{
                if (isMultiSelectActive && !wereChildrenPreviouslyLoaded && flags) selectContentAndDescendants(page.id, false, flags);
            });
        };
        $[116] = actions;
        $[117] = contentIdsWithLoadedChildren;
        $[118] = flags;
        $[119] = isMultiSelectActive;
        $[120] = queryChildren;
        $[121] = selectContentAndDescendants;
        $[122] = t36;
    } else t36 = $[122];
    const expandPage = t36;
    let t37;
    if ($[123] !== actions || $[124] !== isDraggable || $[125] !== space) {
        t37 = (item_1)=>{
            const { pages: latestPages_1 } = actions.getState();
            const parent = item_1.parentId ? latestPages_1[item_1.parentId] : null;
            if (parent && (0, $k0x5M.isManagedFolder)(parent.data)) return false;
            return isDraggable(item_1, {
                space: space
            });
        };
        $[123] = actions;
        $[124] = isDraggable;
        $[125] = space;
        $[126] = t37;
    } else t37 = $[126];
    const isTreeDraggable = t37;
    const { isSmartFoldersEnabled: isSmartFoldersEnabled } = (0, $ftFOj.useIsSmartFoldersEnabled)(spaceKey);
    let t38;
    if ($[127] !== actions || $[128] !== onMoveInvalid) {
        t38 = (item_2)=>{
            const { pages: latestPages_2 } = actions.getState();
            const parent_0 = item_2.parentId ? latestPages_2[item_2.parentId] : null;
            if (parent_0 && (0, $k0x5M.isManagedFolder)(parent_0.data)) onMoveInvalid?.({
                reason: "INVALID_MOVE_LOCATION_MANAGED_FOLDER"
            });
        };
        $[127] = actions;
        $[128] = onMoveInvalid;
        $[129] = t38;
    } else t38 = $[129];
    const onDragBlocked = t38;
    let t39;
    if ($[130] !== actions.getCurrentTreeSize || $[131] !== actions.updateSinglePage || $[132] !== getIsDraggingItem || $[133] !== isSmartFoldersEnabled || $[134] !== onClick || $[135] !== onMovePageAction || $[136] !== renderItem || $[137] !== renderResourcedEmoji || $[138] !== space?.homepage?.id || $[139] !== space?.id) {
        t39 = (params)=>{
            const spaceHomePageId = space?.homepage?.id;
            const displayEmoji = params?.item?.data?.emoji;
            const contentType = params?.item?.data?.type;
            const isSmartLinkEmbed = contentType === "embed";
            let emoji;
            if (displayEmoji && !isSmartLinkEmbed) emoji = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $di8q4.LazyEmojiComponentLoader), {
                emoji: displayEmoji,
                context: "pageTree",
                height: 14,
                key: displayEmoji,
                wrapper: (0, $3aAh8.EmojiWrapper),
                renderResourcedEmoji: renderResourcedEmoji
            });
            return renderItem({
                ...params,
                spaceHomePageId: spaceHomePageId,
                onClick: onClick,
                updateSinglePage: actions.updateSinglePage,
                getIsDraggingItem: getIsDraggingItem,
                spaceId: space?.id,
                emoji: emoji,
                getContentTreeSize: actions.getCurrentTreeSize,
                isSmartFoldersEnabledForTree: isSmartFoldersEnabled,
                onMovePageAction: onMovePageAction
            });
        };
        $[130] = actions.getCurrentTreeSize;
        $[131] = actions.updateSinglePage;
        $[132] = getIsDraggingItem;
        $[133] = isSmartFoldersEnabled;
        $[134] = onClick;
        $[135] = onMovePageAction;
        $[136] = renderItem;
        $[137] = renderResourcedEmoji;
        $[138] = space?.homepage?.id;
        $[139] = space?.id;
        $[140] = t39;
    } else t39 = $[140];
    space?.homepage?.id;
    space?.id;
    const renderPageTreeItem = t39;
    let t40;
    if ($[141] !== onDragStart) {
        t40 = ()=>{
            onDragStart?.();
        };
        $[141] = onDragStart;
        $[142] = t40;
    } else t40 = $[142];
    const onDragStartFn = t40;
    if (state.error) {
        let t41;
        if ($[143] !== isMovePageTree) {
            t41 = !isMovePageTree && (0, $6mKj3.expValEquals)("confluence_sidenav_content_list_semantics", "isEnabled", true);
            $[143] = isMovePageTree;
            $[144] = t41;
        } else t41 = $[144];
        let t42;
        if ($[145] !== handleRetry || $[146] !== state.error.error || $[147] !== state.error.isExpected) {
            t42 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e592d9a1da9bab1$var$PageTreeErrorComponentLoader, {
                error: state.error.error,
                isExpected: state.error.isExpected,
                onRetry: handleRetry
            });
            $[145] = handleRetry;
            $[146] = state.error.error;
            $[147] = state.error.isExpected;
            $[148] = t42;
        } else t42 = $[148];
        let t43;
        if ($[149] !== t41 || $[150] !== t42) {
            t43 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e592d9a1da9bab1$var$OptionalMenuListItem, {
                asListItem: t41
            }, t42);
            $[149] = t41;
            $[150] = t42;
            $[151] = t43;
        } else t43 = $[151];
        return t43;
    }
    const showFooterCreateButtons = !detached && spaceKey !== "" && !isMultiSelectActive;
    if (isPageTreeEmpty) {
        let t41;
        if ($[152] !== isMovePageTree) {
            t41 = !isMovePageTree && (0, $6mKj3.expValEquals)("confluence_sidenav_content_list_semantics", "isEnabled", true);
            $[152] = isMovePageTree;
            $[153] = t41;
        } else t41 = $[153];
        let t42;
        if ($[154] !== actions || $[155] !== isPageTreeLoading || $[156] !== onInitialLoadComplete || $[157] !== rootId || $[158] !== showFooterCreateButtons || $[159] !== spaceKey) {
            t42 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $d41f1ffe44e2b386$export$e1c19f316cce4828), {
                rootId: rootId,
                spaceKey: spaceKey,
                isPageTreeLoading: isPageTreeLoading,
                showFooterCreateButtons: showFooterCreateButtons,
                onInitialLoadComplete: onInitialLoadComplete,
                actions: actions
            });
            $[154] = actions;
            $[155] = isPageTreeLoading;
            $[156] = onInitialLoadComplete;
            $[157] = rootId;
            $[158] = showFooterCreateButtons;
            $[159] = spaceKey;
            $[160] = t42;
        } else t42 = $[160];
        let t43;
        if ($[161] !== t41 || $[162] !== t42) {
            t43 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e592d9a1da9bab1$var$OptionalMenuListItem, {
                asListItem: t41
            }, t42);
            $[161] = t41;
            $[162] = t42;
            $[163] = t43;
        } else t43 = $[163];
        return t43;
    }
    let t41;
    if ($[164] !== isMovePageTree) {
        t41 = !isMovePageTree && (0, $6mKj3.expValEquals)("confluence_sidenav_content_list_semantics", "isEnabled", true);
        $[164] = isMovePageTree;
        $[165] = t41;
    } else t41 = $[165];
    let t42;
    if ($[166] !== isMovePageTree) {
        t42 = !isMovePageTree && {
            renderItemEmptyState: $5b61e06162a9104b$export$4fcfc92bcfdf296e
        };
        $[166] = isMovePageTree;
        $[167] = t42;
    } else t42 = $[167];
    let t43;
    if ($[168] !== actions.collapsePage || $[169] !== dragPreview || $[170] !== expandPage || $[171] !== isPageTreeLoading || $[172] !== isTreeDraggable || $[173] !== isTreeTruncatedFollowing || $[174] !== isTreeTruncatedPrevious || $[175] !== loadFollowingPages || $[176] !== loadPreviousPages || $[177] !== memoizedTree || $[178] !== movePage || $[179] !== onDragBlocked || $[180] !== onDragStartFn || $[181] !== onInitialLoadComplete || $[182] !== renderPageTreeItem || $[183] !== setIsDraggingItem || $[184] !== t42) {
        t43 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $1a3215c7f6382f73$export$330dddbe7c08afed), {
            isDraggable: isTreeDraggable,
            onDragBlocked: onDragBlocked,
            isTreeTruncatedPrevious: isTreeTruncatedPrevious,
            isTreeTruncatedFollowing: isTreeTruncatedFollowing,
            loadPreviousPages: loadPreviousPages,
            loadFollowingPages: loadFollowingPages,
            onCollapse: actions.collapsePage,
            onDragStart: onDragStartFn,
            onDragEnd: movePage,
            onExpand: expandPage,
            onInitialLoadComplete: onInitialLoadComplete,
            tree: memoizedTree,
            loading: isPageTreeLoading,
            renderItem: renderPageTreeItem,
            ...t42,
            setIsDraggingItem: setIsDraggingItem,
            dragPreview: dragPreview
        });
        $[168] = actions.collapsePage;
        $[169] = dragPreview;
        $[170] = expandPage;
        $[171] = isPageTreeLoading;
        $[172] = isTreeDraggable;
        $[173] = isTreeTruncatedFollowing;
        $[174] = isTreeTruncatedPrevious;
        $[175] = loadFollowingPages;
        $[176] = loadPreviousPages;
        $[177] = memoizedTree;
        $[178] = movePage;
        $[179] = onDragBlocked;
        $[180] = onDragStartFn;
        $[181] = onInitialLoadComplete;
        $[182] = renderPageTreeItem;
        $[183] = setIsDraggingItem;
        $[184] = t42;
        $[185] = t43;
    } else t43 = $[185];
    let t44;
    if ($[186] !== t41 || $[187] !== t43) {
        t44 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e592d9a1da9bab1$var$OptionalMenuListItem, {
            asListItem: t41
        }, t43);
        $[186] = t41;
        $[187] = t43;
        $[188] = t44;
    } else t44 = $[188];
    let t45;
    if ($[189] !== isMovePageTree || $[190] !== isPageTreeLoading || $[191] !== showFooterCreateButtons || $[192] !== spaceKey) {
        t45 = showFooterCreateButtons && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e592d9a1da9bab1$var$OptionalMenuListItem, {
            asListItem: !isMovePageTree && (0, $6mKj3.expValEquals)("confluence_sidenav_content_list_semantics", "isEnabled", true)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $844bf5108de244e8$export$ab00dd23925d8af0), {
            spaceKey: spaceKey,
            isContentTreeLoading: isPageTreeLoading
        }));
        $[189] = isMovePageTree;
        $[190] = isPageTreeLoading;
        $[191] = showFooterCreateButtons;
        $[192] = spaceKey;
        $[193] = t45;
    } else t45 = $[193];
    let t46;
    if ($[194] !== isMovePageTree || $[195] !== isMultiSelectActive) {
        t46 = isMultiSelectActive && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e592d9a1da9bab1$var$OptionalMenuListItem, {
            asListItem: !isMovePageTree && (0, $6mKj3.expValEquals)("confluence_sidenav_content_list_semantics", "isEnabled", true)
        }, /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $60ad31f4e0dd72f9$export$e3351feaa340049), null));
        $[194] = isMovePageTree;
        $[195] = isMultiSelectActive;
        $[196] = t46;
    } else t46 = $[196];
    let t47;
    if ($[197] === Symbol.for("react.memo_cache_sentinel")) {
        t47 = [
            (0, $c0urc.ReloadType).content
        ];
        $[197] = t47;
    } else t47 = $[197];
    const t48 = reloadChildren;
    let t49;
    if ($[198] !== t48) {
        t49 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $3Xs1I.QuickReloadSubscriber), {
            name: "pagetree",
            types: t47,
            reload: t48
        });
        $[198] = t48;
        $[199] = t49;
    } else t49 = $[199];
    let t50;
    if ($[200] !== actions || $[201] !== movePageHandler || $[202] !== queryChildren) {
        t50 = (params_0)=>actions.optimisticInsertSmartLinkEmbed({
                ...params_0,
                queryChildren: queryChildren,
                movePage: async (moveParams)=>{
                    if (params_0.position) await movePageHandler(moveParams);
                }
            });
        $[200] = actions;
        $[201] = movePageHandler;
        $[202] = queryChildren;
        $[203] = t50;
    } else t50 = $[203];
    let t51;
    if ($[204] !== actions) {
        t51 = (contentId_1)=>actions.optimisticDeleteContent(contentId_1, undefined);
        $[204] = actions;
        $[205] = t51;
    } else t51 = $[205];
    let t52;
    if ($[206] !== flags || $[207] !== spaceKey || $[208] !== t50 || $[209] !== t51) {
        t52 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $492ff87f1027b57e$export$2a8966ce55c8c689), {
            spaceKey: spaceKey,
            flags: flags,
            onInsert: t50,
            onDelete: t51
        });
        $[206] = flags;
        $[207] = spaceKey;
        $[208] = t50;
        $[209] = t51;
        $[210] = t52;
    } else t52 = $[210];
    let t53;
    if ($[211] !== renderServerPlaceholder) {
        t53 = renderServerPlaceholder && /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e592d9a1da9bab1$var$StopLinkClickSSRInlineScript, null);
        $[211] = renderServerPlaceholder;
        $[212] = t53;
    } else t53 = $[212];
    let t54;
    if ($[213] !== t44 || $[214] !== t45 || $[215] !== t46 || $[216] !== t49 || $[217] !== t52 || $[218] !== t53) {
        t54 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $cozmU.Fragment), null, t44, t45, t46, t49, t52, t53);
        $[213] = t44;
        $[214] = t45;
        $[215] = t46;
        $[216] = t49;
        $[217] = t52;
        $[218] = t53;
        $[219] = t54;
    } else t54 = $[219];
    return t54;
});
const $4e592d9a1da9bab1$var$useLegacyInitialData = (props)=>{
    const $ = (0, $bDgLe.c)(6);
    let t0;
    if ($[0] !== props.currentPageId || $[1] !== props.isSuperAdmin || $[2] !== props.spaceKey) {
        t0 = (0, $34ce551f827e69ec$export$c22e67505d83a820)(props.currentPageId, true, false, false, props.spaceKey, props.isSuperAdmin);
        $[0] = props.currentPageId;
        $[1] = props.isSuperAdmin;
        $[2] = props.spaceKey;
        $[3] = t0;
    } else t0 = $[3];
    const { query: query, options: options } = t0;
    let t1;
    if ($[4] !== options.variables) {
        t1 = {
            variables: options.variables,
            fetchPolicy: "cache-only"
        };
        $[4] = options.variables;
        $[5] = t1;
    } else t1 = $[5];
    return (0, $jMyy4.useQueryInterop)(query, {
        ...t1,
        __callerPackage__: "page-tree"
    });
};
const $4e592d9a1da9bab1$export$a6bc5c2967fe3170 = (props)=>{
    const $ = (0, $bDgLe.c)(3);
    const { initialDataFragmentRef: initialDataFragmentRef } = props;
    let t0;
    if ($[0] !== initialDataFragmentRef || $[1] !== props) {
        t0 = initialDataFragmentRef ? /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e592d9a1da9bab1$var$PageTreeCoordinatorFromFragment, {
            ...props,
            initialDataFragmentRef: initialDataFragmentRef
        }) : /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e592d9a1da9bab1$var$LegacyPageTreeCoordinator, props);
        $[0] = initialDataFragmentRef;
        $[1] = props;
        $[2] = t0;
    } else t0 = $[2];
    return t0;
};
const $4e592d9a1da9bab1$var$LegacyPageTreeCoordinator = (props)=>{
    const $ = (0, $bDgLe.c)(5);
    const { data: data, error: error, refetch: refetch } = $4e592d9a1da9bab1$var$useLegacyInitialData(props);
    let t0;
    if ($[0] !== data || $[1] !== error || $[2] !== props || $[3] !== refetch) {
        t0 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e592d9a1da9bab1$var$PageTreeCoordinatorInner, {
            ...props,
            initialData: data,
            error: error,
            refetch: refetch
        });
        $[0] = data;
        $[1] = error;
        $[2] = props;
        $[3] = refetch;
        $[4] = t0;
    } else t0 = $[4];
    return t0;
};
const $4e592d9a1da9bab1$var$PageTreeCoordinatorFromFragment = (props)=>{
    const $ = (0, $bDgLe.c)(10);
    const fragmentData = (0, $6SsN4.useFragment)((0, $73a87f824b3c592a$export$9eeb1308c58021d8), props.initialDataFragmentRef);
    const { error: error, refetch: refetch } = $4e592d9a1da9bab1$var$useLegacyInitialData(props);
    let t0;
    if ($[0] !== fragmentData.currentPage || $[1] !== fragmentData.homepageRootPageTree || $[2] !== fragmentData.rootPageTree || $[3] !== fragmentData.space) {
        t0 = fragmentData.currentPage != null || fragmentData.rootPageTree != null ? {
            currentPage: fragmentData.currentPage,
            ptpage: fragmentData.rootPageTree,
            space: fragmentData.space
        } : {
            currentPage: fragmentData.space?.pageTree ?? null,
            ptpage: fragmentData.homepageRootPageTree,
            space: fragmentData.space
        };
        $[0] = fragmentData.currentPage;
        $[1] = fragmentData.homepageRootPageTree;
        $[2] = fragmentData.rootPageTree;
        $[3] = fragmentData.space;
        $[4] = t0;
    } else t0 = $[4];
    const initialData = t0;
    let t1;
    if ($[5] !== error || $[6] !== initialData || $[7] !== props || $[8] !== refetch) {
        t1 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e592d9a1da9bab1$var$PageTreeCoordinatorInner, {
            ...props,
            initialData: initialData,
            error: error,
            refetch: refetch
        });
        $[5] = error;
        $[6] = initialData;
        $[7] = props;
        $[8] = refetch;
        $[9] = t1;
    } else t1 = $[9];
    return t1;
};
const $4e592d9a1da9bab1$var$PageTreeCoordinatorInner = (t0)=>{
    const $ = (0, $bDgLe.c)(59);
    let error;
    let initialData;
    let props;
    let refetch;
    if ($[0] !== t0) {
        ({ initialData: initialData, error: error, refetch: refetch, ...props } = t0);
        $[0] = t0;
        $[1] = error;
        $[2] = initialData;
        $[3] = props;
        $[4] = refetch;
    } else {
        error = $[1];
        initialData = $[2];
        props = $[3];
        refetch = $[4];
    }
    const [t1] = (0, $ep3mz.usePageState)();
    const { contentId: selectedPageId } = t1;
    const derrivedCurrentPage = props.detached ? props.currentPageId : selectedPageId;
    let t2;
    if ($[5] !== refetch) {
        t2 = ()=>{
            if (refetch) refetch();
        };
        $[5] = refetch;
        $[6] = t2;
    } else t2 = $[6];
    const handleRetry = t2;
    if (error) {
        let t3;
        if ($[7] !== error || $[8] !== handleRetry) {
            t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e592d9a1da9bab1$var$PageTreeErrorComponentLoader, {
                error: error,
                onRetry: handleRetry
            });
            $[7] = error;
            $[8] = handleRetry;
            $[9] = t3;
        } else t3 = $[9];
        return t3;
    }
    let t3;
    if ($[10] !== props.clearDeleteId || $[11] !== props.currentPageId || $[12] !== props.detached || $[13] !== props.dragPreview || $[14] !== props.expandSpaceHomepage || $[15] !== props.flags || $[16] !== props.forceFetchCurrentPage || $[17] !== props.forceFetchedCallback || $[18] !== props.getIsDraggingItem || $[19] !== props.highlightPages || $[20] !== props.isCreateContentRoute || $[21] !== props.isDraggable || $[22] !== props.isMovePageTree || $[23] !== props.isPeekingFromBlogs || $[24] !== props.isSuperAdmin || $[25] !== props.moveToParentId || $[26] !== props.onDragStart || $[27] !== props.onInitialLoadComplete || $[28] !== props.onLoadMore || $[29] !== props.onMoveInvalid || $[30] !== props.onPageMove || $[31] !== props.optimisticDeleteId || $[32] !== props.pageTreeStateUpdatesContainer || $[33] !== props.renderItem || $[34] !== props.renderResourcedEmoji || $[35] !== props.setContentTreeSize || $[36] !== props.setIsDraggingItem || $[37] !== props.setIsPageTreeEmpty || $[38] !== props.setIsPageTreeLoading || $[39] !== props.setOpenQuickActionsId || $[40] !== props.spaceKey || $[41] !== props.statuses || $[42] !== props.syntheticItem || $[43] !== props.syntheticItemIsDraft || $[44] !== selectedPageId) {
        t3 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement($4e592d9a1da9bab1$export$9121ae6cff2a2b9f, {
            currentPageId: props.currentPageId,
            isPeekingFromBlogs: props.isPeekingFromBlogs,
            isSuperAdmin: props.isSuperAdmin,
            spaceKey: props.spaceKey,
            statuses: props.statuses,
            setIsPageTreeLoading: props.setIsPageTreeLoading,
            expandSpaceHomepage: props.expandSpaceHomepage,
            onInitialLoadComplete: props.onInitialLoadComplete,
            onLoadMore: props.onLoadMore,
            onDragStart: props.onDragStart,
            onPageMove: props.onPageMove,
            onMoveInvalid: props.onMoveInvalid,
            renderItem: props.renderItem,
            isDraggable: props.isDraggable,
            syntheticItem: props.syntheticItem,
            detached: props.detached,
            syntheticItemIsDraft: props.syntheticItemIsDraft,
            forceFetchCurrentPage: props.forceFetchCurrentPage,
            forceFetchedCallback: props.forceFetchedCallback,
            optimisticDeleteId: props.optimisticDeleteId,
            clearDeleteId: props.clearDeleteId,
            highlightPages: props.highlightPages,
            getIsDraggingItem: props.getIsDraggingItem,
            setIsDraggingItem: props.setIsDraggingItem,
            setOpenQuickActionsId: props.setOpenQuickActionsId,
            dragPreview: props.dragPreview,
            renderResourcedEmoji: props.renderResourcedEmoji,
            setContentTreeSize: props.setContentTreeSize,
            setIsPageTreeEmpty: props.setIsPageTreeEmpty,
            selectedPageId: selectedPageId,
            isMovePageTree: props.isMovePageTree,
            moveToParentId: props.moveToParentId,
            pageTreeStateUpdatesContainer: props.pageTreeStateUpdatesContainer,
            isCreateContentRoute: props.isCreateContentRoute,
            flags: props.flags
        });
        $[10] = props.clearDeleteId;
        $[11] = props.currentPageId;
        $[12] = props.detached;
        $[13] = props.dragPreview;
        $[14] = props.expandSpaceHomepage;
        $[15] = props.flags;
        $[16] = props.forceFetchCurrentPage;
        $[17] = props.forceFetchedCallback;
        $[18] = props.getIsDraggingItem;
        $[19] = props.highlightPages;
        $[20] = props.isCreateContentRoute;
        $[21] = props.isDraggable;
        $[22] = props.isMovePageTree;
        $[23] = props.isPeekingFromBlogs;
        $[24] = props.isSuperAdmin;
        $[25] = props.moveToParentId;
        $[26] = props.onDragStart;
        $[27] = props.onInitialLoadComplete;
        $[28] = props.onLoadMore;
        $[29] = props.onMoveInvalid;
        $[30] = props.onPageMove;
        $[31] = props.optimisticDeleteId;
        $[32] = props.pageTreeStateUpdatesContainer;
        $[33] = props.renderItem;
        $[34] = props.renderResourcedEmoji;
        $[35] = props.setContentTreeSize;
        $[36] = props.setIsDraggingItem;
        $[37] = props.setIsPageTreeEmpty;
        $[38] = props.setIsPageTreeLoading;
        $[39] = props.setOpenQuickActionsId;
        $[40] = props.spaceKey;
        $[41] = props.statuses;
        $[42] = props.syntheticItem;
        $[43] = props.syntheticItemIsDraft;
        $[44] = selectedPageId;
        $[45] = t3;
    } else t3 = $[45];
    let t4;
    if ($[46] !== derrivedCurrentPage || $[47] !== initialData || $[48] !== props.detached || $[49] !== props.highlightPages || $[50] !== props.isPeekingFromBlogs || $[51] !== props.onCollapse || $[52] !== props.onExpand || $[53] !== props.onLoadError || $[54] !== props.spaceKey || $[55] !== props.syntheticItem || $[56] !== props.syntheticItemIsDraft || $[57] !== t3) {
        t4 = /*#__PURE__*/ (0, (/*@__PURE__*/$parcel$interopDefault($cozmU))).createElement((0, $jGj7w.PageTreeStateContainer), {
            currentPageId: derrivedCurrentPage,
            highlightPages: props.highlightPages,
            initialData: initialData,
            spaceKey: props.spaceKey,
            syntheticItem: props.syntheticItem,
            onExpand: props.onExpand,
            onCollapse: props.onCollapse,
            onLoadError: props.onLoadError,
            syntheticItemIsDraft: props.syntheticItemIsDraft,
            isPeekingFromBlogs: props.isPeekingFromBlogs,
            detached: props.detached
        }, t3);
        $[46] = derrivedCurrentPage;
        $[47] = initialData;
        $[48] = props.detached;
        $[49] = props.highlightPages;
        $[50] = props.isPeekingFromBlogs;
        $[51] = props.onCollapse;
        $[52] = props.onExpand;
        $[53] = props.onLoadError;
        $[54] = props.spaceKey;
        $[55] = props.syntheticItem;
        $[56] = props.syntheticItemIsDraft;
        $[57] = t3;
        $[58] = t4;
    } else t4 = $[58];
    return t4;
};
const $4e592d9a1da9bab1$var$i18nReorder = (0, $kSwu1.defineMessages)({
    reorderAnnouncement: {
        id: "page-tree.keyboard-reorder.announcement",
        defaultMessage: "{title} moved to position {position} of {total}"
    },
    moveOutAnnouncement: {
        id: "page-tree.keyboard-reorder.move-out-announcement",
        defaultMessage: "{title} moved out one level"
    },
    moveIntoAnnouncement: {
        id: "page-tree.keyboard-reorder.move-into-announcement",
        defaultMessage: "{title} moved under {target}"
    }
});
module.exports["PageTreeCoordinator"] = $4e592d9a1da9bab1$export$a6bc5c2967fe3170;

});

parcelRegister("4Wdup", function(module, exports) {

let $39870ae9cd1b8cca$var$load = (parcelRequire("6dFT0"))(5);
module.exports = $39870ae9cd1b8cca$var$load("ewwba").then(()=>parcelRequire('2gSlC'));

});

parcelRegister("2fuD6", function(module, exports) {

let $1a34bde25079a355$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $1a34bde25079a355$var$load("fcJcK"),
    $1a34bde25079a355$var$load("6wr18"),
    $1a34bde25079a355$var$load("ffEVr"),
    $1a34bde25079a355$var$load("7EorR"),
    $1a34bde25079a355$var$load("ea3NB"),
    $1a34bde25079a355$var$load("dhqJV")
]).then(()=>parcelRequire('fzbVm'));

});

parcelRegister("5EOno", function(module, exports) {

let $41e7c3d800a7a3b6$var$load = (parcelRequire("6dFT0"))(5);
module.exports = Promise.all([
    $41e7c3d800a7a3b6$var$load("6wr18"),
    $41e7c3d800a7a3b6$var$load("ffEVr"),
    $41e7c3d800a7a3b6$var$load("Wowvf"),
    $41e7c3d800a7a3b6$var$load("hhss7"),
    $41e7c3d800a7a3b6$var$load("3L1uC")
]).then(()=>parcelRequire('akCro'));

});

parcelRegister("6CrbN", function(module, exports) {

var $cozmU = parcelRequire("cozmU");

// Using a getter rather than a value so that setting
// `isDragging` does not cause the whole tree to re-render
function $df238d2ddc4e210d$var$create() {
    let isDragging = false;
    return {
        setIsDraggingItem (value) {
            isDragging = value;
        },
        getIsDraggingItem () {
            return isDragging;
        }
    };
}
function $df238d2ddc4e210d$export$db01cee314a3998b() {
    const [api] = (0, $cozmU.useState)($df238d2ddc4e210d$var$create);
    return api;
}
module.exports["useIsDragging"] = $df238d2ddc4e210d$export$db01cee314a3998b;

});

parcelRegister("bP5d8", function(module, exports) {

var $kSwu1 = parcelRequire("kSwu1");

const $f7c88c77c90ab79e$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    flagErrorTitle: {
        id: "page-tree.dragndrop.failed.title",
        defaultMessage: "Something went wrong"
    },
    flagErrorDescription: {
        id: "page-tree.dragndrop.failed.description",
        defaultMessage: "Refresh and try again. If this keeps happening, contact your space administrator."
    },
    paginateErrorDescription: {
        id: "page-tree.paginate-content.failed.description",
        defaultMessage: "We encountered a network error while loading more content. Refresh and try again. If this keeps happening, contact your space administrator."
    },
    flagMovePagePermissionErrorTitle: {
        id: "page-tree.dragndrop.permissions.error.title",
        defaultMessage: "You can\u2019t move this content"
    },
    flagMovePagePermissionErrorDescription: {
        id: "page-tree.dragndrop.permissions.error.decription",
        defaultMessage: "You don\u2019t have permission to move this restricted content. Contact your space administrator."
    },
    flagUndoTitle: {
        id: "page-tree.dragndrop.undo.title",
        defaultMessage: "Moved \u201C{pageTitle}\u201D"
    },
    flagUndoUntitled: {
        id: "page-tree.dragndrop.undo.untitled",
        defaultMessage: "Moved \u201CUntitled\u201D"
    },
    flagUndoAction: {
        id: "page-tree.dragndrop.undo.action",
        defaultMessage: "Undo"
    },
    flagLargePageTreeTitle: {
        id: "page-tree.dragndrop.lpt.title",
        defaultMessage: "We can\u2019t move this content"
    },
    flagLargePageTreeDescription: {
        id: "page-tree.dragndrop.lpt.description",
        defaultMessage: "Drag and drop is not available for a list of 500 or more. Refresh and try again without expanding the content tree."
    },
    flagLargePageTreeSettingsAction: {
        id: "page-tree.dragndrop.lpt.settings.action",
        defaultMessage: "Go to space settings"
    },
    flagLargePageTreeRefreshAction: {
        id: "page-tree.dragndrop.lpt.refresh.action",
        defaultMessage: "Refresh page"
    },
    flagInvalidMoveDraftTitle: {
        id: "page-tree.dragndrop.invalid-move-draft.title",
        defaultMessage: "You can\u2019t move content under a draft"
    },
    flagInvalidMoveDraftDescription: {
        id: "page-tree.dragndrop.invalid-move-draft.description",
        defaultMessage: "Publish the draft to move content here."
    },
    flagInvalidMoveManagedFolderTitle: {
        id: "page-tree.dragndrop.invalid-move-managed-folder.title",
        defaultMessage: "You can\u2019t move this content"
    },
    flagInvalidMoveManagedFolderDescription: {
        id: "page-tree.dragndrop.invalid-move-managed-folder.description",
        defaultMessage: "This folder is managed and cannot be changed."
    },
    untitledDraftText: {
        id: "page-tree.untitled-draft",
        defaultMessage: "Untitled"
    }
});
module.exports["i18n"] = $f7c88c77c90ab79e$export$a7357cdd1f0b0168;

});

parcelRegister("c4LIS", function(module, exports) {

var $bDgLe = parcelRequire("bDgLe");


var $dJIaO = parcelRequire("dJIaO");


var $bwL2u = parcelRequire("bwL2u");


var $jGj7w = parcelRequire("jGj7w");

const $a5a7295fb74e8ae6$export$bc80720d71558aaa = ()=>{
    const $ = (0, $bDgLe.c)(8);
    const [t0, t1] = (0, $bwL2u.useContentTreeSelection)();
    const { selectedContent: selectedContent } = t0;
    const { selectNestedContent: selectNestedContent } = t1;
    const { getState: getState } = (0, $jGj7w.usePageTreeActions)();
    let t2;
    if ($[0] !== getState) {
        t2 = (itemId)=>{
            const { pages: pages, rootId: rootId } = getState();
            const ancestorContentIds = new Set();
            const getIds = (currItem)=>{
                const parentId = currItem.parentId;
                if (parentId && parentId != rootId) {
                    ancestorContentIds.add(currItem.parentId);
                    getIds(pages[parentId]);
                }
            };
            getIds(pages[itemId]);
            return ancestorContentIds;
        };
        $[0] = getState;
        $[1] = t2;
    } else t2 = $[1];
    const getAncestorIds = t2;
    const updateDescendantCount = (0, $dJIaO.useSelectionCount)();
    let t3;
    if ($[2] !== getAncestorIds || $[3] !== getState || $[4] !== selectNestedContent || $[5] !== selectedContent || $[6] !== updateDescendantCount) {
        t3 = (itemId_0, isExplicitlySelected, flags)=>{
            const { pages: pages_0 } = getState();
            const descendants = [];
            const isPreviouslySelected = itemId_0 in selectedContent;
            const isOnExpandOnSelectedParent = isPreviouslySelected && !isExplicitlySelected;
            const pageTreeItem = getState().pages[itemId_0];
            let countToRemove = 0;
            const traverse = (currItem_0, isCountRemoved)=>{
                let currIsCountRemoved = isCountRemoved;
                if (currItem_0 && currItem_0.id != pageTreeItem.id && currItem_0.id in selectedContent && !currIsCountRemoved) {
                    countToRemove = countToRemove + (selectedContent[currItem_0.id]?.selectedDescendantCount + 1);
                    countToRemove;
                    currIsCountRemoved = true;
                }
                descendants.push({
                    id: currItem_0.id,
                    parentId: currItem_0.parentId ?? undefined
                });
                const children = currItem_0.children || [];
                for (const childId of children){
                    const child = pages_0[childId];
                    if (child && child.data.status != "DRAFT" && child.data.subtype != "managed") traverse(child, currIsCountRemoved);
                }
            };
            if (!isPreviouslySelected && isExplicitlySelected || isOnExpandOnSelectedParent) {
                traverse(pageTreeItem, false);
                selectNestedContent(descendants);
                updateDescendantCount(pageTreeItem, [
                    ...getAncestorIds(itemId_0)
                ], [
                    pageTreeItem.id,
                    ...descendants.map($a5a7295fb74e8ae6$var$_temp)
                ], isExplicitlySelected, countToRemove, flags);
            }
        };
        $[2] = getAncestorIds;
        $[3] = getState;
        $[4] = selectNestedContent;
        $[5] = selectedContent;
        $[6] = updateDescendantCount;
        $[7] = t3;
    } else t3 = $[7];
    const selectContentAndDescendants = t3;
    return selectContentAndDescendants;
};
function $a5a7295fb74e8ae6$var$_temp(item) {
    return item.id;
}
module.exports["useNestedSelect"] = $a5a7295fb74e8ae6$export$bc80720d71558aaa;

});

parcelRegister("dJIaO", function(module, exports) {

var $6sfpn = parcelRequire("6sfpn");


var $cozmU = parcelRequire("cozmU");


var $kSwu1 = parcelRequire("kSwu1");


var $7Sm4c = parcelRequire("7Sm4c");


var $3IBnw = parcelRequire("3IBnw");


var $5ZqQS = parcelRequire("5ZqQS");


var $bwL2u = parcelRequire("bwL2u");


var $lvOsp = parcelRequire("lvOsp");

const $78f326507364f46a$var$ContentMetadataQuery = (0, $6sfpn.default);
const $78f326507364f46a$export$8e70fdefe25376ca = ()=>{
    const { updateSelectedDescendantsCount: updateSelectedDescendantsCount, updateTotalCount: updateTotalCount, addLoadingDescendant: addLoadingDescendant, removeLoadingDescendant: removeLoadingDescendant, incrementAncestors: incrementAncestors, updateParent: updateParent, getState: getState } = (0, $bwL2u.useContentTreeSelectionActions)();
    const intl = (0, $kSwu1.useIntl)();
    const latestArgsRef = (0, $cozmU.useRef)(null);
    const [fetchMetadata] = (0, $lvOsp.useLazyQueryInterop)($78f326507364f46a$var$ContentMetadataQuery, {
        fetchPolicy: 'network-only',
        onCompleted: (data)=>{
            if (latestArgsRef.current) {
                const nodes = [
                    ...data?.pageContent?.nodes ?? [],
                    ...data?.whiteboardContent?.nodes ?? [],
                    ...data?.databaseContent?.nodes ?? [],
                    ...data?.embedContent?.nodes ?? [],
                    ...data?.folderContent?.nodes ?? [],
                    ...data?.slideContent?.nodes ?? []
                ];
                const { item: item, ancestorIds: ancestorIds, isExplicitlySelected: isExplicitlySelected, countToRemove: countToRemove } = latestArgsRef.current;
                const itemId = item.id;
                const { selectedContent: selectedContent } = getState();
                const isCurrentlySelected = !!selectedContent[itemId];
                const isParentSelected = item.parentId && item.parentId in selectedContent;
                let selectedCount = 0;
                nodes.forEach((node)=>{
                    if (!node || !node.id) return;
                    if (node.id === itemId) selectedCount = node.visibleDescendantsCount;
                    if (isCurrentlySelected) updateSelectedDescendantsCount(node.id, node.visibleDescendantsCount);
                    removeLoadingDescendant(node.id);
                });
                // Only update counts if content is explicitly selected.
                if (isExplicitlySelected && isCurrentlySelected) {
                    if (isParentSelected && typeof item.parentId === 'string') // If the parent is selected, we need to update the excludedChildren array.
                    updateParent(itemId, item.parentId);
                    incrementAncestors([
                        ...ancestorIds
                    ], selectedCount, countToRemove);
                    updateTotalCount(selectedCount + 1 - countToRemove); // +1 for the content itself
                } else if (countToRemove > 0) // Remove count that have been previously addressed.
                updateTotalCount(-countToRemove);
            }
        },
        onError: (err)=>{
            (0, $7Sm4c.markErrorAsHandled)(err);
            (0, $5ZqQS.getMonitoringClient)().submitError(err, {
                attribution: (0, $3IBnw.Attribution).DISCO
            });
            latestArgsRef.current?.contentForCount.forEach((id)=>removeLoadingDescendant(id));
            if (latestArgsRef.current) latestArgsRef.current.flags.showErrorFlag({
                title: intl.formatMessage($78f326507364f46a$export$a7357cdd1f0b0168.flagErrorTitle),
                description: intl.formatMessage($78f326507364f46a$export$a7357cdd1f0b0168.flagErrorDescription)
            });
        },
        __callerPackage__: "content-tree-actions"
    });
    return (0, $cozmU.useCallback)((item, ancestorIds, contentForCount, isExplicitlySelected, countToRemove, flags)=>{
        latestArgsRef.current = {
            item: item,
            ancestorIds: ancestorIds,
            isExplicitlySelected: isExplicitlySelected,
            countToRemove: countToRemove,
            flags: flags,
            contentForCount: contentForCount
        };
        contentForCount.forEach((id)=>addLoadingDescendant(id));
        fetchMetadata({
            variables: {
                contentIds: contentForCount
            }
        });
    }, [
        addLoadingDescendant,
        fetchMetadata
    ]);
};
const $78f326507364f46a$export$a7357cdd1f0b0168 = (0, $kSwu1.defineMessages)({
    flagErrorTitle: {
        id: "content-tree-actions.selection-count.failed.title",
        defaultMessage: "Something went wrong"
    },
    flagErrorDescription: {
        id: "content-tree-actions.selection-count.failed.description",
        defaultMessage: "Refresh and try again. If this keeps happening, contact your space administrator."
    }
});
module.exports["useSelectionCount"] = $78f326507364f46a$export$8e70fdefe25376ca;

});

parcelRegister("6sfpn", function(module, exports) {
/**
 * @generated SignedSource<<62f5c12aa2df1558e2ea3c91b9e4a0e3>>
 * @relayHash 890f87f75750a8a9dc513a5a1a510c2d
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */ /* tslint:disable */ /* eslint-disable */ // @ts-nocheck
// @relayRequestID 04a60de09cb156e78d1beccbc8a11e46210450dc67afe6d6f671a7d8e6330a09
const $871f673e8fbdbffe$var$node = function() {
    var v0 = [
        {
            "defaultValue": null,
            "kind": "LocalArgument",
            "name": "contentIds"
        }
    ], v1 = {
        "kind": "Variable",
        "name": "ids",
        "variableName": "contentIds"
    }, v2 = [
        {
            "concreteType": "Content",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
                {
                    "kind": "ScalarField",
                    "name": "id"
                },
                {
                    "kind": "ScalarField",
                    "name": "visibleDescendantsCount"
                }
            ]
        }
    ], v3 = [
        {
            "alias": "pageContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "page"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "whiteboardContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "whiteboard"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "databaseContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "database"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "embedContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "embed"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "folderContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "folder"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        },
        {
            "alias": "slideContent",
            "args": [
                v1 /*: any*/ ,
                {
                    "kind": "Literal",
                    "name": "type",
                    "value": "slide"
                }
            ],
            "concreteType": "PaginatedContentListWithChild",
            "kind": "LinkedField",
            "name": "content",
            "plural": false,
            "selections": v2 /*: any*/ 
        }
    ];
    return {
        "fragment": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Fragment",
            "name": "useSelectionCountContentMetadataQuery",
            "selections": v3 /*: any*/ ,
            "type": "Query"
        },
        "kind": "Request",
        "operation": {
            "argumentDefinitions": v0 /*: any*/ ,
            "kind": "Operation",
            "name": "useSelectionCountContentMetadataQuery",
            "selections": v3 /*: any*/ 
        },
        "params": {
            "cacheID": "890f87f75750a8a9dc513a5a1a510c2d",
            "id": "04a60de09cb156e78d1beccbc8a11e46210450dc67afe6d6f671a7d8e6330a09",
            "metadata": {},
            "name": "useSelectionCountContentMetadataQuery",
            "operationKind": "query",
            "text": "query useSelectionCountContentMetadataQuery($contentIds:[ID!]!){pageContent:content(ids:$contentIds,type:\"page\"){nodes{id,visibleDescendantsCount}},whiteboardContent:content(ids:$contentIds,type:\"whiteboard\"){nodes{id,visibleDescendantsCount}},databaseContent:content(ids:$contentIds,type:\"database\"){nodes{id,visibleDescendantsCount}},embedContent:content(ids:$contentIds,type:\"embed\"){nodes{id,visibleDescendantsCount}},folderContent:content(ids:$contentIds,type:\"folder\"){nodes{id,visibleDescendantsCount}},slideContent:content(ids:$contentIds,type:\"slide\"){nodes{id,visibleDescendantsCount}}}"
        }
    };
}();
$871f673e8fbdbffe$var$node.hash = "df9fa24dda7ef9a6331f01e6b1156f83";
var $871f673e8fbdbffe$export$2e2bcd8739ae039 = $871f673e8fbdbffe$var$node;
module.exports["default"] = $871f673e8fbdbffe$export$2e2bcd8739ae039;

});


//# sourceMappingURL=MovePageDialog.1cdd6620.js.map
